/**
 * Avast Module Definition
 * @version 1.1.0
 * @author Jiri Duchon <duchon@avast.com>
 * @copyright AVAST Software s.r.o.
 */
var avm = (function() {
	'use strict';
	var toString = Object.prototype.toString,
		modules = {};
	return {
		/**
		 * Define module
		 * @param {string} namespace
		 * @param {*} value
		 * @returns {*}
		 */
		define: function(namespace, value) {
			if (typeof namespace === 'string' && typeof value !== 'undefined') {
				var spaces = namespace.split('.'),
					spacesLength = spaces.length,
					spacesLast = spacesLength - 1,
					spacesRoot = modules,
					space;
				for (var i = 0; i < spacesLength; i++) {
					space = spaces[i];
					if (i < spacesLast && (toString.call(spacesRoot[space]) === '[object Object]' && spacesRoot[space] !== null || !(space in spacesRoot))) {
						spacesRoot = spacesRoot[space] = spacesRoot[space] || {};
					} else if (i === spacesLast && !(space in spacesRoot)) {
						spacesRoot = spacesRoot[space] = value;
					} else {
						throw new Error('Module ' + namespace + ' already exists');
					}
				}
				return spacesRoot;
			} else {
				throw new Error('Invalid method arguments');
			}
		},
		/**
		 * Require module
		 * @param {string} namespace
		 * @param {boolean} [required=true]
		 * @returns {*}
		 */
		require: function(namespace, required) {
			required = typeof required === 'undefined' ? true : required;
			if (typeof namespace === 'string' && typeof required === 'boolean') {
				var spaces = namespace.split('.'),
					spacesLength = spaces.length,
					spacesRoot = modules,
					space;
				for (var i = 0; i < spacesLength; i++) {
					space = spaces[i];
					if (toString.call(spacesRoot) === '[object Object]' && spacesRoot !== null && space in spacesRoot) {
						spacesRoot = spacesRoot[space];
					} else if (required) {
						throw new Error('Module ' + namespace + ' does not exist');
					} else {
						if (typeof console === 'object' && typeof console.warn === 'function') {
							console.warn('Module ' + namespace + ' does not exist');
						}
						return;
					}
				}
				return spacesRoot;
			} else {
				throw new Error('Invalid method arguments');
			}
		}
	};
})();







/**
 * Avast superclass
 * @author Milan Adam, Ales Gabriel
 * @copyright Avast Software s.r.o &copy;2011-15
 */
if (typeof jQuery !== 'undefined') {
	if (typeof avm === 'object' && typeof avm.define === 'function') {
		avm.define('jquery', jQuery);
	}
}


/**
 * Encode Base64 safely (supports IE10+ or IE6+ with base64 polyfill)
 * @version 1.1.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.base64.encode
 * @param {*} decodedObject
 * @returns {string|null}
 */
avm.define('avast.base64.encode', function(decodedObject) {
	'use strict';
	if (typeof decodedObject !== 'undefined') {
		try {
			return btoa(JSON.stringify(decodedObject)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
		} catch (error) {
			if (typeof console === 'object' && console && typeof console.warn === 'function') {
				console.warn(error);
			}
			return null;
		}
	} else {
		throw new Error('Invalid method arguments to avast.base64.encode');
	}
});

/**
 * Check if cookie support is enabled
 * @version 1.0.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.storage.isCookieEnabled
 */
avm.define('avast.storage.isCookieEnabled', (function() {
	'use strict';
	if (navigator.cookieEnabled) {
		return true;
	} else {
		var key = 'isCookieEnabled';
		document.cookie = key + '=1';
		if (document.cookie.indexOf(key + '=1') !== -1) {
			document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT';
			return true;
		} else {
			return false;
		}
	}
})());

/**
 * Check if storage support is enabled
 * @version 1.1.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.storage.isStorageEnabled
 */
avm.define('avast.storage.isStorageEnabled', (function() {
	'use strict';
	try {
		if (typeof sessionStorage === 'object' && sessionStorage && typeof localStorage === 'object' && localStorage) {
			var key = 'isStorageEnabled';
			sessionStorage.setItem(key, '1');
			sessionStorage.removeItem(key);
			localStorage.setItem(key, '1');
			localStorage.removeItem(key);
			return true;
		}
	} catch (error) {
		if (typeof console === 'object' && console && typeof console.warn === 'function') {
			console.warn(error);
		}
	}
	return false;
})());

/**
 * Serialize URL parameters from object to string
 * @version 1.1.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.url.serialize
 * @param {Object} urlObject
 * @returns {string}
 */
avm.define('avast.url.serialize', function(urlObject) {
	'use strict';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	if (typeof urlObject === 'object' && urlObject) {
		var urlString = '';
		for (var key in urlObject) {
			if (hasOwnProperty.call(urlObject, key)) {
				if (urlString.length) {
					urlString += '&';
				}
				urlString += encodeURIComponent(key) + '=' + encodeURIComponent(urlObject[key]);
			}
		}
		return urlString;
	} else {
		throw new Error('Invalid method arguments to avast.url.serialize');
	}
});

/**
* Push data to GTM dataLayer. 
* @version 1.0.0
* @author Ales Gabriel <gabriel@avast.com>
* @module avast.web.tracker
* @desc GTM dataLayer helper. Primary centralize various window.datalayer pushes.
* @requires jquery
*/
avm.define('avast.web.tracker', (function () {
	'use strict';

	var $ = avm.require('jquery');
	
	window.dataLayer = window.dataLayer || []; 

	/*
	 *	Config events and handlers.
	 *	If tracked via GTM, only datalayer.push should be required.
	 */

	// Define callbacks for events
	var trackEvents = {
		'chromeOffer': {
			/**
			 * Track banner impression
			 * @return {Integer} Length of datalayer
			 */
			view: function(evt){
				//console.log(evt);
				return window.dataLayer.push({
					'event' : 'chromeOffer', 
					'eventCategory' : 'Chrome',
					'eventAction' : 'Chrome Offer',
					'eventLabel' : 'View'
				});
			},
			/**
			 * Track clicking on download Chrome button
			 * @param  {Object} evt Event object
			 * @return {Integer}  Length of dataLayer
			 */
			click: function(evt){
				//console.log(evt);
				return window.dataLayer.push({
					'event' : 'chromeOffer', 
					'eventCategory' : 'Chrome',
					'eventAction' : 'Chrome Offer',
					'eventLabel' : 'Click'
				});
			}
		},
		/**
		 * Password checker on first char - only once per visit 
		 * @param  {Object} evt Event object
		 * @return {Int}     Length of dataLayer array
		 */
		'passwordCheck' : (function(){
			var called = 0;

			return function(evt){
				if(!called){
					called = 1;
					//console.log('passwordCheck event: %o', evt);
					return window.dataLayer.push({
						'event' : 'passwordCheck', // First char filled
					});
				}
			};
		})()
	};

	// Bind events
	$(document).on('passwordCheck.avast', function(){
		methods.track('passwordCheck');
	});

	///////////////////////////////////////////////////////////////////////////////////
	
	/*
	 * Methods
	 */	
	var methods = {
		/**
		 * Track event 
		 * @param  {String}   evtName  Event name. Looking for callback. Dot notation allowed.  
		 * @param  {Object}   [evtObj]  Event object
		 * @param  {Function} [callback] Callback handler. If not defined in param, lookup on module internal callbacks storage is made. 
		 */
		track: function(evtName, evtObj, callback){
			var handler = callback || trackEvents,
				spaces = (typeof evtName === 'string') ? evtName.split('.') : null,
				args = evtObj ? [evtObj] : [], // IE 8 with no arguments 
				space,
				toString = Object.prototype.toString;
			
			// TODO: Do not step into object cycles if callback is only plain function by default
			if ((toString.call(handler) === '[object Function]' || toString.call(handler) === '[object Object]') && spaces && spaces.length > 0){
				for (var i = 0; i < spaces.length; i++) {
					space = spaces[i];
					if (handler !== null && space in handler) {
						handler = handler[space];
					
						// Function founded earlier than in last cycle considered as incorrect.
						// So properties defined on functions are not allowed.
						if (toString.call(handler) === '[object Function]' && i !== (spaces.length - 1)) {						
							handler = null;
						}
					}
				}
			}

			if (typeof handler === 'function') {
				return handler.apply(this, args); // FIXME: Change to call.
			}
		}
	};


	// Export methods
	return methods;
})());

/**
 * Unserialize URL parameters from string to object
 * @version 1.2.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.url.unserialize
 * @param {string} [urlString]
 * @returns {Object}
 */
avm.define('avast.url.unserialize', function(urlString) {
	'use strict';
	urlString = typeof urlString === 'undefined' ? location.search : urlString;
	if (typeof urlString === 'string') {
		var urlObject = {},
			urlQuery = urlString.replace(/#.*|.*\?/g, '');
		if (urlQuery.length) {
			var urlParameters = urlQuery.split('&'),
				urlParametersLength = urlParameters.length,
				urlParameter = [];
			for (var i = 0; i < urlParametersLength; i++) {
				urlParameter = urlParameters[i].split('=');
				urlObject[decodeURIComponent(urlParameter[0])] = decodeURIComponent(urlParameter[1] || '');
			}
		}
		return urlObject;
	} else {
		throw new Error('Invalid method arguments to avast.url.unserialize');
	}
});

// Using toISOString()
// This method was standardized in ECMA-262 5th edition.
// Engines which have not been updated to support this method can work around the absence of this method using the following shim:

if (!Date.prototype.toISOString) {
    (function () {

        function pad(number) {
            if (number < 10) {
                return '0' + number;
            }
            return number;
        }

        Date.prototype.toISOString = function () {
            return this.getUTCFullYear() +
                    '-' + pad(this.getUTCMonth() + 1) +
                    '-' + pad(this.getUTCDate()) +
                    'T' + pad(this.getUTCHours()) +
                    ':' + pad(this.getUTCMinutes()) +
                    ':' + pad(this.getUTCSeconds()) +
                    '.' + (this.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) +
                    'Z';
        };

    }());
}

// IE8 ISO Format
function dateFromISO8601(isoDateString) {
    if (typeof isoDateString !== "undefined") {
        var parts = isoDateString.match(/\d+/g);
        var isoTime = Date.UTC(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]);
        var isoDate = new Date(isoTime);

        return isoDate;
    }
    return new Date();
}

/**
 * Search in json by key and value
 * @param {Array} array
 * @param {String} key
 * @param {String} valuetofind
 * @returns {Array|Number}
 * @author Michal Pribila
 */
function searchArray(array, key, valuetofind) {
    for (i = 0; i < array.length; i++) {
        if (array[i][key] === valuetofind) {
            return array[i];
        }
    }
    return -1;
}


var avg = {};
avg.sizes = {};
avg.sizes['xs'] = [0, 479];
avg.sizes['sm'] = [480, 767];
avg.sizes['md'] = [768, 991];
avg.sizes['lg'] = [992, 3000];

if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function(elt /*, from*/ ) {
        var len = this.length >>> 0;

        var from = Number(arguments[1]) || 0;
        from = (from < 0) ? Math.ceil(from) : Math.floor(from);
        if (from < 0)
            from += len;

        for (; from < len; from++) {
            if (from in this &&
                this[from] === elt)
                return from;
        }
        return -1;
    };
}

if (!('keys' in Object)) Object.keys = function(o) {
    if (typeof o != 'object' || o === null) {
        throw new TypeError('Object.keys called on a non-object or null');
    }
    var k = [];
    for (var p in o)
        if (o.hasOwnProperty(p)) k.push(p);
    return k;
}

function getOS() {
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;

    // system
    var os = "unknown";
    var clientStrings = [
        {s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/},
        {s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/},
        {s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/},
        {s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/},
        {s: 'Windows Vista', r: /Windows NT 6.0/},
        {s: 'Windows Server 2003', r: /Windows NT 5.2/},
        {s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/},
        {s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/},
        {s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/},
        {s: 'Windows 98', r: /(Windows 98|Win98)/},
        {s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/},
        {s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
        {s: 'Windows CE', r: /Windows CE/},
        {s: 'Windows 3.11', r: /Win16/},
        {s: 'Android', r: /Android/},
        {s: 'Open BSD', r: /OpenBSD/},
        {s: 'Sun OS', r: /SunOS/},
        {s: 'Linux', r: /(Linux|X11)/},
        {s: 'iOS', r: /(iPhone|iPad|iPod)/},
        {s: 'Mac OS X', r: /Mac OS X/},
        {s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
        {s: 'QNX', r: /QNX/},
        {s: 'UNIX', r: /UNIX/},
        {s: 'BeOS', r: /BeOS/},
        {s: 'OS/2', r: /OS\/2/},
        {s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
    ];
    for (var id in clientStrings) {
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }

    var osVersion = "unknown";

    if (/Windows/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = 'Windows';
    }

    switch (os) {
        case 'Mac OS X':
            osVersion = /Mac OS X (10[\.\_\d]+)/.exec(nAgt)[1];
            break;

        case 'Android':
            osVersion = /Android ([\.\_\d]+)/.exec(nAgt)[1];
            break;

        case 'iOS':
            osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
            osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
            break;
    }
    return os;
}

function getBrowser(ua) {
    // If an UA is not provided, default to the current browser UA.
    if (ua === undefined) {
        ua = window.navigator.userAgent;
    }
    ua = ua.toLowerCase();

    var match = /(edge)\/([\w.]+)/.exec(ua) ||
            /(opr)[\/]([\w.]+)/.exec(ua) ||
            /(chrome)[ \/]([\w.]+)/.exec(ua) ||
            /(iemobile)[\/]([\w.]+)/.exec(ua) ||
            /(version)(applewebkit)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(ua) ||
            /(webkit)[ \/]([\w.]+).*(version)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(ua) ||
            /(webkit)[ \/]([\w.]+)/.exec(ua) ||
            /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
            /(msie) ([\w.]+)/.exec(ua) ||
            ua.indexOf("trident") >= 0 && /(rv)(?::| )([\w.]+)/.exec(ua) ||
            ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) ||
            [];

    var platform_match = /(ipad)/.exec(ua) ||
            /(ipod)/.exec(ua) ||
            /(windows phone)/.exec(ua) ||
            /(iphone)/.exec(ua) ||
            /(kindle)/.exec(ua) ||
            /(silk)/.exec(ua) ||
            /(android)/.exec(ua) ||
            /(win)/.exec(ua) ||
            /(mac)/.exec(ua) ||
            /(linux)/.exec(ua) ||
            /(cros)/.exec(ua) ||
            /(playbook)/.exec(ua) ||
            /(bb)/.exec(ua) ||
            /(blackberry)/.exec(ua) ||
            [];

    var browser = {},
            matched = {
                browser: match[ 5 ] || match[ 3 ] || match[ 1 ] || "",
                version: match[ 2 ] || match[ 4 ] || "0",
                versionNumber: match[ 4 ] || match[ 2 ] || "0",
                platform: platform_match[ 0 ] || ""
            };

    if (matched.browser) {
        browser[ matched.browser ] = true;
        browser.version = matched.version;
        browser.version_rounded = parseInt(matched.versionNumber, 10);
    }

    if (matched.platform) {
        browser[ matched.platform ] = true;
    }

    // These are all considered mobile platforms, meaning they run a mobile browser
    if (browser.android || browser.bb || browser.blackberry || browser.ipad || browser.iphone ||
            browser.ipod || browser.kindle || browser.playbook || browser.silk || browser[ "windows phone" ]) {
        browser.mobile = true;
    }

    // These are all considered desktop platforms, meaning they run a desktop browser
    if (browser.cros || browser.mac || browser.linux || browser.win) {
        browser.desktop = true;
    }

    // Chrome, Opera 15+ and Safari are webkit based browsers
    if (browser.chrome || browser.opr || browser.safari) {
        browser.webkit = true;
    }

    // IE11 has a new token so we will assign it msie to avoid breaking changes
    if (browser.rv || browser.iemobile) {
        var ie = "msie";

        matched.browser = ie;
        browser[ie] = true;
    }

    // Edge is officially known as Microsoft Edge, so rewrite the key to match
    if (browser.edge) {
        delete browser.edge;
        var msedge = "msedge";

        matched.browser = msedge;
        browser[msedge] = true;
    }

    // Blackberry browsers are marked as Safari on BlackBerry
    if (browser.safari && browser.blackberry) {
        var blackberry = "blackberry";

        matched.browser = blackberry;
        browser[blackberry] = true;
    }

    // Playbook browsers are marked as Safari on Playbook
    if (browser.safari && browser.playbook) {
        var playbook = "playbook";

        matched.browser = playbook;
        browser[playbook] = true;
    }

    // BB10 is a newer OS version of BlackBerry
    if (browser.bb) {
        var bb = "blackberry";

        matched.browser = bb;
        browser[bb] = true;
    }

    // Opera 15+ are identified as opr
    if (browser.opr) {
        var opera = "opera";

        matched.browser = opera;
        browser[opera] = true;
    }

    // Stock Android browsers are marked as Safari on Android.
    if (browser.safari && browser.android) {
        var android = "android";

        matched.browser = android;
        browser[android] = true;
    }

    // Kindle browsers are marked as Safari on Kindle
    if (browser.safari && browser.kindle) {
        var kindle = "kindle";

        matched.browser = kindle;
        browser[kindle] = true;
    }

    // Kindle Silk browsers are marked as Safari on Kindle
    if (browser.safari && browser.silk) {
        var silk = "silk";

        matched.browser = silk;
        browser[silk] = true;
    }

    // Rename mozilla to firefox
    if (browser.mozilla) {
        var firefox = "firefox";

        matched.browser = firefox;
        browser[firefox] = true;
    }

    // Assign the name and platform variable
    browser.browser = matched.browser;
    browser.platform = matched.platform;
    return browser;
}

function getAndroidVersion(ua) {
    var ua = ua || navigator.userAgent;
    var match = ua.match(/Android\s([0-9\.]*)/);
    return match ? match[1] : false;
}


function getScrollBarWidth() {
    var scrollDiv = document.createElement('div');
    scrollDiv.className = 'modal-scrollbar-measure';
    $AVG('body').append(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    $AVG('body')[0].removeChild(scrollDiv);
    return scrollbarWidth;
}

function setSizeList(object) {
    if (object['xs'] === true) {
        if (typeof object['sm'] === 'undefined')
            object['sm'] = true;
        if (typeof object['md'] === 'undefined')
            object['md'] = true;
        if (typeof object['lg'] === 'undefined')
            object['lg'] = true;
    } else {
        if (typeof object['sm'] === 'undefined')
            object['sm'] = false;
        if (typeof object['md'] === 'undefined')
            object['md'] = false;
        if (typeof object['lg'] === 'undefined')
            object['lg'] = false;
    }

    return object;
}

function compareSize(object, callbackTrue, callbackFalse) {
    $AVG.each(object, function(k, v) {
        if (getViewportSize('x') >= avg.sizes[k][0] && getViewportSize('x') <= avg.sizes[k][1]) {
            if (v) {
                callbackTrue();
            } else {
                callbackFalse();
            }
        }
    });
}

/*
 * Return name of breakpoint (sm,xs,md,lg)
 * @returns {String}
 */
function breakpointKey() {
    var windowSize = $AVG(window).outerWidth() + getScrollBarWidth();
    var breakpointKey;
    $AVG.each(avg.sizes, function(key) {
        if (windowSize >= avg.sizes[key][0] && windowSize <= avg.sizes[key][1]) {
            breakpointKey = key;
        }
    });
    return breakpointKey;
}

function getViewportSize(c) {
    if (c == 'x') return ($AVG(window).outerWidth() + getScrollBarWidth());
    if (c == 'y') return ($AVG(window).outerHeight());
}

function waitForWebfonts(fonts, callback) {
    var loadedFonts = 0;
    for (var i = 0, l = fonts.length; i < l; ++i) {
        (function(font) {
            var node = $AVG('<span></span>');
            // Characters that vary significantly among different fonts
            node.text('giItT1WQy@!-/#');
            // Visible - so we can measure it - but not on the screen
            node.css({
                'position': 'absolute',
                'left': '-10000px',
                'top': '-10000px',
                'font-size': '300px',
                'font-family': 'sans-serif',
                'font-variant': 'normal',
                'font-style': 'normal',
                'font-weight': 'normal',
                'letter-spacing': 0
            });

            $AVG('body').append(node);

            var width = node.width();

            node.css('font-family', font);

            var interval;
            function checkFont() {
                // Compare current width with original width
                if (node && node.width() != width) {
                    ++loadedFonts;
                    node.remove();
                }

                // If all fonts have been loaded
                if (loadedFonts >= fonts.length) {
                    if (interval) {
                        clearInterval(interval);
                    }
                    if (loadedFonts == fonts.length) {
                        return true;
                    }
                }
            }

            if (!checkFont()) {
                interval = setInterval(checkFont, 50);
            }
        })(fonts[i]);
    }
    if (loadedFonts == fonts.length) {
        callback();
    }
}


var waitForFinalEvent = (function() {
    var timers = {};
    return function(callback, ms, uniqueId) {
        if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId";
        }
        if (timers[uniqueId]) {
            clearTimeout(timers[uniqueId]);
        }
        timers[uniqueId] = setTimeout(callback, ms);
    };
})();

function platformDetection() {
    var ua = navigator.userAgent.toLowerCase();
    var current_platform;
    if (ua.indexOf("android") > -1) {
        current_platform = "platform_android";
    } else if (ua.indexOf("mac") > -1 && ua.indexOf("ipad") === -1 && ua.indexOf("iphone") === -1 && ua.indexOf("ipod") === -1) {
        current_platform = "platform_mac";
    } else if (ua.indexOf('ipad') > -1 || ua.indexOf('iphone') > -1 || ua.indexOf('ipod') > -1) {
        current_platform = "platform_ios";
    } else {
        current_platform = "platform_pc";
    }
    return current_platform;
}

/* find closes higher number in int array or use last
 * @param {int array} arr
 * @param {Number} closestTo
 * @return {Number} closest
 */
function closestHigherNumber(arr, closestTo) {

    var closest = Math.max.apply(null, arr);

    for (var i = 0; i < arr.length; i++) {
        if (arr[i] >= closestTo && arr[i] < closest)
            closest = arr[i];
    }

    return closest;
}

function emptyValue(el) {
    $AVG(el).val('');
}

function getOffset(el) {
    var childPos = $AVG(el).offset();
    var parentPos = $AVG(el).parent().offset();
    return {
        top: childPos.top - parentPos.top,
        left: childPos.left - parentPos.left
    };
}

function latinize(str) {
    return str.replace(/[^A-Za-z0-9]/g, function(x) { return latinize.characters[x] || x; });
}
latinize.characters = {'ẚ':'a','Á':'a','á':'a','À':'a','à':'a','Ă':'a','ă':'a','Ắ':'a','ắ':'a','Ằ':'a','ằ':'a','Ẵ':'a','ẵ':'a','Ẳ':'a','ẳ':'a','Â':'a','â':'a','Ấ':'a','ấ':'a','Ầ':'a','ầ':'a','Ẫ':'a','ẫ':'a','Ẩ':'a','ẩ':'a','Ǎ':'a','ǎ':'a','Å':'a','å':'a','Ǻ':'a','ǻ':'a','Ä':'a','ä':'a','Ǟ':'a','ǟ':'a','Ã':'a','ã':'a','Ȧ':'a','ȧ':'a','Ǡ':'a','ǡ':'a','Ą':'a','ą':'a','Ā':'a','ā':'a','Ả':'a','ả':'a','Ȁ':'a','ȁ':'a','Ȃ':'a','ȃ':'a','Ạ':'a','ạ':'a','Ặ':'a','ặ':'a','Ậ':'a','ậ':'a','Ḁ':'a','ḁ':'a','Ⱥ':'a','ⱥ':'a','Ǽ':'a','ǽ':'a','Ǣ':'a','ǣ':'a','Ḃ':'b','ḃ':'b','Ḅ':'b','ḅ':'b','Ḇ':'b','ḇ':'b','Ƀ':'b','ƀ':'b','ᵬ':'b','Ɓ':'b','ɓ':'b','Ƃ':'b','ƃ':'b','Ć':'c','ć':'c','Ĉ':'c','ĉ':'c','Č':'c','č':'c','Ċ':'c','ċ':'c','Ç':'c','ç':'c','Ḉ':'c','ḉ':'c','Ȼ':'c','ȼ':'c','Ƈ':'c','ƈ':'c','ɕ':'c','Ď':'d','ď':'d','Ḋ':'d','ḋ':'d','Ḑ':'d','ḑ':'d','Ḍ':'d','ḍ':'d','Ḓ':'d','ḓ':'d','Ḏ':'d','ḏ':'d','Đ':'d','đ':'d','ᵭ':'d','Ɖ':'d','ɖ':'d','Ɗ':'d','ɗ':'d','Ƌ':'d','ƌ':'d','ȡ':'d','ð':'d','É':'e','Ə':'e','Ǝ':'e','ǝ':'e','é':'e','È':'e','è':'e','Ĕ':'e','ĕ':'e','Ê':'e','ê':'e','Ế':'e','ế':'e','Ề':'e','ề':'e','Ễ':'e','ễ':'e','Ể':'e','ể':'e','Ě':'e','ě':'e','Ë':'e','ë':'e','Ẽ':'e','ẽ':'e','Ė':'e','ė':'e','Ȩ':'e','ȩ':'e','Ḝ':'e','ḝ':'e','Ę':'e','ę':'e','Ē':'e','ē':'e','Ḗ':'e','ḗ':'e','Ḕ':'e','ḕ':'e','Ẻ':'e','ẻ':'e','Ȅ':'e','ȅ':'e','Ȇ':'e','ȇ':'e','Ẹ':'e','ẹ':'e','Ệ':'e','ệ':'e','Ḙ':'e','ḙ':'e','Ḛ':'e','ḛ':'e','Ɇ':'e','ɇ':'e','ɚ':'e','ɝ':'e','Ḟ':'f','ḟ':'f','ᵮ':'f','Ƒ':'f','ƒ':'f','Ǵ':'g','ǵ':'g','Ğ':'g','ğ':'g','Ĝ':'g','ĝ':'g','Ǧ':'g','ǧ':'g','Ġ':'g','ġ':'g','Ģ':'g','ģ':'g','Ḡ':'g','ḡ':'g','Ǥ':'g','ǥ':'g','Ɠ':'g','ɠ':'g','Ĥ':'h','ĥ':'h','Ȟ':'h','ȟ':'h','Ḧ':'h','ḧ':'h','Ḣ':'h','ḣ':'h','Ḩ':'h','ḩ':'h','Ḥ':'h','ḥ':'h','Ḫ':'h','ḫ':'h','H':'h','̱':'h','ẖ':'h','Ħ':'h','ħ':'h','Ⱨ':'h','ⱨ':'h','Í':'i','í':'i','Ì':'i','ì':'i','Ĭ':'i','ĭ':'i','Î':'i','î':'i','Ǐ':'i','ǐ':'i','Ï':'i','ï':'i','Ḯ':'i','ḯ':'i','Ĩ':'i','ĩ':'i','İ':'i','i':'i','Į':'i','į':'i','Ī':'i','ī':'i','Ỉ':'i','ỉ':'i','Ȉ':'i','ȉ':'i','Ȋ':'i','ȋ':'i','Ị':'i','ị':'i','Ḭ':'i','ḭ':'i','I':'i','ı':'i','Ɨ':'i','ɨ':'i','Ĵ':'j','ĵ':'j','J':'j','̌':'j','ǰ':'j','ȷ':'j','Ɉ':'j','ɉ':'j','ʝ':'j','ɟ':'j','ʄ':'j','Ḱ':'k','ḱ':'k','Ǩ':'k','ǩ':'k','Ķ':'k','ķ':'k','Ḳ':'k','ḳ':'k','Ḵ':'k','ḵ':'k','Ƙ':'k','ƙ':'k','Ⱪ':'k','ⱪ':'k','Ĺ':'a','ĺ':'l','Ľ':'l','ľ':'l','Ļ':'l','ļ':'l','Ḷ':'l','ḷ':'l','Ḹ':'l','ḹ':'l','Ḽ':'l','ḽ':'l','Ḻ':'l','ḻ':'l','Ł':'l','ł':'l','Ł':'l','̣':'l','ł':'l','̣':'l','Ŀ':'l','ŀ':'l','Ƚ':'l','ƚ':'l','Ⱡ':'l','ⱡ':'l','Ɫ':'l','ɫ':'l','ɬ':'l','ɭ':'l','ȴ':'l','Ḿ':'m','ḿ':'m','Ṁ':'m','ṁ':'m','Ṃ':'m','ṃ':'m','ɱ':'m','Ń':'n','ń':'n','Ǹ':'n','ǹ':'n','Ň':'n','ň':'n','Ñ':'n','ñ':'n','Ṅ':'n','ṅ':'n','Ņ':'n','ņ':'n','Ṇ':'n','ṇ':'n','Ṋ':'n','ṋ':'n','Ṉ':'n','ṉ':'n','Ɲ':'n','ɲ':'n','Ƞ':'n','ƞ':'n','ɳ':'n','ȵ':'n','N':'n','̈':'n','n':'n','̈':'n','Ó':'o','ó':'o','Ò':'o','ò':'o','Ŏ':'o','ŏ':'o','Ô':'o','ô':'o','Ố':'o','ố':'o','Ồ':'o','ồ':'o','Ỗ':'o','ỗ':'o','Ổ':'o','ổ':'o','Ǒ':'o','ǒ':'o','Ö':'o','ö':'o','Ȫ':'o','ȫ':'o','Ő':'o','ő':'o','Õ':'o','õ':'o','Ṍ':'o','ṍ':'o','Ṏ':'o','ṏ':'o','Ȭ':'o','ȭ':'o','Ȯ':'o','ȯ':'o','Ȱ':'o','ȱ':'o','Ø':'o','ø':'o','Ǿ':'o','ǿ':'o','Ǫ':'o','ǫ':'o','Ǭ':'o','ǭ':'o','Ō':'o','ō':'o','Ṓ':'o','ṓ':'o','Ṑ':'o','ṑ':'o','Ỏ':'o','ỏ':'o','Ȍ':'o','ȍ':'o','Ȏ':'o','ȏ':'o','Ơ':'o','ơ':'o','Ớ':'o','ớ':'o','Ờ':'o','ờ':'o','Ỡ':'o','ỡ':'o','Ở':'o','ở':'o','Ợ':'o','ợ':'o','Ọ':'o','ọ':'o','Ộ':'o','ộ':'o','Ɵ':'o','ɵ':'o','Ṕ':'p','ṕ':'p','Ṗ':'p','ṗ':'p','Ᵽ':'p','Ƥ':'p','ƥ':'p','P':'p','̃':'p','p':'p','̃':'p','ʠ':'q','Ɋ':'q','ɋ':'q','Ŕ':'r','ŕ':'r','Ř':'r','ř':'r','Ṙ':'r','ṙ':'r','Ŗ':'r','ŗ':'r','Ȑ':'r','ȑ':'r','Ȓ':'r','ȓ':'r','Ṛ':'r','ṛ':'r','Ṝ':'r','ṝ':'r','Ṟ':'r','ṟ':'r','Ɍ':'r','ɍ':'r','ᵲ':'r','ɼ':'r','Ɽ':'r','ɽ':'r','ɾ':'r','ᵳ':'r','ß':'s','Ś':'s','ś':'s','Ṥ':'s','ṥ':'s','Ŝ':'s','ŝ':'s','Š':'s','š':'s','Ṧ':'s','ṧ':'s','Ṡ':'s','ṡ':'s','ẛ':'s','Ş':'s','ş':'s','Ṣ':'s','ṣ':'s','Ṩ':'s','ṩ':'s','Ș':'s','ș':'s','ʂ':'s','S':'s','̩':'s','s':'s','̩':'s','Þ':'t','þ':'t','Ť':'t','ť':'t','T':'t','̈':'t','ẗ':'t','Ṫ':'t','ṫ':'t','Ţ':'t','ţ':'t','Ṭ':'t','ṭ':'t','Ț':'t','ț':'t','Ṱ':'t','ṱ':'t','Ṯ':'t','ṯ':'t','Ŧ':'t','ŧ':'t','Ⱦ':'t','ⱦ':'t','ᵵ':'t','ƫ':'t','Ƭ':'t','ƭ':'t','Ʈ':'t','ʈ':'t','ȶ':'t','Ú':'u','ú':'u','Ù':'u','ù':'u','Ŭ':'u','ŭ':'u','Û':'u','û':'u','Ǔ':'u','ǔ':'u','Ů':'u','ů':'u','Ü':'u','ü':'u','Ǘ':'u','ǘ':'u','Ǜ':'u','ǜ':'u','Ǚ':'u','ǚ':'u','Ǖ':'u','ǖ':'u','Ű':'u','ű':'u','Ũ':'u','ũ':'u','Ṹ':'u','ṹ':'u','Ų':'u','ų':'u','Ū':'u','ū':'u','Ṻ':'u','ṻ':'u','Ủ':'u','ủ':'u','Ȕ':'u','ȕ':'u','Ȗ':'u','ȗ':'u','Ư':'u','ư':'u','Ứ':'u','ứ':'u','Ừ':'u','ừ':'u','Ữ':'u','ữ':'u','Ử':'u','ử':'u','Ự':'u','ự':'u','Ụ':'u','ụ':'u','Ṳ':'u','ṳ':'u','Ṷ':'u','ṷ':'u','Ṵ':'u','ṵ':'u','Ʉ':'u','ʉ':'u','Ṽ':'v','ṽ':'v','Ṿ':'v','ṿ':'v','Ʋ':'v','ʋ':'v','Ẃ':'w','ẃ':'w','Ẁ':'w','ẁ':'w','Ŵ':'w','ŵ':'w','W':'w','̊':'w','ẘ':'w','Ẅ':'w','ẅ':'w','Ẇ':'w','ẇ':'w','Ẉ':'w','ẉ':'w','Ẍ':'x','ẍ':'x','Ẋ':'x','ẋ':'x','Ý':'y','ý':'y','Ỳ':'y','ỳ':'y','Ŷ':'y','ŷ':'y','Y':'y','̊':'y','ẙ':'y','Ÿ':'y','ÿ':'y','Ỹ':'y','ỹ':'y','Ẏ':'y','ẏ':'y','Ȳ':'y','ȳ':'y','Ỷ':'y','ỷ':'y','Ỵ':'y','ỵ':'y','ʏ':'y','Ɏ':'y','ɏ':'y','Ƴ':'y','ƴ':'y','Ź':'z','ź':'z','Ẑ':'z','ẑ':'z','Ž':'z','ž':'z','Ż':'z','ż':'z','Ẓ':'z','ẓ':'z','Ẕ':'z','ẕ':'z','Ƶ':'z','ƶ':'z','Ȥ':'z','ȥ':'z','ʐ':'z','ʑ':'z','Ⱬ':'z','ⱬ':'z','Ǯ':'z','ǯ':'z','ƺ':'z','２':'2','６':'6','Ｂ':'B','Ｆ':'F','Ｊ':'J','Ｎ':'N','Ｒ':'R','Ｖ':'V','Ｚ':'Z','ｂ':'b','ｆ':'f','ｊ':'j','ｎ':'n','ｒ':'r','ｖ':'v','ｚ':'z','１':'1','５':'5','９':'9','Ａ':'A','Ｅ':'E','Ｉ':'I','Ｍ':'M','Ｑ':'Q','Ｕ':'U','Ｙ':'Y','ａ':'a','ｅ':'e','ｉ':'i','ｍ':'m','ｑ':'q','ｕ':'u','ｙ':'y','０':'0','４':'4','８':'8','Ｄ':'D','Ｈ':'H','Ｌ':'L','Ｐ':'P','Ｔ':'T','Ｘ':'X','ｄ':'d','ｈ':'h','ｌ':'l','ｐ':'p','ｔ':'t','ｘ':'x','３':'3','７':'7','Ｃ':'C','Ｇ':'G','Ｋ':'K','Ｏ':'O','Ｓ':'S','Ｗ':'W','ｃ':'c','ｇ':'g','ｋ':'k','ｏ':'o','ｓ':'s','ｗ':'w'};


function keyboardEvents(el, event, typein) {
    if (!typein) {
        var typein = false;
    }
    var parent = $(el).closest('span.select.input');
    if (typeof actualLi === 'undefined') {
        actualLi = ($(parent).find('li.selected:not(.hide)').length === 1) ? $(parent).find('ul li.selected') : $(parent).find('ul li:first-child');
    }

    var keyCode = (window.Event) ? event.which : event.keyCode;

    var arrowCodes = [13, 27, 33, 34, 35, 36, 38, 40];

    if ($.inArray(event.keyCode, arrowCodes) > -1 && event.type === 'keydown') {
        //$(el).attr('value', '');
    }

    /* UP ARROW */
    if (keyCode === 38 && event.type === 'keydown') {
        if ($(actualLi).prevAll(':not(.hide)').first().prop('tagName') === 'LI') {
            actualLi = $(actualLi).prevAll(':not(.hide)').first();
        }
        $(parent).find('li').removeClass('hovered');
        $(actualLi).addClass('hovered');
        $(parent).find('.ul-wrapper').scrollTop(getOffset(actualLi).top);

        /* DOWN ARROW */
    }
    else if (keyCode === 40 && event.type === 'keydown') {
        if ($(actualLi).nextAll(':not(.hide)').first().prop('tagName') === 'LI') {
            actualLi = $(actualLi).nextAll(':not(.hide)').first();
        }
        $(parent).find('li').removeClass('hovered');
        $(actualLi).addClass('hovered');
        $(parent).find('.ul-wrapper').scrollTop(getOffset(actualLi).top);

        /* PAGE UP */
    }
    else if (keyCode === 33 && event.type === 'keydown') {
        if ($(actualLi).prevAll(':not(.hide):eq(5)').first().prop('tagName') === 'LI') {
            actualLi = $(actualLi).prevAll(':not(.hide):eq(5)').first();
        } else {
            actualLi = $(parent).find('ul li:first-child');
        }
        $(parent).find('li').removeClass('hovered');
        $(actualLi).addClass('hovered');
        $(parent).find('.ul-wrapper').scrollTop(getOffset(actualLi).top);

        /* PAGE DOWN */
    }
    else if (keyCode === 34 && event.type === 'keydown') {
        if ($(actualLi).nextAll(':not(.hide):eq(5)').first().prop('tagName') === 'LI') {
            actualLi = $(actualLi).nextAll(':not(.hide):eq(5)').first();
        } else {
            actualLi = $(parent).find('ul li:last-child');
        }
        $(parent).find('li').removeClass('hovered');
        $(actualLi).addClass('hovered');
        $(parent).find('.ul-wrapper').scrollTop(getOffset(actualLi).top);

        /* END */
    }
    else if (keyCode === 35 && event.type === 'keydown') {
        actualLi = $(parent).find('ul li:last-child');
        $(parent).find('li').removeClass('hovered');
        $(actualLi).addClass('hovered');
        $(parent).find('.ul-wrapper').scrollTop(getOffset(actualLi).top);

        /* HOME */
    }
    else if (keyCode === 36 && event.type === 'keydown') {
        actualLi = $(parent).find('ul li:first-child');
        $(parent).find('li').removeClass('hovered');
        $(actualLi).addClass('hovered');
        $(parent).find('.ul-wrapper').scrollTop(getOffset(actualLi).top);

        /* ENTER */
    }
    else if (keyCode === 13 && event.type === 'keydown') {
        $(el).trigger('blur');
        $(actualLi).trigger('click');

        /* ESCAPE */
    }
    else if (keyCode === 27 && event.type === 'keydown') {
        $(el).trigger('blur');
        $(document).trigger('click');

        /* ALL KEYS EXCEPT ONES ABOVE */
    }
    else if (event.type === 'keyup' && $.inArray(keyCode, arrowCodes) === -1) {
    //    if (typein === true) {


            if ($.inArray(keyCode, arrowCodes) > -1) {
                actualLi = $(parent).find('ul li:first-child');
            }
            $(parent).find('.ul-wrapper').addClass('active');

                var els = $(parent).find('li[data-text^="' + $(el).val().toUpperCase() + '"], li[data-value=""]');


            if ($(el).val().length > 0) {
                $(parent).find('li').addClass('hide');
                $(els).removeClass('hide');
            }
            else {
                $(parent).find('li').removeClass('hide');
            }
    //    }
    }
}

$AVG.fn.updateFormInputs = function(types) {
    $AVG.fn.getParentByChild = function(child) {
        if ($AVG(this).length > 0) {
            var found = false;
            var el = $AVG(this);
            while (found === false) {
                el = $AVG(el).parent();
                if ($AVG(el).find($AVG(child))) {
                    found = true;
                    return $AVG(el);
                }
            }
        }
    };

    var height = $AVG(document).height();
    var inputs = $AVG(this);
    var i = 0;
    var els = $AVG(inputs).find('select:not([data-input-update="false"])');

    $AVG.each(els, function() {
        $AVG(this).attr('size', 2);
        var parent = $AVG(this).getParentByChild('label');
        $AVG(parent).addClass('input-parent select-parent');
        $AVG(this).addClass('input-replaced');
        var typein = ($AVG(this).attr('data-type-in') === 'true');
        var showFlags = ($AVG(this).attr('data-show-flags') === 'true');
        var datafor = $AVG(this).attr('id');
        var dataname = $AVG(this).attr('name');
        var datadisabled = 'false';
        var classes = 'input select ' + dataname;
        var options = '';
        var selectval = $AVG(this).find(':selected').text();
        if ($AVG(this).is(':disabled')) {
            datadisabled = 'true';
            classes += ' disabled';
        }


        $AVG.each($AVG(this).find('option'), function() {
            var latinizedData = typein ? ' data-latinized="' + $AVG(this).html().toUpperCase() + '"' : '';
            var addClass = ($AVG(this).attr('data-class')) ? $AVG(this).attr('data-class') : '';
            var valclass = ($AVG(this).attr('value').length != 0) ? 'val-' + $AVG(this).attr('value') : '';
            var flagClass = showFlags && valclass.length != 0 ? 'flag-' + $AVG(this).attr('value') : '';
            options += '<li' + ($AVG(this).prop('selected') ? ' class="selected ' + valclass + ' ' + flagClass +  ' ' + addClass + '"' : ' class="' + valclass + ' ' + flagClass + ' ' + addClass + '"') + latinizedData + ' data-text="' + $AVG(this).html().toUpperCase() + '" data-value="' + $AVG(this).attr('value') + '"><span></span>' + $AVG(this).text() + '</li>';
        });

        options = ($AVG('<span />').html('<span class="ul-wrapper"><ul class="options">' + options + '</ul></span>').contents());
        var select = $AVG('<span class="' + classes + '" data-for="' + datafor + '" data-name="' + dataname + '" data-type-in="' + typein + '" data-disabled="' + datadisabled + '"><span class="value"><span class="s-text">' + ((typein) ? '<input type="text" tabindex="-1" onclick="emptyValue(this)" autocomplete="off" class="noborder" id="' + datafor + '_typein" name="' + dataname + '_typein" data-for="' + datafor + '" placeholder="' + selectval + '"/>' : '<span class="sval">' + selectval + '</span><input class="input-hidden input-replaced" onclick="emptyValue(this)" autocomplete="off" tabindex="-1" type="text" id="' + datafor + '_notypein" placeholder="' + selectval + '"/>') + '</span><span class="s-button"></span></span></span>')
            .insertAfter($AVG(this));
        $AVG(options).appendTo($AVG(select));
    });

    $AVG('span.select.input .value').off('click').on('click', function(e, data) {
        e.stopPropagation();
        var event = window.event ? window.event : e;
        var parent = $AVG(this).closest('span.select.input');
        var actualLi = ($AVG(parent).find('li.selected').length == 1) ? $AVG(parent).find('ul li.selected') : $AVG(parent).find('ul li:first-child');
        if (event.type == 'click') {
            $AVG(parent).find('input[type="text"]').trigger('focus');
            if ($AVG(parent).attr('data-disabled') === 'false') {
                if ($AVG(parent).find('.ul-wrapper').hasClass('active')) {
                    $AVG(parent).find('.ul-wrapper').removeClass('active');
                } else {
                    $AVG(parent).find('li').removeClass('hide hovered');
                    $AVG('span.select.input .ul-wrapper').removeClass('active');
                    $AVG(parent).find('.ul-wrapper').addClass('active');
                    $AVG(parent).find('.ul-wrapper').scrollTop(getOffset(actualLi).top);
                }
            }
        }
    });

    $AVG('span.select.input[data-type-in="true"] input[type="text"]').on('keyup keydown', function(e) {
        var event = window.event ? window.event : e;
        keyboardEvents($AVG(this), e, true);
    });

    $AVG('span.select.input input.input-hidden[type="text"]').on('keyup keydown', function(e) {
        var event = window.event ? window.event : e;
        keyboardEvents($AVG(this), e, false);
    });

    $AVG(document).on("click", function() {
        actualLi = undefined;
        var selectInput = $AVG('span.select.input input[type="text"]');
        $AVG('span.select.input .ul-wrapper').removeClass('active');
        if ($AVG(selectInput).length > 0) {
            $AVG.each($AVG(selectInput), function() {
                $AVG(this).prop('value', $AVG(this).prop('placeholder'));
            });
        }
    });

    $AVG('span.select.input li').off('click').on('click', function(e, data) {
        if ($AVG(this).closest('span.select.input').attr('data-disabled') === 'false') {
            var parent = $AVG(this).closest('span.select.input');
            $AVG(parent).find('li').removeClass('selected');
            $AVG(this).addClass('selected');
            $AVG(parent).find('.value span:first-child input').val($AVG(this).text());
            $AVG(parent).find('.value span:first-child input').attr('placeholder', $AVG(this).text());
            if ($AVG(parent).find('.value span:first-child span.sval').length > 0) {
                $AVG(parent).find('.value span:first-child span.sval').text($AVG(this).text());
            }
            if (typeof data === "undefined") {
                data = {
                    change: true
                };
            }
            if (data.change === true) {
                $AVG('#' + $AVG(parent).attr('data-for')).val($AVG(this).attr('data-value')).trigger('change', {
                    change: false
                });
            }
            $AVG(parent).find('.ul-wrapper').removeClass('active');
        }
    });

    $AVG(els).on('change keydown', function(e, data) {
        var event = window.event ? window.event : e;
        var keyCode = (window.Event) ? event.which : event.keyCode;

        /* UP, DOWN ARROW */
        if (keyCode === 38 || keyCode === 40 && event.type === 'keydown' || event.type === 'change') {
            if (typeof data === "undefined") {
                data = {
                    change: true
                };
            }
            if (data.change === true) {
                $AVG('[data-for="' + $AVG(this).attr('id') + '"] ' + '[data-value="' + $AVG(this).find(':selected').attr('value') + '"]').trigger('click', {
                    change: false
                });
            }
        }
    });

    $AVG(els).on('focus', function(e, data) {
        $AVG('span.input.select').removeClass('focus');
        $AVG('[data-for="' + $AVG(this).attr('id') + '"]').addClass('focus');
    });

    $AVG(els).on('blur', function(e, data) {
        $AVG('[data-for="' + $AVG(this).attr('id') + '"]').removeClass('focus');
    });
};

function getQueryVariable(variable) {
    var query = encodeURIComponent(window.location.search.substring(1));
    var vars = query.split("%26");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("%3D");
        if (pair[0] === variable) {
            return pair[1];
        }
    }
    return '';
};

/* equal elements heights */
$.fn.getHighestElement = function() {
    var maxHeight = this.map(function(i, e) {
        return $(e).height();
    }).get();
    return Math.max.apply(this, maxHeight);
};

/*
 * Check if array contains value
 * @returns {Boolean}
 */
function isInArray(value, array) {
    return array.indexOf(value) > -1;
}

/*
* Check device with touch event
* {@link https://modernizr.com}
* @return {String} touchevent
*/
function checkTouchEvents() {
    var touchevent = 'no-touchevents';
    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
        var touchevent = 'touchevents';
    }
    return touchevent;
}

/**
* Get translation of plural string according to number of items
* @param key to the data object
* @param number amount of items of units from key
* @param data dictionary JSON object
* @return Dictionary string with the locale translation or empty string
*/
function translation(dicKey, number, data){
    var plural;
    $AVG.each(data, function(key, value) {
        /*  check for correct format NAME_FROM,_TO and if the number is inside [from, to)
            from inclusive
            to exclusive
            eg NAME_1_5 means 1,2,3,4 (not 5!)
        */
        if( key.indexOf(dicKey) !== -1 && key.indexOf('_') !== -1){
            var nameParts = key.split('_');
            if ( nameParts.length > 2 && parseInt(number) >= nameParts[1] && parseInt(number) < nameParts[2]) {
                plural =  value;
            }
        }

    });
    return plural;
}

/* equal heights */
$.fn.equalizeHeights = function () {
    var maxHeight = this.map(function (i, e) {
        return $(e).height();
    }).get();
    return this.height(Math.max.apply(this, maxHeight));
};

$AVG(document).ready(function() {
    var browser = getBrowser();
    var android = getAndroidVersion();

    browser.android = '';
    if (android) {
        browser.android = ' android-' + android.substr(0, 1);
    }
    $AVG('body').addClass('br-' + browser.browser.toLowerCase() + ' br-ver-' + browser.version_rounded + browser.android + ' ' + checkTouchEvents());
    waitForWebfonts(['AVGSans_Light','AVGSans_1', 'AVGSans_2', 'AVGSans_3', 'AVGSans_4'], function() {
        $AVG(window).trigger('fontsLoaded');
    });
});

/*
 1.4.2016 - Suggest to remove.
 This function doesn't work as expected.
 Use .visible() function instead.
 */
$AVG.fn.isVisible = function () {
	var el = this;
	var top = el.offset().top;
	var left = el.offset().left;
	var width = el.outerWidth();
	var height = el.outerHeight();

	el = el.offsetParent();
	top += el.offset().top;
	left += el.offset().left;

	return (
		($AVG(window).scrollTop() + $AVG(window).innerHeight()) >= top && $AVG(window).scrollTop() <= (top + height) &&
		($AVG(window).scrollLeft() + $AVG(window).innerWidth()) >= left && $AVG(window).scrollLeft() <= (left + width)
	);
}

$AVG.extend($AVG.expr[':'], {isvisible: function(elem) {
	return $AVG(elem).isVisible() ? $AVG(elem) : false;
}});
(function ($) {

    /**
     * Copyright 2012, Digital Fusion Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within the user
     *       visible viewport of a web browser. only accounts for vertical
     *       position, not horizontal.
     */
    var $w = $(window);
    $.fn.visible = function (partial, hidden, direction) {

        if (this.length < 1)
            return;

        var $t = this.length > 1 ? this.eq(0) : this,
            t = $t.get(0),
            vpWidth = $w.width(),
            vpHeight = $w.height(),
            direction = (direction) ? direction : 'both',
            clientSize = hidden === true ? t.offsetWidth * t.offsetHeight : true;

        if (typeof t.getBoundingClientRect === 'function') {

            // Use this native browser method, if available.
            var rec = t.getBoundingClientRect(),
                tViz = rec.top >= 0 && rec.top < vpHeight,
                bViz = rec.bottom > 0 && rec.bottom <= vpHeight,
                lViz = rec.left >= 0 && rec.left < vpWidth,
                rViz = rec.right > 0 && rec.right <= vpWidth,
                vVisible = partial ? tViz || bViz : tViz && bViz,
                hVisible = partial ? lViz || lViz : lViz && rViz;

            if (direction === 'both')
                return clientSize && vVisible && hVisible;
            else if (direction === 'vertical')
                return clientSize && vVisible;
            else if (direction === 'horizontal')
                return clientSize && hVisible;
            else if (direction === 'vertical-bottom')
                return clientSize && bViz;
        } else {

            var viewTop = $w.scrollTop(),
                viewBottom = viewTop + vpHeight,
                viewLeft = $w.scrollLeft(),
                viewRight = viewLeft + vpWidth,
                offset = $t.offset(),
                _top = offset.top,
                _bottom = _top + $t.height(),
                _left = offset.left,
                _right = _left + $t.width(),
                compareTop = partial === true ? _bottom : _top,
                compareBottom = partial === true ? _top : _bottom,
                compareLeft = partial === true ? _right : _left,
                compareRight = partial === true ? _left : _right;

            if (direction === 'both')
                return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop)) && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
            else if (direction === 'vertical')
                return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop));
            else if (direction === 'horizontal')
                return !!clientSize && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
            else if (direction === 'vertical-bottom') {                
                return !!clientSize && (compareBottom <= viewBottom);
            }
        }
    };

})($);
/* ========================================================================
 * Bootstrap: modal.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#modals
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options = options
    this.$body = $(document.body)
    this.$element = $(element)
    this.$dialog = this.$element.find('.modal-dialog')
    this.$backdrop = null
    this.isShown = null
    this.originalBodyPad = null
    this.scrollbarWidth = 0
    this.ignoreBackdropClick = false
    this.fixedContent = '.navbar-fixed-top, .navbar-fixed-bottom'

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION = '3.4.1'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
          this.$element[0] !== e.target &&
          !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    var scrollbarWidth = this.scrollbarWidth
    if (this.bodyIsOverflowing) {
      this.$body.css('padding-right', bodyPad + scrollbarWidth)
      $(this.fixedContent).each(function (index, element) {
        var actualPadding = element.style.paddingRight
        var calculatedPadding = $(element).css('padding-right')
        $(element)
          .data('padding-right', actualPadding)
          .css('padding-right', parseFloat(calculatedPadding) + scrollbarWidth + 'px')
      })
    }
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
    $(this.fixedContent).each(function (index, element) {
      var padding = $(element).data('padding-right')
      $(element).removeData('padding-right')
      element.style.paddingRight = padding ? padding : ''
    })
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this = $(this)
      var data = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this = $(this)
    var href = $this.attr('href')
    var target = $this.attr('data-target') ||
      (href && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7

    var $target = $(document).find(target)
    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: modal.js v3.3.1
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


/* +function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options, trigger, config) {
    this.options        = options
    this.$body          = $(document.body)
    this.$element       = $(element)
    this.$backdrop      =
    this.isShown        = null
    this.$trigger				= trigger
    this.scrollbarWidth = 0
    this.config					= config

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.1'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    options: { title: '' },
    show: true,
    delay: 0
  }

  Modal.prototype.toggle = function (_relatedTarget) {
		return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.setIframe = function (target, url) {
		var body = target.find('.modal-body');
		var iframeFormat = '<iframe class="modal-iframe" src="' + url + '?html5=1&amp;rel=0&amp;autoplay=1&amp;enablejsapi=1" frameborder="0" allowfullscreen></iframe>'

		body.html(iframeFormat);
	}

  Modal.prototype.removeIframe = function (target) {
		var body = target.find('.modal-body');
		body.find('iframe').remove();
  }


  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
    var config = this.$trigger.data().options || {}

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    if (this.$trigger.hasClass('video-open')) {
    	this.$element.addClass('video')
    	this.setIframe(this.$element, this.$trigger.attr('href').substr(1))
    }

		if (typeof config.title !== "undefined") {
			this.$element.removeClass('no-header')
    	this.$element.find('.modal-header').append('<h4>' + config.title + '</h4>')
    }

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      if (that.options.backdrop) that.adjustBackdrop()
      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element
        .addClass('in')
        .attr('aria-hidden', false)

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$element.find('.modal-dialog') // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()
    var config = this.$trigger.data().options || {}

    e = $.Event('hide.bs.modal')

		this.$element.removeClass('video').trigger(e)

    if (typeof config.title !== "undefined") {
	    this.$element.addClass('no-header')
	    this.$element.find('.modal-header h4').remove()
	    this.removeIframe(this.$element)
    }

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .attr('aria-hidden', true)
      .off('click.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate
      var classes = ''
			if (this.$trigger.hasClass('video-open')) {
				classes = ' video';
			}

      this.$backdrop = $('<div class="modal-backdrop ' + animate + classes + '" />')
        .prependTo(this.$element)
        .on('click.dismiss.bs.modal', $.proxy(function (e) {
          if (e.target !== e.currentTarget) return
          this.options.backdrop == 'static'
            ? this.$element[0].focus.call(this.$element[0])
            : this.hide.call(this)
        }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    if (this.options.backdrop) this.adjustBackdrop()
    this.adjustDialog()
  }

  Modal.prototype.adjustBackdrop = function () {
    this.$backdrop
      .css('height', 0)
      .css('height', this.$element[0].scrollHeight)
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    this.bodyIsOverflowing = document.body.scrollHeight > document.documentElement.clientHeight
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', '')
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget, trigger, config) {
		return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      Modal.DEFAULTS.modalDelay = 0;
			if (trigger.data().modalDelay) Modal.DEFAULTS.modalDelay = trigger.data().modalDelay
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var reevaluate = true

			if (typeof options['bs.modal'] === 'undefined')
				options['bs.modal'] = {'options': {'delay': 0}}

			if (typeof trigger.data().options !== "undefined" && typeof $this.data('bs.modal') !== "undefined") {
					if ($this.data('bs.modal').$trigger[0] === trigger[0])
						reevaluate = false;
			}

      if (!data || reevaluate) { $this.data('bs.modal', (data = new Modal(this, options, trigger))); }
      if (typeof option == 'string') setTimeout(function(){data[option](_relatedTarget)}, options.delay || options['bs.modal'].options.delay)
      else if (options.show) setTimeout(function(){data.show(_relatedTarget)}, options.delay || options['bs.modal'].options.delay)
    })
  }

  var old = $.fn.modal

  $.fn.modal             = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }

	function readyHandler () {
		this.href = '#' + this.href;
	}

  // MODAL DATA-API
  // ==============

  $(document).ready(function(){
  	$('.video-open[data-toggle="modal"]').each(function(){
			readyHandler.call(this);
	  });
	});

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })

    Plugin.call($target, option, null, $this)
  })

}(jQuery); */

/* ========================================================================
 * Bootstrap: transition.js v3.3.1
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);

+function ($) {
    'use strict';

    // COLLAPSE PUBLIC CLASS DEFINITION
    // ================================

    var Collapse = function (element, options) {
        this.$element = $(element)
        this.options = $.extend({}, Collapse.DEFAULTS, options)
        this.$trigger = $(this.options.trigger).filter('[href="#' + element.id + '"], [data-target="#' + element.id + '"]')
        this.transitioning = null

        if (this.options.event == 'resize' || this.options.event == 'load') {
            var element = this.$element
            var trigger = this.$trigger
            var sizeAction = {}
            this.options.sizes = setSizeList(this.options.sizes);
            compareSize(
                    this.options.sizes,
                    function () {
                        sizeAction = true
                        trigger
                                .removeClass('expandLink')
                    },
                    function () {
                        sizeAction = false
                        trigger
                                .addClass('expandLink')
                    }
            );
            this.options['sizeAction'] = sizeAction
        }

        if (typeof this.options.sizes === 'undefined')
            this.options.sizes = {};

        if (this.options.parent) {
            this.$parent = this.getParent()
        } else {
            this.addAriaAndCollapsedClass(this.$element, this.$trigger)
        }

        if (this.options.toggle)
            this.toggle()

    }

    Collapse.VERSION = '3.3.1'

    Collapse.TRANSITION_DURATION = 350

    Collapse.DEFAULTS = {
        toggle: true,
        trigger: '[data-toggle="collapse"]'
    }

    Collapse.prototype.dimension = function () {
        var hasWidth = this.$element.hasClass('width')
        return hasWidth ? 'width' : 'height'
    }

    Collapse.prototype.show = function () {
        if (this.transitioning || this.$element.hasClass('in'))
            return
        var activesData
        var actives = this.$parent && this.$parent.find('> .panel').children('.in, .collapsing')

        $('body')
                .trigger('menu-opening', {element: this});

        if (actives && actives.length) {
            activesData = actives.data('bs.collapse')
            if (activesData && activesData.transitioning)
                return
        }

        var startEvent = $.Event('show.bs.collapse')
        this.$element.trigger(startEvent)
        if (startEvent.isDefaultPrevented())
            return

        if (actives && actives.length) {
            Plugin.call(actives, 'hide')
            activesData || actives.data('bs.collapse', null)
        }

        var dimension = this.dimension()

        if (Object.keys(this.options.sizes).length > 0) {
            var element = this.$element
            var trigger = this.$trigger

            this.options.sizes = setSizeList(this.options.sizes);
            compareSize(
                    this.options.sizes,
                    function () {
                        element
                                .removeClass('collapse')
                                .addClass('collapsing')[dimension](0)
                                .attr('aria-expanded', true)

                        trigger
                                .removeClass('collapsed plus')
                                .addClass('minus icon-right')
                                .attr('aria-expanded', true)
                    },
                    function () {
                        element
                                .attr('aria-expanded', true)
                        trigger
                                .removeClass('plus')
                                .attr('aria-expanded', true)
                    }
            );
        } else {
            element
                    .removeClass('collapse')
                    .addClass('collapsing')[dimension](0)
                    .attr('aria-expanded', true)

            trigger
                    .removeClass('collapsed')
                    .attr('aria-expanded', true)
        }

        this.transitioning = 1

        var complete = function () {
            $('body')
                    .addClass('menu-opened')
                    .removeClass('menu-closed');

            this.$element
                    .removeClass('collapsing')
                    .addClass('collapse in')[dimension]('')
            this.transitioning = 0
            this.$element
                    .trigger('shown.bs.collapse')
        }

        if (!$.support.transition)
            return complete.call(this)

        var scrollSize = $.camelCase(['scroll', dimension].join('-'))

        this.$element
                .one('bsTransitionEnd', $.proxy(complete, this))
                .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
    }

    Collapse.prototype.hide = function () {
        if (this.transitioning || !this.$element.hasClass('in'))
            return
        var startEvent = $.Event('hide.bs.collapse')
        this.$element.trigger(startEvent)
        if (startEvent.isDefaultPrevented())
            return

        var dimension = this.dimension()

        $('body')
                .trigger('menu-closing', {element: this});

        this.$element[dimension](this.$element[dimension]())[0].offsetHeight

        this.transitioning = 1

        var complete = function () {
            $('body')
                    .addClass('menu-closed')
                    .removeClass('menu-opened');

            this.transitioning = 0
            this.$element
                    .removeClass('collapsing')
                    .addClass('collapse')
                    .trigger('hidden.bs.collapse')
        }

        if (Object.keys(this.options.sizes).length > 0) {
            var $this = this
            var element = this.$element
            var trigger = this.$trigger
            this.options.sizes = setSizeList(this.options.sizes);
            compareSize(
                    this.options.sizes,
                    function () {
                        element
                                .addClass('collapsing')
                                .removeClass('collapse in')
                                .attr('aria-expanded', false)
                                [dimension](0)
                                .one('bsTransitionEnd', $.proxy(complete, $this))
                                .emulateTransitionEnd(Collapse.TRANSITION_DURATION)

                        trigger
                                .removeClass('minus')
                                .addClass('collapsed plus icon-right')
                                .attr('aria-expanded', false)

                    },
                    function () {
                        element
                                .one('bsTransitionEnd', $.proxy(complete, $this))
                                .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
                    }
            );
        } else {
            element
                    .addClass('collapsing')
                    .removeClass('collapse in')
                    .attr('aria-expanded', false)

            trigger
                    .addClass('collapsed')
                    .attr('aria-expanded', false)

            this.$element
                    [dimension](0)
                    .one('bsTransitionEnd', $.proxy(complete, this))
                    .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
        }

        if (!$.support.transition)
            return complete.call(this)

    }

    Collapse.prototype.toggle = function () {
        if (Object.keys(this.options.sizes).length > 0 && (this.options.event == "load" || this.options.event == "resize")) {

            if (this.options.sizeAction) {
                this.hide()
                this.$trigger.addClass('collapsed plus icon-right')
            } else {
                this.show()
            }
            this.options.event = "default"
        } else {
            this[this.$element.hasClass('in') ? 'hide' : 'show']()
        }

    }

    Collapse.prototype.getParent = function () {
        return $(this.options.parent)
                .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
                .each($.proxy(function (i, element) {
                    var $element = $(element)
                    this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
                }, this))
                .end()
    }

    Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
        var isOpen = $element.hasClass('in')

        $element.attr('aria-expanded', isOpen)
        $trigger
                .toggleClass('collapsed', !isOpen)
                .attr('aria-expanded', isOpen)
    }

    function getTargetFromTrigger($trigger) {
        var href
        var target = $trigger.attr('data-target')
                || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

        return $(target)
    }


// COLLAPSE PLUGIN DEFINITION
// ==========================

    function Plugin(option) {

        return this.each(function () {
            var $this = $(this)
            var data = $this.data('bs.collapse')
            var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
            if (!data && options.toggle && option == 'show')
                options.toggle = false
            if (!data || option.event == 'resize')
                $this.data('bs.collapse', (data = new Collapse(this, options)))
            if (typeof option == 'string')
                data[option]()
        })
    }

    var old = $.fn.collapse

    $.fn.collapse = Plugin
    $.fn.collapse.Constructor = Collapse


// COLLAPSE NO CONFLICT
// ====================

    $.fn.collapse.noConflict = function () {
        $.fn.collapse = old
        return this
    }


// COLLAPSE DATA-API
// =================

    $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
        var $this = $(this)
        if (!$this.attr('data-target'))
            e.preventDefault()
        var $target = getTargetFromTrigger($this)
        var data = $target.data('bs.collapse')
        var option = data ? 'toggle' : $.extend({}, $this.data(), {trigger: this})
        Plugin.call($target, option)
    })

    var eventHandler = function (els, event) {

        var $this = $(els)
        $.each($this, function () {

            var $target = getTargetFromTrigger($(this))
            var option = $.extend({}, {event: event}, $this.data(), {trigger: this})
            Plugin.call($target, option)
        });
    }

    $(window).load(
            function () {
                eventHandler('[data-expand]', "load")
            }
    )
    $(window).resize(function () {
        waitForFinalEvent(function () {
            eventHandler('[data-expand]', "resize")
        }, 500);
    });


}(jQuery);
/* ========================================================================
 * Bootstrap: navigation.js v3.3.1
 * ========================================================================
 * Copyright 2015 Vojtech Portes
 * ======================================================================== */


+function ($) {
	'use strict';

	// NAVIGATION CLASS DEFINITION
	// ====================

	var Navigation = function (element, options) {
		this.element = $(element);
		this.options = options;
		this.options.css3 = true;
		this.$trigger = $(this.options.trigger).filter('[href="#' + element.id + '"], [data-navigation-target="#' + element.id + '"]');
	}

	Navigation.prototype.toggle = function () {
		var controls = this.options.navigationControls;
		var $target = $(this.options.navigationTarget);
		var $parent = $(controls.container);
		var $navigation = $(controls.navigationContainer).first();
		var $this = $(this.element);
		var settings = {};
		settings.parent = {};
		settings.nav = {};

		$('html, body').animate({
			scrollTop: $(".navigation").offset().top
		}, 100);

		$target.toggleClass('in');
		$('body, html').toggleClass('nav-active');

		if (!propertyExists('transition')) {
			if ($target.hasClass('in')) {
				if (controls.align == 'left') {
					var base = $navigation.css('left');
					settings.parent.right = controls.closed;

					if ($('body').hasClass('br-msie')) {
						settings.nav.left = base + controls.closed;
					} else {
						settings.nav.left = controls.opened;
					}
				}
				if (controls.align == 'right') {
					var base = $navigation.css('right');
					settings.parent.left = controls.closed;

					if ($('body').hasClass('br-msie')) {
						settings.nav.right = base + controls.closed;
					} else {
						settings.nav.right = controls.opened;
					}

				}

				$target.animate(settings.nav, controls.duration);
				$navigation.animate(settings.parent, controls.duration);
				$parent.animate(settings.parent, controls.duration);
			} else {
				if (controls.align == 'left') {
					settings.parent.right = -controls.opened;
					settings.nav.left = controls.closed;
				}
				if (controls.align == 'right') {
					settings.parent.left = -controls.opened;
					settings.nav.right = controls.closed;
				}

				$target.animate(settings.nav, controls.duration);
				$navigation.animate(settings.parent, controls.duration);
				$parent.animate(settings.parent, controls.duration);
			}
		}
	}

	Navigation.prototype.init = function () {
		var controls = this.options.navigationControls;
		var $target = $(this.options.navigationTarget);
		var $parent = $(controls.container);
		var $navigation = $(controls.navigationContainer);
		var $this = $(this.element);
		var css = {};

		css['position'] = 'relative';
		css[((controls.align == 'right') ? 'left' : 'right')] = 0;
		$parent.css(css);

		$navigation.css(css);

		if (propertyExists('transition')) {
			$target.prepend('<style>@media (max-width: 991px) {' + this.options.navigationTarget + ', ' + controls.container + ', ' + controls.navigationContainer + ' { ' + browserProperty('transition', 'transform ' + (controls.duration / 1000) + 's linear', true) + ' } .nav-active ' + this.options.target + ' { ' + browserProperty('transform', 'translateX(' + controls.opened + 'px)') + ' }  .nav-active ' + controls.container + ', .nav-active ' + controls.navigationContainer + ' { ' + browserProperty('transform', 'translateX(' + controls.closed + 'px)') + ' }}</style>');
		}
	}

	function propertyExists(property) {
		var feature = false,
				domPrefixes = 'Webkit Moz ms O'.split(' '),
				elm = document.createElement('div'),
				propertyCapital = null;

		property = property.toLowerCase();

		if (elm.style[property] !== undefined) {
			feature = true;
		}

		if (feature === false) {
			propertyCapital = property.charAt(0).toUpperCase() + property.substr(1);
			for (var i = 0; i < domPrefixes.length; i++) {
				if (elm.style[domPrefixes[i] + propertyCapital ] !== undefined) {
					property = true;
					break;
				}
			}
		}
		return feature;
	}

	function browserProperty(property, value, valuePrefix) {
		if (typeof valuePrefix === 'undefined')
			valuePrefix = false;

		return 	property + ': ' + value + ';'
				+ '-webkit-' + property + ': ' + ((valuePrefix) ? '-webkit-' : '') + value + ';'
				+ '-moz-' + property + ': ' + ((valuePrefix) ? '-moz-' : '') + value + ';'
				+ '-ms-' + property + ': ' + ((valuePrefix) ? '-ms-' : '') + value + ';'
				+ '-o-' + property + ': ' + ((valuePrefix) ? '-o-' : '') + value + ';';
	}


	// NAVIGATION PLUGIN DEFINITION
	// =====================

	function Plugin(option) {
		return this.each(function () {
			var $this = $(this)
			var options = $.extend({}, $this.data(), typeof object == 'object' && option)

			var data = new Navigation(this, options);
			switch (option) {
				case 'init':
					if (options.navigationControls.actionSkip !== "init") {
						data.init();
					}
					break;
				case 'toggle':
					data.toggle();
					break;
			}
		})
	}

	var old = $.fn.navigation

	$.fn.navigation = Plugin
	$.fn.navigation.Constructor = Navigation


	// NAVIGATION NO CONFLICT
	// ===============

	$.fn.navigation.noConflict = function () {
		$.fn.navigation = old
		return this
	}


	// NAVIGATION DATA-API
	// ============

	var clickHandler = function (e) {
		e.preventDefault()
		Plugin.call($(this), 'toggle')
	}

	var readyHandler = function (e) {
		var els = '[data-navigation-toggle="navigation"]'
		Plugin.call($(els), 'init');
	}

	$(document)
			.on('click.bs.naviagtion.data-api', '[data-navigation-toggle="navigation"]', clickHandler)
			.ready(readyHandler)

}(jQuery);

AndroidFix = window.AndroidFix || {};
AndroidFix.androidNav = (function ($, document) {
	var api = {};
	var navItems = $(".nav-main-link").filter(function () {
		return($(this).find("ul").length !== 0);
	});

	$('.navbar-toggle, .navigation-close').on('click', function() {
		var $trackButton = $('[data-bi-nav-menu-status]'),
			$trackButtonTrackingAttribute = $trackButton.attr('data-bi-nav-menu-status');

		if ($trackButtonTrackingAttribute === 'open') {
			$trackButton.attr('data-bi-nav-menu-status', 'close');
		} else {
			$trackButton.attr('data-bi-nav-menu-status', 'open');
		}
	});

	function handleClick(event)
	{
		if ($('.navbar-toggle').css('display') === "none") {
			navItems.on('click.android-link', '> a', function (e) {
				var linkParent = $(this).parent();
				if (linkParent.hasClass("open")) {
					linkParent.removeClass("open");
				} else {
					navItems.removeClass("open");
					linkParent.addClass('open');
				}
				e.preventDefault();
			});
		} else {
			navItems.off("click.android-link");
		}
	}

	api.init = function () {
		$(document).on({
			ready: function () {
				navItems.addClass('mobile-android-link');
				handleClick();
			}
		});
		$(window).resize(function () {
			handleClick();
		});
	};
	return api;
}($, document));

$(document).ready(function () {
	if (getAndroidVersion()) {
		AndroidFix.androidNav.init();
	}

	if ($(window).width() < 991 && $('.navigation').length > 0) {
		function mobileNavigation() {
			var $menuLink = $('.nav-main-link > a'),
				$menuLinkSubmenu = $menuLink.parent().find('ul'),
				$navigationClose = $('.js-navigation-close'),
				$navigationBack = $('.js-navigation-back');

			$menuLinkSubmenu.attr('style', 'display: block !important');
			$navigationBack.hide();

			$(window).on('resize', function() {
				$menuLinkSubmenu.removeClass('active');
				$navigationBack.hide();

				if ($(window).width < 991) {
					$menuLinkSubmenu.attr('style', 'display: block !important');
				} else {
					$menuLinkSubmenu.attr('style', '');
				}
			});

			$menuLink.on('click', function(event) {
				event.preventDefault();
				var $self = $(this),
					$selfSubmenu = $self.parent().find('ul'),
					selfLink = $self.attr('href');

				if (selfLink.indexOf('all-products') > -1 || selfLink.indexOf('services') > -1
					|| selfLink.indexOf('support') > -1 || selfLink.indexOf('business') > -1
					|| selfLink.indexOf('store#') > -1) {
					$menuLinkSubmenu.removeClass('active');
					$selfSubmenu.addClass('active');
					$menuLinkSubmenu.attr('style', 'display: block !important');
					$navigationBack.show();
				} else {
					window.location = selfLink;
				}

				// $menuLinkSubmenu.attr('style', 'display: none !important');

				// $selfSubmenu.attr('style', 'display: block !important');
			});

			$navigationClose.on('click', function() {
				setTimeout(function() {
					$menuLinkSubmenu.removeClass('active');
					$navigationBack.hide();
				}, 500);
			});

			$navigationBack.on('click', function() {
				$menuLinkSubmenu.removeClass('active');
				$(this).hide();
			});

			// Close navigation if clicked outside of it
			$(document).on('click', function(event) {
				var $clicked = $(event.target);

				// In file 30_optoutbar.js is click triggering when Cookie bar closed. This will prevent script from automatic closing of navigation in condition below this IF.
				if ($clicked.hasClass('cookie-submit-button')) {
					return;
				}

				if ($('.nav-active').length > 0 && $('.navigation').has($clicked).length === 0) {
					$navigationClose.trigger('click');
				}
			});
		}

		mobileNavigation();

		// Bug fix - closed cookie bar causes page to scroll up, but body overflow is hidden when nav opened. Need to scroll to top of the page when navigation closed.
		$(window).on('cookie-bar-closed', function() {
			$(window).scrollTop(0);
		});
	}
});

// nav accessibility
var lastOpenedMenu = null,
	lastOpenedSubMenu = null,
	lastMenuLink = null;

// nodeList not working in IE
try {
	document.querySelectorAll('.nav-main-link').forEach(function(navButton) {
		navButton.addEventListener('keydown', function(e) {
			if (e.which == 13 || e.keyCode == 13) {
				if (navButton.querySelector('ul') !== null && /menu-link/.test(document.activeElement.className)) {
					e.preventDefault();
					expandNav(navButton);
				}
			}
		})
	});
}
catch (err){
}

document.addEventListener('keydown', function(e) {
	if (e.which == 9 || e.keyCode == 9) {
		if (lastMenuLink !== null) {
			if (document.activeElement === lastMenuLink) {
				lastOpenedSubMenu.focus();
			}
		}
	} else if (e.which == 27 || e.keyCode == 27) {
		closeNav();
	}
});

function closeNav() {
	if (lastOpenedMenu !== null) {
		document.querySelector('[aria-expanded=true]') !== undefined ? document.querySelector('[aria-expanded=true]').setAttribute('aria-expanded', false) : '';
		document.querySelector('.navigation .expanded') !== undefined ? document.querySelector('.navigation .expanded').classList.remove('expanded') : '';
		lastOpenedMenu.focus();

		lastOpenedMenu = null;
		lastOpenedSubMenu = null,
		lastMenuLink = null;
	}
}

function expandNav(mainNavItem) {
	var navLink = mainNavItem.querySelector('.menu-link'),
		subMenu = mainNavItem.querySelector('ul.bi-nav-items'),
		linksArray = subMenu.querySelectorAll('a:not(.js-navigation-close)');

	mainNavItem.classList.add('expanded');
	navLink.setAttribute('aria-expanded', true);
	subMenu.setAttribute('tabIndex', -1);
	subMenu.focus();

	lastOpenedSubMenu = subMenu;
	lastOpenedMenu = navLink;
	lastMenuLink = linksArray[linksArray.length - 1];
}

/* ========================================================================
 * Bootstrap: dimension.js v3.0.1
 * ========================================================================
 * Copyright V. Portes 2015
 * ======================================================================== */

+function ($) {



    var Dimension = function (element, event) {
        this.element = $(element);
        this.event = event;
    }

    Dimension.prototype.setFullHeight = function (parent, options) {
        var $this = this.element;
        var height = {};
        var minus_height = 0;
        var m;

        if (typeof options.property === 'undefined')
            options.property = 'height';
        if (typeof options.sizes === 'undefined')
            options.sizes = {};
        if (typeof options.minus === 'undefined')
            options.minus = 0;
        if (typeof options.searchParent === 'undefined')
            options.searchParent = true;
        if (typeof options.outerHeight === 'undefined')
            options.outerHeight = false;

        if (typeof options.minus === 'string') {
            var pattern = new RegExp(/(?:\s([+-])\s)?([.#]?[a-zA-Z\[\]\-=\"\'\{\}:,*]+)/g);
            var sign = '+';
            var visible;
            while ((m = pattern.exec(options.minus)) != null) {
                if (typeof m[1] !== 'undefined') {
                    if (m[1] == '+' || m[1] == '-') {
                        sign = m[1];
                    }
                }
                if (typeof m[2] !== 'undefined') {
                    if ($(m[2]).length > 0) {
                        visible = true;
                        if ($(m[2])) {
                            visible = true;
                        }

                        if (visible) {
                            if (sign == '+') {
                                minus_height = minus_height + $(m[2]).first().outerHeight();
                            } else if (sign == '-') {
                                minus_height = minus_height - $(m[2]).first().outerHeight();
                            }
                        }
                    }
                }
            }
            options.minus = minus_height;
        }

        if (this.event == 'resize') {
            $this.css(options.property, 'auto');
        }

        if (parent === 'window') {
            if (options.outerHeight) {
                height.parent = $(window).outerHeight();
            } else {
                height.parent = $(window).height();
            }
        } else {
            if (options.searchParent) {
                if (options.outerHeight) {
                    height.parent = $this.parents(parent).outerHeight();
                } else {
                    height.parent = $this.parents(parent).height();
                }
            } else {
                if (options.outerHeight) {
                    height.parent = $(parent).outerHeight();
                } else {
                    height.parent = $(parent).height();
                }
            }
        }

        if (Object.keys(options.sizes).length > 0) {
            options.sizes = setSizeList(options.sizes);
            compareSize(
                    options.sizes,
                    function () {
                        $this.css(options.property, height.parent - options.minus);
                    },
                    function () {
                        $this.css(options.property, 'auto');
                    }
            );
        } else {
            $this.css(options.property, height.parent - options.minus);
        }
    }

    Dimension.prototype.setEqualHeights = function (elements) {
        var heights = [];
        var $this = this.element;
        $this.find(elements).css('height', 'auto');
        $.each($this.find(elements), function () {
            heights.push(parseInt($(this).outerHeight()));
        });
        heights.sort(function (a, b) {
            return b - a
        });
        $this.find(elements).css('height', heights[0] + 'px');
    }


    function Plugin(els, event) {
        $.each($(els), function () {
            var data = new Dimension(this, event);
            var options = $.extend({}, $(this).data('dimension-options'), true);
            switch ($(this).data('dimension-action')) {
                case 'fullHeight':
                    var parent = $(this).data('dimension-target');
                    data.setFullHeight(parent, options);
                    break;
                case 'equalHeights':
                    var elements = $(this).data('dimension-target');
                    $.each(elements.split(' | '), function (k, el) {
                        data.setEqualHeights(el);
                    });
                    break;
            }
        });
    }

    var old = $.fn.dimension

    $.fn.dimension = Plugin
    $.fn.dimension.Constructor = Dimension


    // DIMENSION NO CONFLICT
    // ===============

    $.fn.dimension.noConflict = function () {
        $.fn.tab = old
        return this
    }

    // DIMENSION DATA-API
    // ============

    var eventHandler = function (els, event) {
        Plugin(els, event)
    }

    $(window).on('fontsLoaded', function () {
        $(window).load(function () {
            if (!$('body').hasClass('cq-wcm-edit')) {

                eventHandler('[data-dimension-action][data-dimension-target]');

                $(window).resize(function () {
                    eventHandler('[data-dimension-action][data-dimension-target]', 'resize')
                });
                $(window).scroll(function () {
                    eventHandler('[data-dimension-action][data-dimension-target][data-dimension-scroll]')
                });
            }
        });
    });

}(jQuery);

/* ========================================================================
 * Bootstrap: platform.js v3.3.1
 * ======================================================================== */


+function ($) {
    'use strict';

    // PLATFORM PUBLIC CLASS DEFINITION
    // ==============================

    var Platform = function (element) {
        this.$element = $(element);
    };

    Platform.prototype.setAttr = function () {
        var platform = platformDetection(), platforms = this.$element.data('platform'), attribute = this.$element.data('platform-attr');

        platform = platforms[platform];

        if (typeof PriceUtil !== 'undefined' && typeof attribute === 'undefined' || attribute === 'href') {
            platform = PriceUtil.fastAddToCartLink(platform);
        }

        if (typeof attribute === 'undefined') {
            if (platform !== "") {
                this.$element.attr('href', platform);
            }
        } else {
            switch (attribute) {
                case 'class':
                    this.$element.addClass(platform);
                    break;
                case 'style':
                    if (platform instanceof Object) {
                        this.$element.css(platform);
                    }
                    break;
                case 'html':
                    this.$element.html(platform);
                    break;
                case 'text':
                    this.$element.text(platform);
                    break;
                default:
                    this.$element.attr(attribute, platform);
                    break;
            }
        }
    };

    // PLATFORM PLUGIN DEFINITION
    // ========================

    function Plugin(option) {
        return this.each(function () {
            var $this = $(this);
            var data = new Platform($this);
            data.setAttr();
        });
    }

    var old = $.fn.platform;

    $.fn.platform = Plugin;
    $.fn.platform.Constructor = Platform;


    // PLATFORM NO CONFLICT
    // ==================

    $.fn.platform.noConflict = function () {
        $.fn.platform = old;
        return this;
    };


    // PLATFORM DATA-API
    // ===============

    $(document).ready(function () {
        Plugin.call($('[data-platform]'));
    });
    $(document).on("TestAndTargetInit teaserInit", function () {
        Plugin.call($('[data-platform]'));
    });
}(jQuery);

(function ($) {
    $.fn.countdown = function (options, callback) {
        var thisElement = $(this);
        var settings = {
            'date': null,
            'displayDays': false,
            'continuous': false,
            'repeat': null,
            'relative': null,
            'componentCount': null,
            'timeLabel': ""
        };
        if (options) {
            $.extend(settings, options);
        }
        var compCount = settings['componentCount'];
        if (eventDate == null) {
            var eventDate = Date.parse(settings['date']) / 1000;
        }

        var browser = getBrowser();
        if (browser.browser.toLowerCase() === 'msie' && browser.version_rounded < 9 && settings['date'] == "") {
            var relativeEventDate = Math.floor((dateFromISO8601($.cookie(compCount)).getTime()) / 1000);
        } else {
            var relativeEventDate = Math.floor((new Date($.cookie(compCount)).getTime()) / 1000);
        }
        
 
        var relative = settings['relative'];
        var currentDate = Math.floor($.now() / 1000);
        var maxSecs = 99 * 3600 + 99 * 60 + 99; //362439
        var repeat = settings['repeat'] * 1000;
        var continuous = settings['continuous'];
        var jsonCountDown = null;
        var interval = null;
        var countDownHref = null;
        var currentDateSecondLess = currentDate - 1;
        var timeStrings = settings['timeStrings'];


        function countAgain() {
            if (relative != 0) {
                relativeEventDate = relativeEventDate + (2 * 24 * 3600) + repeat / 1000 + 1;
                interval = setInterval(function () {
                    timer(relativeEventDate);
                }, 1000);
            } else {
                eventDate = eventDate + (2 * 24 * 3600) + repeat / 1000 + 1;
                interval = setInterval(function () {
                    timer(eventDate);
                }, 1000);
            }
        }

        function hideAfterDelay() {
            $('.countdown').css('visibility', 'hidden');
            $('.countdown-timer').css('display', 'none');
        }

        // dynamic localization string
       function localization(string, number) {
        var label = "";
            if (string !== undefined) {
                for(key in string){                               
                    if(key.indexOf(number) != -1){
                        label = string[key];
                        break;
                    } else {
                        label = string['other'];
                    }
                }
            }
            return label;
    }

        function change() {            
            // attribute becasue of teaser is loaded after all events
            $('#countdown').attr('data-finish',true);
            $(document).trigger("CountdownFinish");
        }

        function timer() {
            currentDate = Math.floor($.now() / 1000);
            currentDateSecondLess = currentDate - 1;
            if (arguments[0] <= currentDateSecondLess) {
                clearInterval(interval);
                if (continuous == "count" && arguments[0] == currentDateSecondLess) {
                    setTimeout(countAgain, repeat);
                } else if (continuous == "count" && arguments[0] < currentDateSecondLess) {
                    countAgain();
                }
                if (continuous == "change" && arguments[0] == currentDateSecondLess) {
                    change();
                    setTimeout(hideAfterDelay, repeat);
                } else if (continuous == "change" && arguments[0] < currentDateSecondLess) {
                    change();
                } else if (continuous == "change" && arguments[0] - repeat < currentDateSecondLess) {
                    hideAfterDelay();
                }
            } else {
                $('.countdown').css('visibility', 'visible');
                $('.countdown-timer').css('display', 'inline');
                seconds = arguments[0] - currentDate;
                if (settings['displayDays']) {
                    days = Math.floor(seconds / 3600 / 24);
                    seconds -= days * 3600 * 24;
                    console.log(days);
                } else {
                    days= 0;
                }

                hours = Math.floor(seconds / 3600);
                seconds -= hours * 3600;
                minutes = Math.floor(seconds / 60);
                seconds -= minutes * 60;
               

               if (days !== 0) {
                    thisElement.find('.countdown-days, .countdown-hours, .countdown-mins').css('display', 'inline');
                    timeLabel = localization(timeStrings.days, days);
                }
                if (days === 0 && hours !== 0) {
                    thisElement.find('.countdown-hours, .countdown-mins').css('display', 'inline');
                    timeLabel = localization(timeStrings.hours, hours);
                    thisElement.find('.countdown-days').css('display', 'none');
                }
                if (days === 0 && hours === 0 && minutes !== 0) {
                    thisElement.find('.countdown-hours').css('display', 'inline');
                    timeLabel = localization(timeStrings.minutes, minutes);
                    thisElement.find('.countdown-hours, .countdown-days').css('display', 'none');
                }
                if (days === 0 && hours === 0 && minutes === 0 && seconds !== 0) {
                    timeLabel = localization(timeStrings.seconds, seconds);
                    thisElement.find('.countdown-hours, .countdown-days, .countdown-mins').css('display', 'none');
                }
/*
                if (settings['displayDays']) {
                    days = String(days).length >= 2 ? days : "0" + days;
                } else {
                    days = "0";
                }
*/
                days = String(days).length >= 2 ? days : "0" + days;
                hours = String(hours).length >= 2 ? hours : "0" + hours;
                minutes = String(minutes).length >= 2 ? minutes : "0" + minutes;
                seconds = String(seconds).length >= 2 ? seconds : "0" + seconds;

                if (!isNaN(arguments[0])) {
                    if (settings['displayDays']) {
                        thisElement.find(".countdown-main-d1").text(String(days).substr(0, 1));
                        thisElement.find(".countdown-main-d2").text(String(days).substr(1, 1));
                    }
                    thisElement.find(".countdown-main-h1").text(String(hours).substr(0, 1));
                    thisElement.find(".countdown-main-h2").text(String(hours).substr(1, 1));
                    thisElement.find(".countdown-main-m1").text(String(minutes).substr(0, 1));
                    thisElement.find(".countdown-main-m2").text(String(minutes).substr(1, 1));
                    thisElement.find(".countdown-main-s1").text(String(seconds).substr(0, 1));
                    thisElement.find(".countdown-main-s2").text(String(seconds).substr(1, 1));
                    thisElement.find(".count-timeString").text(timeLabel);
                } else {
                    clearInterval(interval);
                }
            }
        }

        if (relative != 0) {
            timer(relativeEventDate);
            interval = setInterval(function () {
                timer(relativeEventDate);
            }, 1000);
        } else {
            timer(eventDate);
            interval = setInterval(function () {
                timer(eventDate);
            }, 1000);
        }
    }
})(jQuery);
$(document).ready(function () {
    'use strict';
    var avgGeneral = avgGeneral || {};
    avgGeneral.avgAccordion = function (options) {
        var settings = $.extend({
            wrapper: null,
            area: null,
            button: null
        }, options || {});

        $(settings.button).click(function (e) {
            e.preventDefault();
            var $parent = $(this).parent();
            var $area = $(this).closest(settings.wrapper).find(settings.area);
            $area.slideToggle('slow', function () {
                if ($area.css('display') === "block") {
                    $parent.removeClass('see-details');
                    $parent.addClass('hide-details');
                } else {
                    $parent.removeClass('hide-details');
                    $parent.addClass('see-details');
                }
            });
            var caption = $(this).text();
            var readMore = $(this).attr('data-readmore');
            var readLess = $(this).attr('data-readless');
            $(this).text((caption === readMore) ? readLess : readMore);
        });
    };

    if ($('.comparison-column-content').length > 0) {
        avgGeneral.avgAccordion({
            wrapper: ".comparison-column-content",
            area: ".features-list",
            button: ".features-list-btn"
        });
    }

});
+function ($) {
    'use strict';

    // FOOTER PUBLIC CLASS DEFINITION
    // ==============================

    var Footer = function (element, options) {
        this.$element = $(element);
        this.options = $.extend({}, options);
        this.objectSizes = {'xs': true, 'sm': true, 'md': false, 'lg': false};
    };

    Footer.prototype.setState = function (elm) {       
        compareSize(
                this.objectSizes,
                function () {
                    elm.addClass('clickable');
                    elm.find('.footer-links-content').hide();
                    elm.removeClass('active-column');
                },
                function () {
                    elm.removeClass('active');
                    elm.find('.footer-links-content').show();
                    elm.removeClass('active-column');
                }
        );
    };

    Footer.prototype.toggle = function (elm) {
        elm.find('.footer-links-content').slideToggle('fast');
        elm.toggleClass('active-column');
    };

    /*
     // FOOTER PLUGIN DEFINITION
     // ========================
     */

    function Plugin(option) {
        return this.each(function () {
            var $this = $(this);
            var data = $this.data('bs.footer');
            var options = typeof option === 'object' && option;

            if (!data)
                $this.data('bs.footer', (data = new Footer(this, options)));

            if (option === 'toggle'){
                data.toggle($this);
            } else if (option){
                data.setState($this);
            }
        });
    }

    var old = $.fn.footer;

    $.fn.footer = Plugin;
    $.fn.footer.Constructor = Footer;


    // FOOTER NO CONFLICT
    // ==================

    $.fn.footer.noConflict = function () {
        $.fn.footer = old;
        return this;
    };

    var clickHandler = function (e) {        
        e.stopPropagation();        
        Plugin.call($(this), 'toggle');
    };

    var readyHandler = function (e) {
        var els = '[data-footer="toggle"]';
        Plugin.call($(els), 'setState');
    };

    $(document)
            .on('click.bs.footer.data-api', '.footer-links.clickable', clickHandler)
            .ready(readyHandler);

    $(window).resize(function () {
        waitForFinalEvent(function () {
            readyHandler();
        }, 100, "footer-resize");
    });

}(jQuery);
+function ($AVG) {
    'use strict';
    // DRUTILS OPTIONS PUBLIC CLASS DEFINITION
    // ================================
    var DRUtils = function (element, options) {
        this.link = $AVG(element);
        this.options = options;
        this.params = ['A', 'T', 'Z'];
        this.paramsName = {
            'ACCOUNTID': ['ACCID', 'ZID'], // ACCID ~ AV|PCT account ID, ZID ~ Zen ID; GUID (Globally Unique Identifier)
            'LICENSETYPE': ['LT', 'LICTYPE', 'APPAV', 'APPTU'], // https://confluence.cz.avg.com/display/ZENCOE/Application+Params+URL
        };
        this.paidLicenseTypes = /%4%|%P%|LTfull/i; // AV and TU return license type "4" or "P", Zen returns license type for both (APPAV and APPTU)
        this.replacements = [
            {
                pattern: /\/buy\//i,
                replace: '/buysaf/',
            },
            {
                pattern: /$/,
                replace: '/AVGAccountIDIdentifiedFlow.%ACCOUNTID%/IdentifiedFlowPaidRenewals.%LICENSETYPE%',
            },
        ];
    };

    DRUtils.prototype.init = function () {
        this.replaceLink();
    };

    DRUtils.prototype.countdown = function () {
        this.replaceLink();
    };

    DRUtils.prototype.replaceLink = function () {
        var url = this.link.attr('href'),
            data,
            i;

        // get data from URL or cookie
        data = this.getDataFromURL() || this.getDataFromCookie();

        if (data) {
            if(url.indexOf('IdentifiedFlowPaidRenewals') !== -1) {
                url = url.replace(/\/(AVGAccountIDIdentifiedFlow|IdentifiedFlowPaidRenewals)[^\/]+/g,'');
            }

            // change URL
            for (i = 0; i < this.replacements.length; i++) {
                url = url.replace(this.replacements[i].pattern, this.replacements[i].replace);
            }
            // apply data
            $AVG.each(data, function(key, value) {
                var regexp = new RegExp('%' + key + '%', 'g');
                url = url.replace(regexp, value);
            });
            this.link.attr('href', url);
        }
    };

    DRUtils.prototype.getDataFromURL = function () {
        var paramsURL = window.location.search.substring(1).split('&');

        return this.getAccountLicense(this.getParam(paramsURL, this.params));
    };

    DRUtils.prototype.getDataFromCookie = function() {
        var r = false,
            i;

        for (i = 0; i < this.params.length; i++) {
            r = this.getAccountLicense($AVG.cookie('app-param-' + this.params[i]) || ''); // due undefined cookie
            if (r) {
                return r;
            }
        }
        return false;
    };

    DRUtils.prototype.getAccountLicense = function(encodedParams) {
        var params = this.decodeBase64(encodedParams).split(' '),
            accountID = this.getParam(params, this.paramsName.ACCOUNTID),
            licenseType = '',
            i;


        if (this.isValidGUID(accountID)) {
            // join all possible license to string (due ZEN)
            for (i = 0; i < this.paramsName.LICENSETYPE.length; i++) {
                licenseType += '%' + this.getParam(params, [this.paramsName.LICENSETYPE[i]]) + '%';
            }
            return {
                'ACCOUNTID': accountID,
                'LICENSETYPE': licenseType.match(this.paidLicenseTypes) !== null, // paid = true, others = false
            }
        }
        return false;
    };

    DRUtils.prototype.getParam = function(params, param) {
        var pair = '',
            i;

        for (i = 0; i < params.length; i++) {
            pair = params[i].split('=');
            if (param.indexOf(pair[0].toUpperCase()) !== -1 && pair[1].length) {
                return pair[1];
            }
        }
        return false;
    };

    DRUtils.prototype.isValidGUID = function (guid) {
        var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
        return regexGuid.test(guid);
    };

    DRUtils.prototype.decodeBase64 = function(s) {
        var e = {}, i, b = 0, c, l = 0, a, r = '', w = String.fromCharCode, L = s.length,
            A = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

        for (i = 0; i < 64; i++) {
            e[A.charAt(i)] = i;
        }

        for(i = 0; i < L; i++) {
            c = e[s.charAt(i)];
            b = (b<<6)+c;
            l += 6;
            while( l>=8 ) {
                ((a=(b>>>(l-=8))&0xff)||(i<(L-2)))&&(r+=w(a));
            }
        }
        return r;
    };

    // DRUtils PLUGIN DEFINITION
    // =======================
    function Plugin(option) {
        return this.each(function () {
            var $this = $AVG(this);
            var data = $this.data('drutils.link');
            var options = $AVG.extend({}, $this.data(), typeof object == 'object' && option);
            if (!data) {
                $this.data('drutils.link', (data = new DRUtils(this, options)));
            }
            switch (option) {
                case 'init':
                    data.init();
                    break;
                case 'countdown':
                    data.countdown();
                    break;
            }
        });
    };

    var old = $AVG.fn.DRUtils;
    $AVG.fn.DRUtils = Plugin;
    $AVG.fn.DRUtils.Constructor = DRUtils;
    // DRUtils NO CONFLICT
    // =====================
    $AVG.fn.DRUtils.noConflict = function () {
        $AVG.fn.DRUtils = old;
        return this;
    };

    var els = 'a[href*="shop.avg.com/store"]'; // selector was changed because we can't set class '.dr-store-link';

    var countdown = function (e) {
        Plugin.call($AVG(els), 'countdown');
    };

    var readyHandler = function (e) {
        Plugin.call($AVG(els), 'init');
    };

    $AVG(document)
        .on('TestAndTargetInit teaserInit drLinkChange', readyHandler)
        .on('CountdownFinish', countdown)
        .ready(readyHandler);

}(jQuery);

/** 
 * @version 1.0
 * @author Michal Pribila
 */
+function ($AVG) {
    'use strict';

    // FOOTER PUBLIC CLASS DEFINITION
    // ==============================

    var Button = function (element, options) {
        this.$element = $AVG(element);
        this.options = $AVG.extend({}, options);
    };

    /**
     * Swap button after countdown change
     * @param {Object} elm     
     */
    Button.prototype.countdown = function (elm) {

        // if outer div exist change classes
        var outerDiv = $(elm).parent('[data-countdownClass]');
        if (outerDiv.length > 0) {
            outerDiv.attr('class', outerDiv.attr('data-countdownClass'));
        }
        elm.next("a").remove();
        elm.removeClass('countdownBtnChange');
        // swap platform attributes to avoid overwrite by other scripts
        if (typeof (elm.data('platform')) !== "undefined") {
            elm.data('platform', elm.data('countdown-platform'));
            var platform = elm.data('platform')[platformDetection()];
            if (typeof PriceUtil !== 'undefined') {
                platform = PriceUtil.fastAddToCartLink(platform);
            }
            elm.attr('href', platform);
        }
    };

    /*
     // FOOTER PLUGIN DEFINITION
     // ========================
     */

    function Plugin(option) {
        return this.each(function () {
            var $this = $AVG(this);
            var data = $this.data('bs.button');
            var options = typeof option === 'object' && option;

            if (!data)
                $this.data('bs.button', (data = new Button(this, options)));

            if (option === 'countdown') {
                data.countdown($this);
            }
        });
    }

    var old = $AVG.fn.button;

    $AVG.fn.button = Plugin;
    $AVG.fn.button.Constructor = Button;


    // FOOTER NO CONFLICT
    // ==================

    $AVG.fn.button.noConflict = function () {
        $AVG.fn.button = old;
        return this;
    };

    var countdown = function (e) {
        var els = 'a.countdownBtnChange';
        Plugin.call($AVG(els), 'countdown');
    };

    $AVG(document).on('CountdownFinish', countdown);
}(jQuery);
$(document).ready(function () {
    $('.dropdown-links').on('change', function () {
        if (this.selectedIndex !== 0) {
            window.location.href = encodeURI(this.value);
        }
    });
});
+ function($AVG) {
    'use strict';

    /**
     * @author Michal Pribila
     * @version 1.0
     */

    // BOXFILTER CLASS DEFINITION
    // ======================
    var BoxFilter = function(element, options) {
        this.options = $AVG.extend({}, options);
        this.$element = $AVG(element);
        this.$boxes = this.$element.find('.filter-box');
        this.urlBoxesLimit = getQueryVariable('boxes');
        this.breakpointItems = parseInt(this.breakpointLimits());
        this.persistUrlFilter = []; // filter from URL which cannot be changed by any filter on the page
        this.allFilters = $AVG('.filtering .input-filter').map(function() {
            return this.name + "=" + this.value;
        }).get();
    };

    BoxFilter.DEFAULTVISIBLE = 1000;
    BoxFilter.SEE_MORE = 'see-more';
    BoxFilter.SEE_MORE_PRODUCTS = 'see-more-products';
    BoxFilter.NO_PRODUCTS = 'no-products';
    BoxFilter.FILTER_RESULTS = 'filter-results';
    BoxFilter.HIDDEN = 'hidden';
    BoxFilter.EQUALIZE_BOXES = 'equalize-boxes';

    BoxFilter.prototype.init = function() {
        this.displayBoxes();
    };

    BoxFilter.prototype.equalizeBoxes = function() {        
        var allContentWrapper = this.$boxes.find('.filter-box-header, .feature-list-wrapper, .bottom-wrapper');
        if (breakpointKey() !== 'xs' && breakpointKey() !== 'sm') {            
            var filterBoxesHidden = this.$element.find('.filter-box').filter(function() {                
                return $(this).is('.' + BoxFilter.HIDDEN);
            });
            
            var filterHeader = this.$boxes.find('.filter-box-header');
            var filterMiddle = this.$boxes.find('.feature-list-wrapper');
            var filterBottom = this.$boxes.find('.bottom-wrapper');

            allContentWrapper.css('height','');
            filterBoxesHidden.removeClass(BoxFilter.HIDDEN);
            filterHeader.equalizeHeights();
            filterMiddle.equalizeHeights();
            filterBottom.equalizeHeights();
            filterBoxesHidden.addClass(BoxFilter.HIDDEN);
        } else {            
            allContentWrapper.css('height','auto');
        }
    };

    /*
     * Check if array contains value
     * @return {Int} number
     */
    BoxFilter.prototype.findNextNumber = function(number, array) {
        number++;
        var idx = array.indexOf(number);
        while (idx !== -1) {
            number++;
            idx = array.indexOf(number, idx + 1);
        }
        return number;
    };

    // add current filter to URL as hash
    BoxFilter.prototype.addFilterToUrl = function() {
        var urlQuery = window.location.hash.toString().split('?');
        window.location.hash = this.filterFromInputs().concat(this.persistUrlFilter).join('&') + (typeof urlQuery[1] !== 'undefined' ? '?' + urlQuery[1] : '');
    };

    /*
     * Basic setting for filter
     * 
     */
    BoxFilter.prototype.setting = function(option) {
        // setup new filter only after changing filter by checkbox or on load page
        var productResult = this.$element.find('.filter-results');
        productResult.css('min-height', productResult.height());
        if (option !== BoxFilter.SEE_MORE) {
            // return elements to load state before ordering
            this.$boxes.addClass(BoxFilter.HIDDEN).css('order', '');
            this.currentFilter = this.adjustFilter(option === 'init' ? this.filterFromQuery() : this.filterFromInputs().concat(this.persistUrlFilter));
            if (this.currentFilter.length > 0) {
                // return array of filtered product
                this.filteredArray = this.filteredBoxes();
                // return sortered array by data-order attribute
                this.sortedArray = this.reorder();
            }
        }
    };

    /**
     * get all selected checkboxes names and values 
     * @returns {Array} filter;
     */
    BoxFilter.prototype.filterFromInputs = function() {
        return $AVG('.input-filter:checked').map(function() {
            return this.name + "=" + this.value;
        }).get();
    };

    /**
     * if URL parameter match filter checkbox add to filter and change checked value
     * @returns {Array} filter;
     */
    BoxFilter.prototype.filterFromQuery = function() {
        var urlQuery = window.location.hash;
        if (urlQuery.indexOf('?')) {
            var urlQueryParse = urlQuery.split('?');
            urlQuery = urlQueryParse[0];
        }
        var windowHash = urlQuery.indexOf('=') !== -1 ? urlQuery.replace('#', '').split('&') : '';
        var $checkboxes = 0,
            filter = [],
            $this = this;
        if (windowHash.length > 0) {
            windowHash.forEach(function(item) {
                item = item.split('=');
                $checkboxes = $AVG('.input-filter[name=' + item[0].replace('!', '') + '][value=' + item[1] + ']');

                if ($checkboxes.length === 0) {
                    $this.persistUrlFilter.push(item[0] + '=' + item[1]);
                }
                if (item[0].indexOf('!') === -1 && $checkboxes.length > 0) {
                    $checkboxes.prop('checked', true);
                }

                filter.push(item[0] + '=' + item[1]);
            });
        }
        return filter;
    };

    /**
     * Adjust array for matching all boxes with data attributes and values
     * @param {Array} array
     * @returns {Array} filter;
     */
    BoxFilter.prototype.adjustFilter = function(array) {
        var filter = array.map(function(item) {
            if (item.indexOf('!=') !== -1) {
                item = item.split('!=');
                return ".filter-box:not([data-" + item[0] + "~=" + item[1] + "])";
            } else {
                item = item.split('=');
                return "[data-" + item[0] + "~=" + item[1] + "]";
            }
        });
        return filter;
    };

    /**
     * Return number based on breakpoint (xs,sm,md,lg) and default displayed items for each breakpoint
     * @return {Int}
     */
    BoxFilter.prototype.breakpointLimits = function() {
        // setup limit by URL parameter 'boxes' for all and call it only once        
        if (this.urlBoxesLimit && !this.urlLimitSetup) {
            if (this.urlBoxesLimit === 'all') {
                this.urlLimitSetup = BoxFilter.DEFAULTVISIBLE;
            } else if (/^\d+$/.test(this.urlBoxesLimit)) {
                this.urlLimitSetup = parseInt(this.urlBoxesLimit);
            } else {
                this.urlLimitSetup = this.options.showItems[breakpointKey()];
            }
        }

        // check if limit by URL is already initiazized
        if (this.urlBoxesLimit && this.urlLimitSetup) {
            return this.urlLimitSetup;
        } else {
            return this.options.showItems[breakpointKey()];
        }
    };

    /**
     * Reset visible filter do default after filtering
     */
    BoxFilter.prototype.setDefaultItems = function() {
        this.breakpointItems = parseInt(this.breakpointLimits());
    };

    /**
     * Reorder boxes to keep boxes with "override order" property in same positon after filtering
     * @param {Object} object description
     * @return {Object} description
     */
    BoxFilter.prototype.reorder = function(object) {
        var $this = this;
        // array of boxes without override order
        var boxesWithoutOrder = this.filteredArray.filter(function() {
            return !$(this).data('order');
        });

        // get array of override order numbers
        var orderArray = this.filteredArray.map(function() {
            $AVG(this).css('order', $AVG(this).data('order'));
            return $AVG(this).data('order');
        }).get();

        // flexbox init order value
        var orderNumber = 0;

        // add order to all elements
        boxesWithoutOrder.each(function(index) {
            orderNumber++;
            // skip override order numbers
            if (isInArray(orderNumber, orderArray)) {
                // return next following number which is not in array
                orderNumber = $this.findNextNumber(orderNumber, orderArray);
            }
            $(this).attr('data-reorder', orderNumber);
            $(this).css('order', orderNumber);
        });

        // sort array by reorder attribute
        return this.filteredArray.sort(function(a, b) {
            return parseInt($AVG(a).data('reorder')) - parseInt($AVG(b).data('reorder'));
        });
    };

    /**
     * Return boxes filtered by multiple filters
     * @return {Object}
     */
    BoxFilter.prototype.filteredBoxes = function() {
        return this.$boxes.filter(this.currentFilter.join(""));
    };

    BoxFilter.prototype.displayBoxes = function() {
        var displayed, boxesNumber, showMore, sortedArrayIE, $filterResultsIE;
        var $seeMoreProducts = this.$element.find('.' + BoxFilter.SEE_MORE_PRODUCTS);
        var $noProducts = this.$element.find('.' + BoxFilter.NO_PRODUCTS);

        if (this.currentFilter.length > 0) {
            // show only boxes by breakpoint setting
            displayed = this.sortedArray.slice(0, this.breakpointItems);
            boxesNumber = this.filteredArray.length;
        } else {
            // show only boxes by breakpoint setting
            displayed = this.$boxes.slice(0, this.breakpointItems);
            boxesNumber = this.$boxes.length;
        }

        // IE9 fix for re-ordering elements and keep overrided order elements on same place
        if (getBrowser().browser === 'MSIE' && getBrowser().version_rounded <= 9) {
            $filterResultsIE = this.$element.find('.filter-results-ie');
            if (this.currentFilter.length > 0) {
                // clone element to remove reference
                sortedArrayIE = this.sortedArray.clone();
                displayed = sortedArrayIE.slice(0, this.breakpointItems);
                showMore = this.$element.find('.' + BoxFilter.FILTER_RESULTS + ' .last-in-order').clone();
                this.$element.find('.' + BoxFilter.FILTER_RESULTS).addClass(BoxFilter.HIDDEN);
                $filterResultsIE.removeClass(BoxFilter.HIDDEN);
                $filterResultsIE.html(sortedArrayIE);
                // add see more and message div after replace boxes
                if (this.$element.find('.filter-results-ie .last-in-order').length === 0) {
                    $filterResultsIE.append(showMore);
                }
            } else {
                this.$element.find('.' + BoxFilter.FILTER_RESULTS).removeClass(BoxFilter.HIDDEN);
                $filterResultsIE.addClass(BoxFilter.HIDDEN);
            }
        }

        // show all filtered boxes
        displayed.removeClass(BoxFilter.HIDDEN);

        // clear inline css for auto height value
        this.$element.find('.filter-results').css('min-height', '');
        boxesNumber <= this.breakpointItems ?
            $seeMoreProducts.addClass(BoxFilter.HIDDEN) :
            $seeMoreProducts.removeClass(BoxFilter.HIDDEN);

        // show|hide empty filter message
        boxesNumber === 0 ?
            $noProducts.removeClass(BoxFilter.HIDDEN) :
            $noProducts.addClass(BoxFilter.HIDDEN);

    };

    /**
     * Update variable to see next set of boxes after see-more-product button
     * @param {String} option description
     */
    BoxFilter.prototype.seeMore = function(option) {
        this.breakpointItems += parseInt(this.breakpointLimits());
        this.displayBoxes(option);
    };

    // BOXFILTER PLUGIN DEFINITION
    // =======================

    function Plugin(option) {
        return this.each(function() {
            var $this = $AVG(this);
            var data = $this.data('bs.boxfilter');
            var options = $AVG.extend({}, $this.data());
            if (!data)
                $this.data('bs.boxfilter', (data = new BoxFilter(this, options)));

            try {
                if (option !== BoxFilter.EQUALIZE_BOXES) {
                    data.setting(option);
                }

                switch (option) {
                    case 'filter':
                        // skip setup default items if URL contains boxes param                    
                        data.setDefaultItems();
                        data.displayBoxes();
                        data.addFilterToUrl();
                        break;
                    case BoxFilter.SEE_MORE:
                        data.seeMore(option);
                        break;
                    case BoxFilter.EQUALIZE_BOXES:
                        data.equalizeBoxes();
                        break;
                    default:
                        data.init();
                }
            } catch (e) {
                // todo add log to new relic
            }

        });
    }

    var old = $AVG.fn.boxfilter;

    $AVG.fn.boxfilter = Plugin;
    $AVG.fn.boxfilter.Constructor = BoxFilter;

    // BOXFILTER NO CONFLICT
    // =================

    $AVG.fn.boxfilter.noConflict = function() {
        $AVG.fn.boxfilter = old;
        return this;
    };

    // BOXFILTER DATA-API
    // ==============

    $AVG(document).ready(function() {
        Plugin.call($AVG('[data-filterbox]'), 'init');

        // set height from  highest span because of hover effect
        $AVG('.filtering .platforms-filter').each(function(e) {
            var $inputSpan = $AVG(this).find('.input-text span');
            $inputSpan.css('position', 'static');
            $AVG(this).find('.input-text').height($inputSpan.getHighestElement());
            $inputSpan.css('position', 'absolute');
        });

        $AVG('.filtering').on('click', '.input-filter', function() {
            // only one checkbox can be selected at the same time
            $AVG(this).parents('.button-group').find('.input-filter').not($AVG(this)).prop('checked', false);
            Plugin.call($AVG('[data-filterbox]'), 'filter');
        });

        $AVG('[data-filterbox]').on('click', '.' + BoxFilter.SEE_MORE_PRODUCTS, function(e) {
            Plugin.call($AVG('[data-filterbox]'), BoxFilter.SEE_MORE);
        });

        // add element to fix IE9 centering tables
        if (getBrowser().browser === 'MSIE' && getBrowser().version_rounded <= 9) {
            $AVG('.filtering .categories-filter .input-wrapper').wrapAll('<div class="fixCenteringIE"></div>');
        }
    });

    // equal heights for header, list-wrapper and bottom
    $AVG(window).on('fontsLoaded', function() {
        $AVG(window).load(function() {
            Plugin.call($AVG('[data-filterbox]'), BoxFilter.EQUALIZE_BOXES);
        });
    });

    $AVG(window).resize(function () {
        waitForFinalEvent(function () {
            Plugin.call($AVG('[data-filterbox]'), BoxFilter.EQUALIZE_BOXES);
        }, 500);
    });
}(jQuery);

var bGraph2 = {
    GRAPH_CLASS: "graph-responsive",
    FIXED_TITLE_CLASS: "fixed-title",
    GRAPH_ANIMATE_CLASS: "graph-animate",

    /**
     * Set in which sizes should be graph animated.
     * true => animate, false => don't animate
     */
    options: {
        animationSizes: {
            'xs': false,
            'sm': false,
            'md': true,
            'lg': true
        }
    },

    /**
     * Checks whether the graph is visible by user and run animation if it is.
     */
    animation: function() {
        $AVG("." + this.GRAPH_CLASS).each(function() {
            var graph = $AVG(this);

            if(!graph.visible()) {
                // Add class that will run animation after its removing
                $AVG(graph).addClass(bGraph2.GRAPH_ANIMATE_CLASS);

                // Bind "remove animate class" after graph is visible
                $AVG(window).on("scroll resize", function() {
                    if (graph.visible(false, false, "vertical-bottom")) {
                        graph.removeClass(bGraph2.GRAPH_ANIMATE_CLASS);
                    }
                });
            }
        });
    },
};

/**
 * On document ready, check user's resolution and compare with graph animationSizes option
 */
$AVG(document).ready(function() {
    compareSize(
        bGraph2.options.animationSizes,
        function() {
            bGraph2.animation();
        },
        function() {}
    );
});
+function ($AVG) {
    'use strict';

    /**
     * @author Michal Pribila
     * @version 1.0
     */

    // LOCATOR CLASS DEFINITION
    // ======================

    var Locator = function (element, options) {
        this.options = $AVG.extend({}, options);
        this.$element = $AVG(element);
        this.akamaiData = {};
        this.ipAdress = this.$element.find('.ip-address');
        this.city = this.$element.find('.city');
        this.country = this.$element.find('.country');
        this.timeZone = this.$element.find('.time-zone');
        this.browser = this.$element.find('.browser');
        this.device = this.$element.find('.device');
        this.cookies = this.$element.find('.cookies');
        this.mapCanvas = this.$element.find('.tracking-map');        
        if (this.cookies.length > 0) {
            this.cookieEnabled = (navigator.cookieEnabled) ? this.cookies.data('cookies').YES : this.cookies.data('cookies').NO;
        } else {
            this.cookieEnabled = '';
        }
        this.browserObj = getBrowser();
        this.browserName = this.browserObj.browser + ' ' + this.browserObj.version_rounded;
        this.initLocator();
    };

    Locator.prototype.initLocator = function () {
        this.getAkamai();
    };

    /**
     * Parse string and fill akamaiData object
     * @param {String} str
     */
    Locator.prototype.parseString = function (str) {
        if (str.indexOf(',') !== -1) {
            var vars = str.split(',');
            for (var i = 0; i < vars.length; i++) {
                if (vars[i].indexOf('=') !== -1) {
                    var pair = vars[i].split('=');
                    this.akamaiData[pair[0]] = pair[1];
                }
            }
        }
    };
    /**
     * Get akamai headers
     * Akamai data are available only in production. For testing in proxy have to be
     * added query parameter: akamai_geo_header=country_code=CZ,city=PRAGUE,...
     */
    Locator.prototype.getAkamai = function () {
        var $this = this;
        $AVG.ajax({
            type: 'GET',
            url: document.location,
            success: function (data, status, xhr) {
                var akamaiHeader = (xhr.getResponseHeader('X-Akamai-Edgescape'));
                // True-Client-IP is available only in production
                var clientIP = (xhr.getResponseHeader('True-Client-IP'));
                if (akamaiHeader) {
                    $this.parseString(akamaiHeader);
                    if ($this.akamaiData['lat'] && $this.akamaiData['long']) {
                        $this.trackingMap($this.akamaiData['lat'], $this.akamaiData['long']);
                    }
                    if ($this.akamaiData['country_code']) {
                        // get country object from coutries clientlib
                        var countryObj = searchArray(countriesJSON(), "alpha2Code", $this.akamaiData['country_code']);
                        $this.akamaiData['country_name'] = countryObj.nativeName;
                    }
                }
                if (clientIP) {
                    $this.akamaiData['ip_address'] = clientIP;
                }
                $this.setHTML();
            }
        });
    };

    Locator.prototype.setHTML = function () {
        this.ipAdress.html(this.akamaiData['ip_address']);
        this.city.html(this.akamaiData['city']);
        this.country.html(this.akamaiData['country_name']);
        this.timeZone.html(this.akamaiData['timezone']);
        this.browser.html(this.browserName);
        this.device.html(getOS());
        this.cookies.html(this.cookieEnabled);
    };

    /**
     * Create google map by latitude and longitude
     * @param {String} lat latitude
     * @param {String} lng longitude
     */
    Locator.prototype.trackingMap = function (lat, lng) {
        var mapOptions = {
            center: new google.maps.LatLng(lat, lng),
            zoom: 10,
            scrollwheel: false,
            draggable: false,
            disableDefaultUI: true,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        },
        map = new google.maps.Map(this.mapCanvas[0], mapOptions);

        return {
            init: function () {
                map.set('styles', [{
                        featureType: 'landscape',
                        elementType: 'geometry',
                        stylers: [
                            {hue: '#ffff00'},
                            {saturation: 30},
                            {lightness: 10}
                        ]}
                ]);
            }
        };
    };

    // LOCATOR PLUGIN DEFINITION
    // =======================

    function Plugin(option) {
        return this.each(function () {
            var $this = $AVG(this);
            var data = $this.data('bs.locator');
            var options = typeof option === 'object' && option;

            if (!data)
                $this.data('bs.locator', (data = new Locator(this, options)));
            if (typeof option === 'string')
                data[option]();
        });
    }

    var old = $AVG.fn.locator;

    $AVG.fn.locator = Plugin;
    $AVG.fn.locator.Constructor = Locator;

    // LOCATOR NO CONFLICT
    // =================

    $AVG.fn.locator.noConflict = function () {
        $AVG.fn.locator = old;
        return this;
    };

    // LOCATOR DATA-API
    // ==============

    $AVG(document).ready(function () {
        Plugin.call($AVG('[data-locator]'));
    });

}(jQuery);
+function ($AVG) {
    'use strict';
    // SHOPBOXWITH OPTIONS PUBLIC CLASS DEFINITION
    // ================================
    var shopbox2 = function (element, options) {
        this.shopbox = $AVG(element);
        this.options = options;
        this.button = this.shopbox.find('.button');        
        this.initialized = false;
        this.businessDesign = this.shopbox.hasClass('business') && this.options.sellbox !== "undefined";
    };

    shopbox2.prototype.init = function () {
        // avoid initialize more times by teaser or mbox
        if (!this.initialized) {
            if(this.shopbox.find('.subscription-wrapper input[type=radio]:checked').length === 0){
                this.shopbox.find('.subscription-wrapper input[type=radio]').first().attr('checked', true).change();
            }
            this.selectedInputValue = this.shopbox.find('input:checked').val();            
            if (this.options.sellboxOptions) {
                var YEAR_PRICE_SELECTOR = ".year-price",
                    YEAR_PRICE_NAME = "orgPrice",
                    WAS_PRICE_SELECTOR = ".wasPrice",
                    WAS_PRICE_NAME = "wasPrice",
                    COMBINE_DISCOUNT_SELECTOR = ".percent",
                    COMBINE_DISCOUNT_NAME = "percent";
                this.sellbox = this.options.sellboxOptions;
                
                this.productCode = Object.keys(this.sellbox)[0].split('-'); 
                this.keys = this.options.keys; 
                // get validity e.g. 12m, 24m
                this.validityMonthsKeys = this.options.maintenances.split(',');
                this.shopboxWrapper = this.shopbox.parents('.bshopbox2-wrapper');
                this.errMessage = $AVG('.error-message');
                this.priceType = 'realPriceFormatted';
                this.priceListPriceType = 'priceFormatted';
                this.selectedPC = this.options.selectedpc;
                // select default option by user input or predefined option
                this.selectedOption = this.keys[0];
                if (typeof this.selectedPC !== "undefined") {
                    this.selectedOption = closestHigherNumber(this.keys, this.options.selectedpc);
                } else if (this.shopbox.find('option:selected').length > 0) {
                    this.selectedOption = this.shopbox.find('option:selected').val();
                }
                this.exterlnalRefID = this.sellbox[this.setProductCode()]['link'];                 
                this.shopboxHtmlElements = {};
                for (var i = 0; i < this.validityMonthsKeys.length; i++) {
                    this.createHtmlElementsVariable(YEAR_PRICE_SELECTOR, YEAR_PRICE_NAME, i);
                    this.createHtmlElementsVariable(WAS_PRICE_SELECTOR, WAS_PRICE_NAME, i);
                    this.createHtmlElementsVariable(COMBINE_DISCOUNT_SELECTOR, COMBINE_DISCOUNT_NAME, i);
                }

                if (typeof this.options.sellboxCountdown !== "undefined" && this.options.sellboxCountdown) {
                    this.sellboxCountdown = this.options.sellboxCountdown.sellbox;
                }
            }

            if (this.businessDesign) {
                this.dropdownOptions = this.shopbox.find(".options li:not(.val-customComputers)");
                this.dropdownSelectOptions = this.shopbox.find("option:not(option[value=customComputers])");
                this.seats = [];
                for (i = 0; i < this.dropdownSelectOptions.length; i++) {
                    this.seats[$AVG(this.dropdownSelectOptions[i]).val()] = $AVG(this.dropdownSelectOptions[i]).text();
                }
                if (this.options.predefineComputers) {
                    this.hideDropdownOptions();
                }
                this.updateDropdownSale();
                this.updatePrices(this.selectedOption);
            } else {
                this.setExternalRefId(this.shopbox.find('input:checked'));
            }

            this.updateRadio(this.selectedInputValue);
            this.updateButton();
            this.provider = this.button.attr('href').indexOf('addtocart') !== -1 ? "INHOUSE" : "DR";
            this.tracking();
            if (this.businessDesign){ this.placeholders(); }
            this.initialized = true;
        }
    };
    /**
     * Helper method to create variable to connect html element with validity (e.g.12m)
     * @param {string} selector
     * @param {string} elmName
     * @param {number} index
     */
    shopbox2.prototype.createHtmlElementsVariable = function (selector, elmName, index) {
        try {
            if (this.shopbox.find(selector + this.validityMonthsKeys[index]).length > 0) {
                var name = elmName + this.validityMonthsKeys[index];
                this.shopboxHtmlElements[name] = this.shopbox.find(selector + this.validityMonthsKeys[index]);
                this.shopboxHtmlElements[name]['validity'] = this.validityMonthsKeys[index];
                this.shopboxHtmlElements[name]['type'] = elmName;
            }
        } catch (e) {
            // todo: add new relic notification
        }
    };
    /**
     * Get all keys from object
     * @param {Object} json
     */
    shopbox2.prototype.getKeys = function (json) {
        var keys = [];
        for (var o in json) {
            keys.push(o); // the property name
        }
        return keys;
    };
    /**
     * Update prices in options based on VAT set in data element
     * @param {number} selected
     */
    shopbox2.prototype.updatePrices = function (selected) {
        var sellbox = this.sellbox, price, wasPrice, current;
        this.productCode[2] = ('000' + selected ).slice(-3);
        for (var element in this.shopboxHtmlElements) {
            this.productCode[3] = this.shopboxHtmlElements[element]['validity'];
            current = this.productCode.join('-');
            try {
                price = sellbox[current][this.priceType] + " " + this.options.vat;
                if (this.shopboxHtmlElements[element]['type'] === 'orgPrice') {
                    this.shopboxHtmlElements[element].html(price);
                }
            } catch (e) {
                // todo: add new relic notification
            }

            try {
                wasPrice = sellbox[current][this.priceType] + " " + this.options.vat;
                if (this.shopboxHtmlElements[element]['type'] === 'wasPrice') {
                    if (price !== wasPrice) {
                        this.shopboxHtmlElements[element].removeClass('hidden');
                        this.shopboxHtmlElements[element].html(wasPrice);
                    } else {
                        this.shopboxHtmlElements[element].addClass('hidden');
                    }
                }
            } catch (e) {
                // todo: add new relic notification
            }
            try {
                if (this.shopboxHtmlElements[element]['type'] === 'percent') {
                    if (typeof sellbox[this.setProductCode(this.shopboxHtmlElements[element]['validity'])]['discountPercent'] !== 'undefined' && sellbox[this.setProductCode(this.shopboxHtmlElements[element]['validity'])]['discountPercent'] !== 0) {
                        this.shopboxHtmlElements[element].removeClass('hidden');
                        this.shopboxHtmlElements[element].html('&nbsp;-' + sellbox[this.setProductCode(this.shopboxHtmlElements[element]['validity'])]['discountPercent'] + '%&nbsp;');
                    } else {
                        this.shopboxHtmlElements[element].addClass('hidden');
                    }
                }
            } catch (e) {
                // todo: add new relic notification
            }
        }
    };
    // update button based on product code
    shopbox2.prototype.updateButton = function () {
        var newLink = "", externalRefID;
        if (this.businessDesign) {
            if ( this.sellbox[this.productCode.join('-')]['link'].indexOf('addtocart') !== -1 ) {
                newLink = this.sellbox[this.productCode.join('-')]['link'];
            } else {
                externalRefID = this.sellbox[this.setProductCode()]['link'].match(/externalRefID\.([^\/]+)/)[1].split('.');                
                newLink = this.button.attr('href').replace(/externalRefID[^\/]+/,
                    "externalRefID." + (externalRefID.length >= 4
                            ? (externalRefID[0] + "." + externalRefID[1] + "." + externalRefID[4])
                            : externalRefID.join('.')
                    ));                
            }
        } else {
            newLink = this.shopbox.find('input:checked').data('link');
        }
        if (typeof PriceUtil !== "undefined") {
            newLink = PriceUtil.fastAddToCartLink(newLink);
        }
        this.button.attr('href', newLink);
        $(document).trigger('drLinkChange');
    };
    shopbox2.prototype.hideDropdownOptions = function () {
        var visibleOptions = this.options.predefineComputers.replace(/ /g, '').split(',');
        this.dropdownOptions.each(function (index, element) {
            if (visibleOptions.indexOf($AVG(this).attr('data-value')) === -1) {
                $AVG(this).addClass('hidden');
            }
        });
    };

    shopbox2.prototype.updateDropdownSale = function () {
        var sellbox = this.sellbox;
        var compDesc = this.seats[this.selectedOption];        
        var current = this.productCode.join('-');
        var $this = this;
        if (typeof sellbox[current].discountPercent !== 'undefined' && sellbox[current].discountPercent !== 0) {
            this.shopbox.find('.rext .sval').html(compDesc + " (-" + sellbox[current].discountPercent + "%)");
        } else {
            this.shopbox.find('.rext .sval').html(compDesc);
        }
        this.dropdownOptions.each(function (index, element) {
            if (typeof sellbox[$this.setProductCode($AVG(this).attr('data-value'))] !== "undefined" && typeof sellbox[$this.setProductCode($AVG(this).attr('data-value'))]['discountPercent'] !== 'undefined') {
                $AVG(this).text($AVG(this).attr('data-text') + " (-" + sellbox[$this.setProductCode($AVG(this).attr('data-value'))]['discountPercent'] + "%)");
            } else {
                $AVG(this).html($AVG(this).attr('data-text'));
            }
        });
    };
    /**
     * Dropdown custom quantity option
     * @param {string} elm
     */
    shopbox2.prototype.updateQuantity = function (elm) {
        if (elm.match(/^[0-9]\d*$/)) {
            var inputValue = parseInt(elm);
            var computers = closestHigherNumber(this.keys, inputValue);
            this.selectedOption = inputValue;
            this.shopbox.find('.rext .val-' + computers).trigger('click');
            this.shopbox.find('.inputQuantity').addClass('hidden');
            this.shopbox.find('.rext').removeClass('hidden');
            if (inputValue !== computers) {
                this.errMessage.removeClass('hidden');
            }
        } else if (elm === "") {
            this.shopbox.find('.inputQuantity').addClass('hidden');
            this.shopbox.find('.rext').removeClass('hidden');
            this.shopbox.find('.rext .val-' + this.selectedOption).trigger('click');
        }
    };
    /**
     * Tracking for button
     */
    shopbox2.prototype.tracking = function () {
        var trackingCode,link;
        if(this.provider === "INHOUSE"){
            trackingCode = this.exterlnalRefID.split(".").slice(0, 5).join(".");
        } else {
            link = this.options.sellboxOptions ? this.sellbox[this.productCode.join('-')]['link'] : this.shopbox.find('input:checked').data('link');
            if( link.indexOf('addtocart') === -1 ){
                trackingCode = link.match(/externalRefID\.([^\/]+)/)[1].split(".").slice(0, 3).join(".");
            } else {
                trackingCode = link.match(/[a-z]{3}\.\d.*/g)[0].split(".").slice(0, 3).join(".");
            }
        }
        
        var trackingData = this.button.data('tracking');
        if (this.button.data('tracking').length > 1) {
            this.button.data('tracking', trackingData.replace(/'product':'.*?'/, "'product':'" + trackingCode + "'"));
            this.button.attr('data-tracking', trackingData.replace(/'product':'.*?'/, "'product':'" + trackingCode + "'"));
        }
    };
    /**
     * Update other shopboxes with same product code
     * @param {Object} shopbox
     * @param {Number} selectedValue
     */
    shopbox2.prototype.updateOtherShopbox = function (shopbox, selectedValue) {
        $AVG('.bshopbox2[data-product="' + this.options.productCode + '"]').not(shopbox).each(function (index) {
            // update selected dropdown text in other shopboxes
            var selectedOptionsText = $AVG(this).find('.rext .val-' + selectedValue).text();
            $AVG(this).find('.rext .sval').text(selectedOptionsText);
        });
    };
    /**
     * Update radio buttons and update product code
     * @param {Object} elm
     */
    shopbox2.prototype.updateRadio = function (value) {
        // update other shopbox inputs
        this.shopbox.find('input[value="' + value + '"]:visible').attr('checked', true).change();
    };
    /**
     * Set product code by seats or validity
     * @param {Object} elm
     */
    shopbox2.prototype.setProductCode = function () {
        // update other shopbox inputs        
        this.productCode[2] = ('000'+this.selectedOption).slice(-3);
        this.productCode[3] = this.selectedInputValue;        
        return this.productCode.join('-');
    };

    /**
     * set externalRefID from input value
     * @param {Object} elm
     */
    shopbox2.prototype.setExternalRefId = function (elm) {
        if (this.businessDesign) {
            this.exterlnalRefID = this.setProductCode(); 

        } else {
            this.exterlnalRefID = (this.provider === "INHOUSE" ?
                this.shopbox.find('input:checked').data('link').match(/[?&]addtocart=([^&]+)(&|$)/)[1] :
                this.shopbox.find('input:checked').data('link').match(/externalRefID\.([^\/]+)/)[1]);
        }
    };

    shopbox2.prototype.countdown = function () {
        if (this.options.changeCountdownValues) {
            this.shopbox.find('.subscription-wrapper').remove();
            this.shopbox.find('.subscription-wrapper-countdown').removeClass('hidden');
            if(this.shopbox.find('input[type=radio]:checked').length === 0){
                this.shopbox.find('input[type=radio]').first().attr('checked', true).change();
            }
            if (this.businessDesign) {
                if (typeof this.sellboxCountdown !== "undefined" && this.sellboxCountdown) {
                    this.sellbox = this.sellboxCountdown;
                    this.updateDropdownSale();
                    this.updatePrices(this.selectedOption);
                    this.updateRadio(this.shopbox.find('input:checked').val());
                }

                // change overlay title
                this.shopbox.parents('.container').find('.swo-overlay-title')
                    .html(this.shopbox.find('.overlayTitleCountdown').html());

                if (this.shopbox.find('.countdownButton').length > 0) {
                    var countdownButton = this.shopbox.find('.countdownButton');
                    this.button.html(countdownButton.html());
                    if (countdownButton.data('twolines')) {
                        this.button.addClass('two-lines');
                    } else {
                        this.button.removeClass('two-lines');
                    }
                }
            }
            this.updateButton();
        }
    };

    /**
     * Selected option dependecies
     * @param {String} elm radio value
     */
    shopbox2.prototype.radioChange = function (elm) {
        this.selectedInputValue = elm.val();
        this.updateRadio(elm.val());
        this.setExternalRefId(elm);
        if (this.businessDesign) {
            this.updateDropdownSale();
        }
        this.updateButton();
        this.tracking();
        if (this.businessDesign) {
            this.placeholders();
        }
    };

    /**
     * Selected option dependecies
     * @param {number} elmValue  Dropdown value
     */
    shopbox2.prototype.computersChange = function (elmValue) {
        if (elmValue === 'customComputers') {
            this.shopbox.find('.inputQuantity').removeClass('hidden');
            this.shopbox.find('.compQuantity').val("").focus();
            this.shopbox.find('.rext').addClass('hidden');
            this.shopbox.find('.validInfo').addClass('hidden');
        } else {
            var elmValueInt = parseInt(elmValue);
            this.selectedOption = elmValueInt;
            this.exterlnalRefID = this.sellbox[this.setProductCode()];
            this.errMessage.addClass('hidden');
            this.updateOtherShopbox(this.shopbox, this.options, elmValueInt);
            this.updatePrices(elmValueInt);
            this.updateButton();
            this.tracking();
        }
    };
    /**
     * Input validation to allow only numbers
     * @param {Object} elm
     * @param {Event} e
     */
    shopbox2.prototype.keyUPChange = function (elm, e) {
        elm.value = $AVG(elm).val().replace(/[^0-9]/g, '');
        if (elm.value.match(/^[0-9]\d*$/)) {
            $AVG(elm).next().removeClass('hidden');
        } else {
            $AVG(elm).next().addClass('hidden');
        }
        if (e.type === 'keyup' && e.keyCode === 10 || e.keyCode === 13) {
            $AVG(elm).blur();
        }
    };

    shopbox2.prototype.placeholders = function () {
        var price = "";
        var wasPrice = "";
        var saleSecondYear = "";
        var seats = "";
        var subscription = "";
        var current = this.productCode.join('-');
        try {

            price = this.sellbox[current][this.priceType] + " " + this.options.vat; //price-placeholder
            wasPrice = this.sellbox[current][this.priceListPriceType] + " " + this.options.vat; //was-price-placeholder
            saleSecondYear = this.sellbox[current]['discountPercent']; //sale-placeholder
            seats = this.seats[this.selectedOption]; //seats-placeholder
            subscription = this.shopbox.find('input:checked').data('text'); //subscription-placeholder
        } catch (e) {
            // todo: add new relic notification
        }
        this.shopboxWrapper.find('.price-placeholder').html(price);
        this.shopboxWrapper.find('.was-price-placeholder').html(wasPrice);
        this.shopboxWrapper.find('.discount-placeholder').html(saleSecondYear);
        this.shopboxWrapper.find('.seats-placeholder').html(seats.trim());
        this.shopboxWrapper.find('.subscription-placeholder').html(subscription);
    };


    // shopbox PLUGIN DEFINITION
    // =======================
    function Plugin(option, elm, event) {
        return this.each(function () {            
            var $this = $AVG(this);
            var data = $this.data('bs.shopbox-with-options');
            var options = $AVG.extend({}, $this.data(), typeof object == 'object' && option);
            if (!data)
                $this.data('bs.shopbox-with-options', (data = new shopbox2(this, options)));
            switch (option) {
                case 'init':
                    data.init();
                    break;
                case 'countdown':
                    data.countdown();
                    break;
                case 'update':
                    data.radioChange($AVG(elm));
                    break;
                case 'select':
                    data.computersChange($AVG(elm).val());
                    data.placeholders();
                    break;
                case 'customQuantity':
                    data.updateQuantity($AVG(elm).val());
                    break;
                case 'keyUP':
                    data.keyUPChange(elm, event);
                    break;
            }
        });
    }

    var old = $AVG.fn.shopbox2;
    $AVG.fn.shopbox2 = Plugin;
    $AVG.fn.shopbox2.Constructor = shopbox2;
    // shopbox NO CONFLICT
    // =====================
    $AVG.fn.shopbox2.noConflict = function () {
        $AVG.fn.shopbox2 = old;
        return this;
    };

    var clickHandler = function (e) {
        var parent = $AVG(this).parents('.bshopbox2');
        var action = $AVG(this).data('shopbox2');
        var productCode = parent.attr("data-product");
        Plugin.call($AVG('.bshopbox2[data-product="' + productCode + '"]'), action, this);
    };

    var selectHandler = function (e) {
        var parent = $AVG(this).parents('.bshopbox2');
        var productCode = parent.attr("data-product");
        Plugin.call($AVG('.bshopbox2[data-product="' + productCode + '"]'), 'select', this);
    };

    var readyHandler = function (e) {        
        var shopboxes = $AVG('.bshopbox2');
        if (shopboxes.length > 0) {            
            // check if is input already change by updateFormInputs()
            for (var i = 0, l = shopboxes.length; i < l; i++) {
                if (!$AVG(shopboxes[i]).find('.select.rext').length > 0) {
                    // add tracking data to customer design button
                    if ($AVG(shopboxes[i]).hasClass('consumer')) {
                        $AVG(shopboxes[i]).find('.button').attr('data-tracking', "'product',{'category':'HOME','product':''}");
                    } else{
                        var errMessage = $AVG(shopboxes[i]).parents('.bshopbox2-wrapper').find('.error-message');
                        errMessage.html(errMessage.text().replace('[SEATS]','<span class="seats-placeholder">&nbsp;</span>'));
                    }
                    // update dropdown on plural    
                    if( $AVG(shopboxes[i]).find('select option').length > 0 ){
                        var translationKey = $AVG(shopboxes[i]).data('translationkey');
                        var translationData = $AVG(shopboxes[i]).data('translationplural');
                        var originTranslation = $AVG(shopboxes[i]).data('defaulttranslation');
                        
                        $AVG(shopboxes[i]).find('select option').each(function (index, element) {
                            var optionVal = $AVG(this).val();
                            if( /\d+/.test(optionVal)){                                
                                $AVG(this).text( $AVG(this).text().replace( originTranslation, translation(translationKey, optionVal, translationData) ) );
                            }
                        });
                    }

                    $AVG(shopboxes[i]).updateFormInputs();
                }
            }
            // add data attributes for button parsys to trigger modal
            $AVG(".bshopbox2-wrapper .button-wrapper").each(function (index, element) {
                $AVG(this).find('a').attr('data-toggle', 'modal');
                $AVG(this).find('a').attr('data-target', '#' + $AVG(this).data('index'));
            });
            $AVG(".button-wrapper").on("click", "a", function (e) {
                e.preventDefault();
            });

            var els = '[data-shopbox2-comp]';
            Plugin.call($AVG(els), 'init');
            // If teaser is loaded after countdownFinish event call coundown function
            if ($AVG('#countdown[data-finish]').length > 0) {
                Plugin.call($AVG(els), 'countdown');
            }
        }
    };

    var countdown = function (e) {
        var els = '[data-shopbox2-comp]';
        Plugin.call($AVG(els), 'countdown');
    };

    var keyUpHandler = function (e) {
        var els = '[data-shopbox2-comp]';
        Plugin.call($AVG(els), 'keyUP', this, e);
    };

    $AVG(document)
        .on('change.bs.shopbox2.data-api', '[data-shopbox2-comp] select', selectHandler)
        .on('TestAndTargetInit teaserInit', readyHandler)
        .on('click.bs.shopbox2.data-api', '[data-shopbox2]:not([data-shopbox2="customQuantity"])', clickHandler)
        .on('blur.bs.shopbox2.data-api', '[data-shopbox2="customQuantity"]', clickHandler)
        .on('keyup.bs.shopbox2.data-api', '[data-shopbox2="customQuantity"]', keyUpHandler)
        .on('CountdownFinish', countdown)
        .ready(readyHandler);
}(jQuery);
var previousScroll = 0;

$AVG(window).scroll(function () {
    if ($AVG('.sliding-tabs-wrapper').length > 0) {
        var currentScroll = $AVG(this).scrollTop();

        if (currentScroll > previousScroll) {
            window.setTimeout(hideNav, 300);
        } else {
            window.setTimeout(showNav, 300);
        }
        previousScroll = currentScroll;

        if (isScrolledIntoView($AVG('.sliding-tabs-wrapper'), 'bottom'))
            addSticky();
        if (isScrolledIntoView($AVG('.sliding-tabs-wrapper'), 'top'))
            removeSticky();
    }

});

function hideNav() {
    $AVG("[data-nav-status='sticky-toggle']").removeClass("slide-in").addClass("slide-out");
}

function showNav() {
    $AVG("[data-nav-status='sticky-toggle']").removeClass("slide-out").addClass("slide-in");
}

function addSticky() {
    $AVG("[data-nav-status='sticky-toggle']").removeClass("sticky-disabled").addClass("sticky-enabled");
}

function removeSticky() {
    $AVG("[data-nav-status='sticky-toggle']").removeClass("sticky-enabled").addClass("sticky-disabled");
}

function isScrolledIntoView(elem, state) {
    var $elem = $AVG(elem);
    var $window = $AVG(window);

    var docViewTop = $window.scrollTop();

    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();

    if (state == 'top')
        return (elemTop >= docViewTop);
    if (state == 'bottom')
        return (elemBottom <= docViewTop);
}

function itemsSlideIn() {
    $AVG('.sliding-tabs ul').addClass('slide-from-right');
}

$AVG(document).ready(function () {
    // set height to hide scrollbar
    if ($AVG('.sliding-tabs').length > 0 && platformDetection() !== 'platform_pc') {
        $AVG('.sliding-tabs').each(function(){
            $AVG(this).find('.panel-body').css('padding-bottom','20px');
            $AVG(this).css('height',$AVG(this).outerHeight()-20);
        });
    }
    itemsSlideIn();

    $AVG('.sliding-tabs-hub .items').each(function() {
        var $item = $AVG(this);
        $item.removeClass('opened');
        $item.find('li:first-child').click(function() {
            $item.toggleClass('opened');
        })
    });
});
"use strict";
var SocialShare = {
    currentPage: encodeURIComponent(location.href),
    DATA_SOCIAL_NETWORKS: 'social-networks',
    DELIMETER_SOCIAL_NETWORKS: '|',
    SELECTOR_SHARE_COUNT: '.social-share .social',

    counts: {
        FB: false, // Facebook
        TW: false, // Twitter
        GP: false, // GooglePlus
        LI: false, // LinkedIn
    },

    init: function() {
        this.getUsedSocials();

        if(this.counts.FB === true) {
            this.getFacebookShareCounts();
        }
        if(this.counts.TW === true) {
            this.getTwitterShareCounts();
        }
        if(this.counts.GP === true) {
            this.getGooglePlusShareCounts();
        }
        if(this.counts.LI === true) {
            this.getLinkedInShareCounts();
        }
    },

    /**
     * Find which social networks are used on page for calculating sum of share counts
     */
    getUsedSocials: function() {
        $AVG('[data-' + this.DATA_SOCIAL_NETWORKS + ']').each(function() {
            var socials = $AVG(this).data(SocialShare.DATA_SOCIAL_NETWORKS).split(SocialShare.DELIMETER_SOCIAL_NETWORKS);
            var l = socials.length;

            for(var i = 0; i < l; i++) {
                SocialShare.counts[socials[i]] = true;
            }
        });
    },

    /**
     * Check whether the response data is correct number or not
     */
    validateCount: function(number, social) {
        if(!isNaN(parseInt(number))) {
            this.counts[social] = parseInt(number);
        }else {
            // todo: add new relic notification
        }
        this.setShareCounts();
    },

    /**
     * Loop through social share component instances and sets sum of share counts.
     * Unloaded social networks has TRUE value in counts object.
     */
    setShareCounts: function() {
        if(this.counts.FB === true || this.counts.TW === true ||
            this.counts.GP === true || this.counts.LI === true) {
            return;
        }

        // All social networks loaded
        $AVG(this.SELECTOR_SHARE_COUNT).each(function() {
            var socials = $AVG(this).data(SocialShare.DATA_SOCIAL_NETWORKS).split(SocialShare.DELIMETER_SOCIAL_NETWORKS);
            var sum = 0, l = socials.length;

            for(var i = 0; i < l; i++) {
                sum += SocialShare.counts[socials[i]];
            }

            if(parseInt($AVG(this).data('aggregate-number')) <= sum) {
                $AVG(this).find('.count-number').text(SocialShare.numberFormat(sum));
                $AVG(this).find('.share-counts').css('display', 'inline-block');
            }
        });
    },

    /**
     * Shorten number with appropriate abbreviation. 1_000_000 -> 1M, 10_000 -> 10k
     */
    numberFormat: function(number) {
        if(number >= Math.pow(10, 6)) {
            number = Math.round(number / Math.pow(10, 6)) + "M";
        } else if(number >= Math.pow(10, 4)) {
            number = Math.round(number / Math.pow(10, 3)) + "k";
        }

        return number;
    },

    getFacebookShareCounts: function() {
        $AVG.getJSON('//graph.facebook.com/fql?q=SELECT share_count FROM link_stat WHERE url="' + this.currentPage + '"', function (data) {
            try {
                SocialShare.validateCount(data.data[0].share_count, "FB");
            } catch(e) {
                // todo: add new relic notification
            }
        });
    },

    getTwitterShareCounts: function() {
        $AVG.getJSON('//opensharecount.com/count.json?url=' + SocialShare.currentPage, function(data) {
            try {
                SocialShare.validateCount(data.count, "TW");
            } catch(e) {
                // todo: add new relic notification
            }
        });
    },

    getGooglePlusShareCounts: function() {
        var data = {
            "method": "pos.plusones.get",
            "id": decodeURIComponent(SocialShare.currentPage),

            "params": {
                "nolog": true,
                "id": decodeURIComponent(SocialShare.currentPage),
                "source": "widget",
                "userId": "@viewer",
                "groupId": "@self",
            },

            "jsonrpc": "2.0",
            "key": "p",
            "apiVersion": "v1",
        };

        $AVG.ajax({
            type: "POST",
            url: "https://clients6.google.com/rpc",
            processData: true,
            contentType: "application/json",
            data: JSON.stringify(data),
            success: function(data){
                try {
                    SocialShare.validateCount(data.result.metadata.globalCounts.count, "GP");
                } catch(e) {
                    // todo: add new relic notification
                }
            }
        });
    },

    getLinkedInShareCounts: function() {
        $AVG.ajax({
            url: "https://www.linkedin.com/countserv/count/share",
            dataType: "jsonp",
            jsonpCallback: "social_share_linked_in_callback",
            data: {
                "url": decodeURIComponent(SocialShare.currentPage),
            },
            success: function(data){
                try {
                    SocialShare.validateCount(data.count, "LI");
                } catch(e) {
                    // todo: add new relic notification
                }
            },
        });
    },
};

$AVG(document).ready(function () {
    if($AVG('.social-share').length > 0){
        // Bind open dialog
        $AVG('.social-share .social-button').click(function(){
            window.open($AVG(this).attr('href') + '&t=' + encodeURIComponent(document.title), 'sharer', 'toolbar=0,status=0,width=626,height=436');
            return false;
        });

        if($AVG(SocialShare.SELECTOR_SHARE_COUNT).length > 0) {
            SocialShare.init();
        }
    }
});
+ function ($AVG) {
    'use strict';

    /**
     * @author Zden�k Mazanec
     * @version 1.0
     */

    // find and replace cart links to avoid http redirects
    function cartLinkReplace() {
        if (typeof PriceUtil !== 'undefined') {
            $AVG('main').find('a[href*="/cart"]').each(function () {
                var $link = $AVG(this);
                $link.attr('href', PriceUtil.fastAddToCartLink($link.attr('href')));
            });
        }
    }

    $AVG(document).ready(function () {
        cartLinkReplace();
    });

}(jQuery);

Header = window.Shopbox|| {};
Header.header = (function($, document) {
	var api = {};
	
	function slideImg(){
			
		var delay = 500;				
		var images = $AVG('.header-wrapper .banner-header-img').not('.callout');
		var callout = $AVG('.header-wrapper .callout');
				
		images.css( 'left' , '-=50px');	
		
		images.each(function( index ) {
			
			delay = (index == 0 ? 0 : delay);			
			
			$AVG(this).delay(delay).animate({
				'left': '+=50px',
				'opacity': '1.0'
			}, 400, 'swing');
			
			delay += 200;
		});
				
		callout.delay(500).animate({ 'opacity': '1.0' }, 300, 'swing'); 
			
		
	}	
	
	api.init = function() {
		$AVG(document).on({
			ready : function() {
					
				slideImg();								
			}			
		});
	};
	return api;
	
}($AVG, document));


Header.header.init();


function disableOptOutCookiesButton() {
    var $optOutButton = $AVG("a.opt_out_cookies_button");
    $optOutButton.addClass("disabled");
    var $textSection = $optOutButton.find("span.text");
    var $disabledTest = $textSection.data("opt-out-already-text");
    $textSection.html("<small>" + $disabledTest + "</small>");
}

$AVG(document).ready(function(){
    var value = "; " + document.cookie;
    var parts = value.split("; sat_track=");
    if (parts.length === 2) {
        if (parts.pop().split(";").shift() === "false") {
            disableOptOutCookiesButton();
        }
    }
});

$AVG("a.opt_out_cookies_button").click(function(event) {
    event.preventDefault();
    if (typeof s !== 'undefined' && typeof s.dataTrackingCallback !== 'undefined') {
        s.dataTrackingCallback('optOut');
    }   
    if (typeof deleteTrackingCookies === "function") {
        deleteTrackingCookies();
        disableOptOutCookiesButton();
    }
    if (typeof setDeclineCookie === "function") {
        setDeclineCookie();
    }
    $AVG("#avg-cookie-bar").slideUp('fast');
});

$AVG("a.opt_out_cookies_button_author").click(function(event) {
    event.preventDefault();
    alert("Function is disabled on author instance");
});

function deleteTrackingCookies() {
    var cookiesNamesWhitelist = ["AVGCookiePercentage","avg_eshop_cart","AVGSIDM","F5AVG","TSSID","avg_toolbar","avgualpw","avguareg","upl_ssid_c","geoip","spideroak","avg_eshop_cart_ubrowser","avg_eshop_ctysel","avg_myaccount","avg_eshop_chsel","avg_eshop_chsel_force","avg_eshop_chsel_force","avg_eshop_pattempts","avg_eshop_empty_cart_redir","avg_eshop_no_expiry_date","avg_eshop_bkpcd_","checkout_type_","avg_eshop_use_license_data","affid","forceGateway","rbsFail","gbcFail","TC_orderInfo_Fail","TC_getKeyRequest_Fail","checkout_type","autobilling_variant","debugbar","AVGSCHELPREQUEST","avgLocale","avg_plt","avg_thr","avg_mobile","SESSIONID","JSESSIONID","SessionPersistence-publish-prod","AParam","app-param-A","avg_app_params","avg_app_params2","SessionPersistence-publish","two_step_acc","AVGSurvey","avgLocale","PHPSESSID","s_zen"];
    var cookiesStubsWhitelist = ["AVGCSC","AVGRandom"];
    var cookies = document.cookie.split("; ");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var parts = cookie.split("=");
        var cookieName = parts[0];
        if (typeof cookieName !== "undefined") {
            var notFound = true;
            for (var j = 0; j < cookiesNamesWhitelist.length; j++) {
                if (cookiesNamesWhitelist[j] === cookieName) {
                    notFound = false;
                    break;
                }
            }
            if (notFound) {
                for (j = 0; j < cookiesStubsWhitelist.length; j++) {
                    if (cookieName.indexOf(cookiesStubsWhitelist[j]) == 0) {
                        notFound = false;
                        break;
                    }
                }
            }
            if (notFound) {
                if (document.domain.indexOf(".avg.com", document.domain.length - 8) !== -1) {
                    document.cookie = cookieName + "=; expires=Thu, 01-Jan-70 00:00:00 UTC; path=/; domain=.avg.com;";
                } else {
                    document.cookie = cookieName + "=; expires=Thu, 01-Jan-70 00:00:00 UTC; path=/;";
                }
            }
        }
    }
}

function setDeclineCookie() {
    var optOutCookies = ["sat_track:false"];
    var name = "sat_track";
    var value = "false";
    if (optOutCookies.length > 0) {
        var declineCookie = optOutCookies[0].split(":");
        name = declineCookie[0];
        if (declineCookie.length > 1) {
            value = declineCookie[1];
        } else {
            value = name;
        }
    }
    var cookieDate = new Date();
    cookieDate.setFullYear(cookieDate.getFullYear( ) + 2);
    if (document.domain.indexOf(".avg.com", document.domain.length - 8) !== -1) {
        document.cookie = name + "=" + value +"; expires=" + cookieDate.toUTCString() + "; path=/; domain=.avg.com;";
    } else {
        document.cookie = name + "=" + value +"; expires=" + cookieDate.toUTCString() + "; path=/;";
    }
}

(function checkOptOutCookies() {
    var value = "; " + document.cookie;
    var optOutCookies = ["sat_track:false"];
    for (var i = 0; i < optOutCookies.length; i++) {
        var cookie = optOutCookies[i].split(":");
        var parts = value.split("; "+ cookie[0] + "=");
        if (parts.length == 2) {
            var value = parts.pop().split(";").shift();
            if (typeof value  !== "undefined") {
                if (cookie.length > 1) {
                    if (value === cookie[1]) {
                        deleteTrackingCookies();
                        var cookieDate = new Date();
                        cookieDate.setFullYear(cookieDate.getFullYear() + 2);
                        if (document.domain.indexOf(".avg.com", document.domain.length - 8) !== -1) {
                            document.cookie = cookie[0] + "=" + value +"; expires=" + cookieDate.toUTCString() + "; path=/; domain=.avg.com;";
                        } else {
                            document.cookie = cookie[0] + "=" + value +"; expires=" + cookieDate.toUTCString() + "; path=/;";
                        }
                    }
                }
            }
        }
    }
}());
/**
 * @version 1.0
 * @author Michal Pribila
 */
+function ($AVG) {
    'use strict';

    // TEXT COMPONENT PUBLIC CLASS DEFINITION
    // ==============================

    var TextComponent = function (element, options) {
        this.$element = $AVG(element);
        this.options = $AVG.extend({}, options);
    };

    /**
     * Swap textComponent after countdown change
     * @param {Object} elm
     */
    TextComponent.prototype.countdown = function (elm) {
        $AVG(elm).css('display', 'none');
        $AVG('.countdownChange').css('display', 'block');
    };

    /*
     // TEXT COMPONENT PLUGIN DEFINITION
     // ========================
     */

    function Plugin(option) {
        return this.each(function () {
            var $this = $AVG(this);
            var data = $this.data('bs.textComponent');
            var options = $AVG.extend({}, $this.data());
            if (!data)
                $this.data('bs.textComponent', (data = new TextComponent(this, options)));

            if (option === 'countdown') {
                data.countdown($this);
            }
        });
    }

    var old = $AVG.fn.textComponent;

    $AVG.fn.textComponent = Plugin;
    $AVG.fn.textComponent.Constructor = TextComponent;


    // TEXT COMPONENT NO CONFLICT
    // ==================

    $AVG.fn.textComponent.noConflict = function () {
        $AVG.fn.textComponent = old;
        return this;
    };

    var countdown = function (e) {
        var els = '.defaultWithoutChange';
        Plugin.call($AVG(els), 'countdown');
    };

    $AVG(document).on('CountdownFinish', countdown);
    $AVG(document).on("TestAndTargetInit teaserInit", function () {
        // If teaser is loaded after countdownFinish event call coundown function
        if ($('#countdown[data-finish]').length > 0) {
            countdown();
        }
    });
}(jQuery);

/**
 * Zoomify
 * A jQuery plugin for simple lightboxes with zoom effect.
 * http://indrimuska.github.io/zoomify
 *
 * (c) 2015 Indri Muska - MIT
 */
;(function ($AVG) {

    // initialization
    function Zoomify(element, options) {
        var that = this;

        this._zooming = false;
        this._zoomed = false;
        this._timeout = null;
        this.$shadow = null;
        this.$image = $AVG(element).addClass('zoomify');
        this.$parent = this.$image.parents('.lightbox');
        this.options = $AVG.extend({}, Zoomify.DEFAULTS, this.$image.data(), options);
        this.$image.on('click', function (event) {            
            that.zoom();return false;
        });
        $AVG(window).on('resize', function () {
            that.reposition();
        });
        $AVG(document).on('scroll', function () {
            that.reposition();
        });
    }
    ;
    Zoomify.DEFAULTS = {
        duration: 200,
        easing: 'linear',
        scale: 0.9
    };

    // css utilities
    Zoomify.prototype.transition = function ($element, value) {
        $element.css({
            '-webkit-transition': value,
            '-moz-transition': value,
            '-ms-transition': value,
            '-o-transition': value,
            'transition': value
        });
    };
    Zoomify.prototype.addTransition = function ($element) {
        this.transition($element, 'all ' + this.options.duration + 'ms ' + this.options.easing);
    };
    Zoomify.prototype.removeTransition = function ($element, callback) {
        var that = this;

        clearTimeout(this._timeout);
        this._timeout = setTimeout(function () {
            that.transition($element, '');
            if ($AVG.isFunction(callback))
                callback.call(that);
        }, this.options.duration);
    };
    Zoomify.prototype.transform = function (value) {
        this.$image.css({
            '-webkit-transform': value,
            '-moz-transform': value,
            '-ms-transform': value,
            '-o-transform': value,
            'transform': value
        });
    };
    Zoomify.prototype.transformScaleAndTranslate = function (scale, translateX, translateY, callback) {
        this.addTransition(this.$image);
        this.transform('scale(' + scale + ') translate(' + translateX + 'px, ' + translateY + 'px)');
        this.removeTransition(this.$image, callback);
    };

    // zooming functions
    Zoomify.prototype.zoom = function () {
        if (this._zooming)
            return;

        if (this._zoomed)
            this.zoomOut();
        else
            this.zoomIn();
    };
    Zoomify.prototype.zoomIn = function () {
        var that = this,
                transform = this.$image.css('transform');

        this.transition(this.$image, 'none');
        this.transform('none');

        var offset = this.$image.offset(),
                width = this.$image.outerWidth(),
                height = this.$image.outerHeight(),
                nWidth = this.$image[0].naturalWidth || +Infinity,
                nHeight = this.$image[0].naturalHeight || +Infinity,
                wWidth = $AVG(window).width(),
                wHeight = $AVG(window).height(),
                scaleX = Math.min(nWidth, wWidth * this.options.scale) / width,
                scaleY = Math.min(nHeight, wHeight * this.options.scale) / height,
                scale = Math.min(scaleX, scaleY),
                translateX = (-offset.left + (wWidth - width) / 2) / scale,
                translateY = (-offset.top + (wHeight - height) / 2 + $AVG(document).scrollTop()) / scale;

        this.transform(transform);

        this._zooming = true;
        this.$image.addClass('zoomed').trigger('zoom-in.zoomify');	
        this.$parent.removeClass('lightbox-thumbnail');
        setTimeout(function () {
            that.addShadow();
            that.transformScaleAndTranslate(scale, translateX, translateY, function () {
                that._zooming = false;
                that.$image.trigger('zoom-in-complete.zoomify');
            });
            that._zoomed = true;
        });
    };
    Zoomify.prototype.zoomOut = function () {
        var that = this;

        this._zooming = true;
        this.$image.trigger('zoom-out.zoomify');
        this.transformScaleAndTranslate(1, 0, 0, function () {
            that._zooming = false;
            that.$image.removeClass('zoomed').trigger('zoom-out-complete.zoomify');
            this.$parent.addClass('lightbox-thumbnail');
        });
        this.removeShadow();
        this._zoomed = false;
    };

    // page listener callbacks
    Zoomify.prototype.reposition = function () {
        if (this._zoomed) {
            this.transition(this.$image, 'none');
            this.zoomIn();
        }
    };

    // shadow background
    Zoomify.prototype.addShadow = function () {
        var that = this;
        if (this._zoomed)
            return;

        if (that.$shadow)
            that.$shadow.remove();
        this.$shadow = $AVG('<div class="zoomify-shadow"></div>');
        $AVG('body').append(this.$shadow);
        this.addTransition(this.$shadow);
        this.$shadow.on('click', function () {
            that.zoomOut();
        });

        setTimeout(function () {
            that.$shadow.addClass('zoomed');
        }, 10);
    };
    Zoomify.prototype.removeShadow = function () {
        var that = this;
        if (!this.$shadow)
            return;

        this.addTransition(this.$shadow);
        this.$shadow.removeClass('zoomed');
        this.$image.one('zoom-out-complete.zoomify', function () {
            if (that.$shadow)
                that.$shadow.remove();
            that.$shadow = null;
        });
    };

    // plugin definition
    $AVG.fn.zoomify = function (option) {
        return this.each(function () {
            var $this = $AVG(this),
                    zoomify = $this.data('zoomify');
            if (!zoomify)
                $this.data('zoomify', (zoomify = new Zoomify(this, typeof option === 'object' && option)));
            if (typeof option === 'string' && ['zoom', 'zoomIn', 'zoomOut', 'reposition'].indexOf(option) >= 0)
                zoomify[option]();
        });
    };
    
    $AVG('.lightbox-thumbnail .zoom').zoomify();
    $AVG('.lightbox-thumbnail').on('click',function (event) {
        $AVG(this).find('.zoom').trigger('click');
        return false;
    });
})(jQuery);
(function() {
	'use strict';
	var unserializeUrl = avm.require('avast.url.unserialize'),
		encode = avm.require('avast.base64.encode'),
		path = window.location.href,
		URLparams = unserializeUrl(path),
		$document = $(document),
		$targetLinks = $('a[href*="shop.avg.com/store/avgstore"]'),	// link with old functionality
		$newTargetLinks = $('a[href*="shop.avg.com/store"]'); // link with new functionality

	if (typeof URLparams.test !== 'undefined') { /* @todo : This condition to be removed when approved in OO-9609 */

		$newTargetLinks.each(function() {
			removeAswParamFromLink($(this));
		});

		if (typeof URLparams.ppc !== 'undefined' && URLparams.ppc.length > 0) {

				$document.ready(function() {

					$targetLinks.each(function() {

						var $self = $(this),
							oldLink = $self.attr('href'),
							separator = oldLink.substring(oldLink.length - 1 ) === '/' ? '' : '/';

							$self.attr('href', oldLink + separator + 'ASWPARAM.' + encode({ppc: URLparams.ppc}));
					});
				});
		}
		// new aswparam functionality
	} else if (typeof URLparams.aswparam !== 'undefined' && URLparams.aswparam.length > 0) {

		$newTargetLinks.each(function() {
			setAswParamLink($(this), URLparams.aswparam, $(this).data('aswparam-placeholder'));
		});
	} else {
		$newTargetLinks.each(function() {
			removeAswParamFromLink($(this));
		});
	}

	function setAswParamLink(link, aswParamValue, aswParamPlaceholder) {

		var oldLink = link.attr('href');

		if(aswParamPlaceholder) {
			$(link).attr('href', oldLink.replace('{aswparam}', aswParamPlaceholder.replace('{ASWPARAM}', aswParamValue)));
		} else {
			removeAswParamFromLink(link);
		}
	}
	function removeAswParamFromLink(link) {
		var oldLink = link.attr('href');
		$(link).attr('href', oldLink.replace('{aswparam}', ''));
	}
})();

// affiliate aswparam from url parameters GLOWEB-7251
(function() {
    'use strict';

    try {
        // get parameters from url
        var urlParams = location.search.toLowerCase(),
            buylinks = document.querySelectorAll('[data-role="cart-link"]');

        // check if url contains some of the affiliate parameters
        if (/programtype|partnerid|clickid|trafficsource/.test(urlParams)) {

            var aswObj = {},
                aswparam = '';

            // put parameters from url to object
            //safari fix, remove when safari starts working
            //if (/partnerid=/.test(urlParams)) aswObj.partnerid = urlParams.match(/(?<=partnerid=).*?(?=&)|(?<=partnerid=).*?$/)[0];
            //if (/programtype=/.test(urlParams)) aswObj.programtype = urlParams.match(/(?<=programtype=).*?(?=&)|(?<=programtype=).*?$/)[0];
            //if (/clickid=/.test(urlParams)) aswObj.clickID = urlParams.match(/(?<=clickid=).*?(?=&)|(?<=clickid=).*?$/)[0];
            //if (/trafficsource=/.test(urlParams)) aswObj.trafficSource = urlParams.match(/(?<=trafficsource=).*?(?=&)|(?<=trafficsource=).*?$/)[0];
            if (/partnerid=/.test(urlParams)) {
                aswObj.partnerid = urlParams.match(/(?:partnerid=).*?(?=&)|(?:partnerid=).*?$/)[0].replace(/partnerid=/, '');
            }

            if (/programtype=/.test(urlParams)) {
                aswObj.programtype = urlParams.match(/(?:programtype=).*?(?=&)|(?:programtype=).*?$/)[0].replace(/programtype=/, '');
            }

            if (/clickid=/.test(urlParams)) {
                aswObj.clickID = urlParams.match(/(?:clickid=).*?(?=&)|(?:clickid=).*?$/)[0].replace(/clickid=/, '');
            }

            if (/trafficsource=/.test(urlParams)) {
                aswObj.trafficSource = urlParams.match(/(?:trafficsource=).*?(?=&)|(?:trafficsource=).*?$/)[0].replace(/trafficsource=/, '');
            }

            // encode object to base64
            aswparam = btoa(JSON.stringify(aswObj));

            if (!sessionStorage.getItem("aswparam")) {
                sessionStorage.setItem("aswparam", aswparam);
            }

            setAswparamOnButton(aswparam);

        } else if (sessionStorage.getItem("aswparam")) {
            setAswparamOnButton(sessionStorage.getItem("aswparam"));
        };

        function setAswparamOnButton(aswparam) {
            // check if there any buttons on page
            if (buylinks.length > 0) {

                // for each buy link update href
                buylinks.forEach(function(link) {
                    updateLink(link, aswparam)
                });
            };

            // event listener for change in actionbox
            window.addEventListener('actionbox-updated', function(e) {
                e.detail.element.querySelectorAll('[data-role="cart-link"]').forEach(function(link) {
                    updateLink(link, aswparam)
                });
            });

        }

        // check if link doesn't contain aswparam and add it
        function updateLink(link, aswparam) {
            if(!/aswparam/.test(link.href)) {
                link.href = link.href + '&aswparam=' + aswparam;
            };
        }

    } catch (error) {
        console.error(error);
        sdl.push({
            system: {
                error: {
                    type: error.name,
                    message: error.message,
                }
            },
            event: 'system.error'
        })
    }
}());

(function() {
	'use strict';
	var serializeUrl = avm.require('avast.url.serialize'),
		unserializeUrl = avm.require('avast.url.unserialize'),
		createLink = function(currentLink, param, value) {
			var newLink = currentLink.substring(0, currentLink.indexOf('?')),
				linkParams = unserializeUrl(currentLink);

			linkParams[param] = value;
			newLink += '?' + serializeUrl(linkParams);

			return newLink;
		},
		path = window.location.href,
		URLparams = unserializeUrl(path),
		$targetLinks = $('a[href*="product=freegsr"]');

	if (URLparams.ppc && path.indexOf('/ppc/') > -1) {
		if ( URLparams.ppc.match(/[A-Za-z0-9]/) && URLparams.ppc.length === 2) {
			$(document).ready(function() {
				$targetLinks.each(function(index) {
					var $self = $(this),
						selfLink = $self.attr('href'),
						value = URLparams.ppc;

					$self.attr('href', createLink(selfLink, 'ppc', value));
				});
			});
		}
	}
})();

(function() {
	'use strict';

	/**
	* Decorate cart link with showCuponeCode parameter
	* @version 1.0.0
	* @author Ales Gabriel
	* @module avast.web.cuponeCode
	* @requires jquery
	*/
	function couponCode() {
		return {
			options: {
				regexS: '[\\?&]couponfield=yes([^&#]*)',
				providers: ['shop.avg.com'],
				urlQuery: '/showCouponCode=yes'
			},

			init: function(params) {
				if (params !== undefined) {
					for (var param in params) {
						this.options[param] = params[param];
					}
				}

				var regex = new RegExp(this.options.regexS, 'i');
				var results = regex.exec(window.location.href);

				if (results === null) {
					return 1;
				} else {
					var href;
					var couponParam = this.options.urlQuery;
					var providers = this.options.providers;

					$('a').each(function() {
						href = $(this).attr('href') ? $(this).attr('href') : '';
						for (var i = 0; i < providers.length; i++) {
							if (href.indexOf(providers[i]) !== -1) {
								href += couponParam;
								$(this).attr('href', href);
							}
						}
					});
				}
			}
		};
	}

	couponCode().init();
})();

/**
 * Event emitter
 * @version 1.0.0
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.event.emitter
 * @return {Function}  Emitter constructor
 */
avm.define('avast.event.emitter', (function(){
	'use strict';

	/**
	 * Event emitter
	 * @version 1.2.1
	 * @see {@link https://github.com/component/emitter}
	 */

	/*
	(The MIT License)

	Copyright (c) 2014 Component contributors <dev@component.io>

	Permission is hereby granted, free of charge, to any person
	obtaining a copy of this software and associated documentation
	files (the "Software"), to deal in the Software without
	restriction, including without limitation the rights to use,
	copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the
	Software is furnished to do so, subject to the following
	conditions:

	The above copyright notice and this permission notice shall be
	included in all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
	OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
	HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
	WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	OTHER DEALINGS IN THE SOFTWARE.
	*/

	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */

	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};

	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */

	function mixin(obj) {
	  for (var key in Emitter.prototype) {
		obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}

	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
		.push(fn);
	  return this;
	};

	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.once = function(event, fn){
	  function on() {
		this.off(event, on);
		fn.apply(this, arguments);
	  }

	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};

	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};

	  // all
	  if (0 == arguments.length) {
		this._callbacks = {};
		return this;
	  }

	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;

	  // remove all handlers
	  if (1 == arguments.length) {
		delete this._callbacks['$' + event];
		return this;
	  }

	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
		cb = callbacks[i];
		if (cb === fn || cb.fn === fn) {
		  callbacks.splice(i, 1);
		  break;
		}
	  }
	  return this;
	};

	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */

	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
		, callbacks = this._callbacks['$' + event];

	  if (callbacks) {
		callbacks = callbacks.slice(0);
		for (var i = 0, len = callbacks.length; i < len; ++i) {
		  callbacks[i].apply(this, args);
		}
	  }

	  return this;
	};

	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */

	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};

	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */

	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};

	return Emitter;
})());

/**
 * Avast brcmpgid parameter
 * @version 1.0.0
 * @author Jaroslav Slaby <jaroslav.slaby@avast.com>
 * @module avast.web.brcmpgid
 * @requires avast.url.unserialize
 * @requires avast.web.linkDecorator
 * @copyright Avast Software s.r.o &copy;2021
 */

 (function() {
	'use strict';
	
	// check for brcmpgid parameter in url and if URLSearchParams method exists in browser
	if (/brcmpgid/.test(location.search) && 'URLSearchParams' in window) {
		var unserialize = avm.require('avast.url.unserialize'),
			qs = unserialize(),
			productId = 'SBR',
			valueTest = /^[a-z0-9]+$/i,
			SBRLinks = document.querySelectorAll('[data-download-name*="' + productId + '"]');

		SBRLinks.forEach(function(el) {
			try {
				var downloadURL,
					downloadQueryString;

				if(!/ANDROID|IOS/.test(el.getAttribute('data-download-name')) && qs && qs.brcmpgid && valueTest.test(qs.brcmpgid)) {
					if (el.href) {
						downloadURL = new URL(el.href);
						downloadQueryString = new URLSearchParams(downloadURL.search);

						downloadQueryString.set('product', (el.getAttribute('data-download-name') !== null ? el.getAttribute('data-download-name') : el.getAttribute('data-bi-download-name')) + '-CID');

						if (qs.brcmpgid !== undefined) {
							downloadQueryString.set('tag', qs.brcmpgid);
						}

						if (qs.source_tag !== undefined) {
							downloadQueryString.set('source_tag', qs.source_tag);
						}

						downloadURL.search = downloadQueryString.toString();
						el.href = downloadURL.toString();
					}
				}

			} catch (error) {
				// singe data layer error tracking
				if (typeof sdl !== 'undefined') {
					console.error(error);
					sdl.push({
						system: {
							error: {
								type: error.name,
								message: error.message,
							}
						},
						event: 'system.error'
					})
				}
			}
		})	
	}

	return;

})();

// unsupported chrome on older windows versions GLOWEB-7000

(function() {
    'use strict';

    try {
        var version = avastGlobals.detect.os.version;

        // check for windows version 7, 8, 8.1
        if(avastGlobals.detect.os.isWindows && (version === '7' || version === '8' || version === '8.1')) {

            // load tooltip script into page
            var script = document.createElement('script');
            script.src = document.querySelector('link[rel="stylesheet"]').href.split('/c/')[0]+'/j/lib/tooltip.js';
            document.body.appendChild(script);

            setTimeout(function()  {
                var buttons = document.querySelectorAll('[data-download-name*="SBR"]'),
                    stickyButton = document.querySelectorAll('.sticky-bar  [data-download-name*="SBR"]');

                stickyButton.forEach(function(button) {
                    button.setAttribute('data-placement', 'bottom');
                });

                // set tooltip on all download links contains SBR download ID
                buttons.forEach(function(button) {
                    setTooltipOnButton(button)
                });


                // event listener for change in actionbox and search if in updated content isn't link with SBR download ID
                window.addEventListener('actionbox-updated', function(e) {
                    e.detail.element.querySelectorAll('[data-download-name*="SBR"]:not([data-toggle])').forEach(function(button) {
                        setTooltipOnButton(button)
                    });
                });

                // event listener for opened modal and search if modal content contains not-updated link with SBR download ID
                window.addEventListener('modal-shown', function(e) {
                    e.detail.element.querySelectorAll('[data-download-name*="SBR"]:not([data-toggle])').forEach(function(button) {
                        setTooltipOnButton(button)
                    });
                });

                // set tooltip with information about unsupported system version on provided button
                function setTooltipOnButton(button) {
                    button.setAttribute('data-toggle', 'tooltip');
                    button.setAttribute('data-original-title', avastGlobals.texts.chromeUnsupportedOS);
                    $(button).tooltip()
                }
            }, 1000);

        }

    } catch (error) {
        console.error(error);
        sdl.push({
            system: {
                error: {
                    type: error.name,
                    message: error.message,
                }
            },
            event: 'system.error'
        })
    }

})();

/**
 * Avast CampaignMarker set from Google Optimize WYSIWYG editor
 * @version 1.0.0
 * @author Jaroslav Slaby <jaroslav.slaby@avast.com>
 * @module avast.web.campaignMarkerChange
 * @copyright Avast Software s.r.o &copy;2020
 */

avm.define('avast.campaignMarkerChange', function() {
	return {
		changeCM: function(abTest, testVariant) {
			avastGlobals.web.abtest = {
				'ticketNumber': abTest,
				'testVariant': testVariant
			}

			document.querySelectorAll('[data-role=cart-link]').forEach(function(el) {
				var dataCM = el.getAttribute('data-campaign-marker').split('~'),
					hrefCM = el.getAttribute('href').split('~');

				dataCM[3] = abTest;
				dataCM[4] = testVariant;
				hrefCM[3] = abTest;
				hrefCM[4] = testVariant;
				el.setAttribute('data-campaign-marker', dataCM.join('~'))
				el.setAttribute('href', hrefCM.join('~'))
			})
		}
	}
});

// GLOWEB-1762 AB test
(function() {
    // get parameters from url
    var urlParams = location.search.toLowerCase();
    var params = new URLSearchParams(window.location.search);
    var sourceVariantParams = params.get('sourceVariant');

    if (/sourcevariant/.test(urlParams)) {
        var buyButtons = document.querySelectorAll('[data-role="cart-link"]');
		
		sourceVariantParams = sourceVariantParams.replace(/[^\w\-]/g, ''); 

		buyButtons.forEach(function (button) {
			cmUpdate(button);
		})

        function cmUpdate(button) {
            var CMvalue = button.getAttribute('data-campaign-marker').split('~'),
				CMhref = button.getAttribute('href').split('~'),
				CMvariantParams = sourceVariantParams.split('-');

			CMvalue[3] = sourceVariantParams.substring(0, sourceVariantParams.lastIndexOf('-'));
            CMvalue[4] = CMvariantParams[CMvariantParams.length - 1].slice(-1);

			CMhref[3] = sourceVariantParams.substring(0, sourceVariantParams.lastIndexOf('-'));
			CMhref[4] = CMvariantParams[CMvariantParams.length - 1].slice(-1);

            button.setAttribute('data-campaign-marker', CMvalue.join('~'));
            button.setAttribute('href', CMhref.join('~'))
		}

		window.addEventListener('actionbox-updated', function(event) {
			var buttons = event.detail.element.querySelectorAll('[data-role="cart-link"]');

			buttons.forEach(function (button) {
				cmUpdate(button);
			});
		})
    }
})();

/**
 * Display Chrome Offer in non-chrome browsers
 * @version 1.2.0
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.web.chromeBanner
 * @requires jquery
 * @requires avast.url.unserialize
 * @requires avast.web.tracker
 */
avm.define('avast.web.chromeBanner', (function () {
	'use strict';

	var $ = avm.require('jquery');
	var detect = avastGlobals.detect;
	var urlParams = avm.require('avast.url.unserialize')();
	var tracker = avm.require('avast.web.tracker');
	var showException = urlParams.qp_sid === 'SV_d5wxMSvcStdiUgC' ? true : false; // exception for SBR survey

	// Chrome banner
	var chromeBanner = {
		init: function(){
			var hasBanner = $('#offer-chrome').length,
				isChrome = detect.browser.isChrome,
				isSbr = detect.browser.isAvast,
				product = (typeof urlParams.product === 'string') ? urlParams.product : '',
				isMsBuild = (product.indexOf('-ONLINE-MS') > -1) ? true : false;

			if(hasBanner){
				if(!isChrome && !isMsBuild && !isSbr){
					this.show();
					$('#offer-chrome').on('click', '.button', this.trackClick);
				}
			}
		},
		show: function(e){
			var url = document.location.href,
				pExt = url.match(/[?&]p_ext=([^&]*)/),
				pExtVal = pExt ? pExt[1].toLowerCase() : '';

			if (url.indexOf('?') > -1) {
				url = url.substr(0, url.indexOf("?"));
			}

			if(pExtVal.indexOf('chrome') == -1 && !showException && !/secure-browser/.test(url)){
				$('#offer-chrome').show();
				tracker.track('chromeOffer.view', e);
			}
		},
		trackClick: function(e){
			tracker.track('chromeOffer.click', e);
		}
	};

	return chromeBanner;

})());

(function() {
	'use strict';

	//
	//	FAQ accordion
	//
	var $faqTitle = $('.js-info-box .accordion-title');

	$faqTitle.on('click', function() {
		var $parent = $(this).parent(),
			expandClass = 'expand';


		// Close all other items
		$('.js-info-box').not($parent).removeClass(expandClass);

		// Toggle the 'expand' class on the clicked item's parent
		$parent.toggleClass(expandClass);
	});

})();

/**
 * Geoip detection for project Median
 */

 if (avastGlobals.web.locale === 'ms-my') {
    $.ajax({ url: 'geo-data'})
    .done(function(response) {
        var data = JSON.parse(response),
            comment = document.createComment(data.region);

        document.querySelector('body').prepend(comment);
    });
}

/**
 * Legal Modals
 * @version 1.0.0
 * @author Jaroslav Slaby <jaroslav.slaby@avast.com>
 * @requires jquery
 */

(function(){
    'use strict';
    var $ = avm.require('jquery'),
        buttons = $('.js-legal-modal-trigger[data-toggle="modal"]');

    buttons.on('click', function(){
        if ($($(this).attr('data-target')).length === 0) {
            var contentHolder = document.querySelector('#body-inner'),
                xhr = new XMLHttpRequest(),
                self = this;

            xhr.onreadystatechange = function() {
                if (this.readyState == 4 && this.status == 200) {

                    var container = document.createElement('div');

                    container.innerHTML = this.responseText;
                    contentHolder.append(container);
                    $($(self).attr('data-target')).modal('show');
                }
            };
            xhr.open("GET", 'https://' + avastGlobals.web.domain + '/' + avastGlobals.web.locale + '/' + $(this).attr('data-target').substring(1) + '?projectId[]=29965', true);
            xhr.setRequestHeader('x-requested-with', 'XMLHttpRequest');
            xhr.send(null);
        }
    })
})();

/**
 * Decorate link with params
 * @version 1.1.0
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.web.linkdecorator
 * @requires jquery
 * @requires avast.url.unserialize
 * @param {string} selector Css selector. Matched elements will be decorated
 * @param {(string|string[])} params Name or array of names
 * @param {string} [querystring] Optionally you can set querystring parameter manually. In this case querystring from URL will be ignored.
 * @param {string} [newValue] Optionally value can be set
 * @returns {object} jQuery object of selected elements
 */

avm.define('avast.web.linkDecorator', function(selector, params, querystring, newValue){
	'use strict';

	var $ = avm.require('jquery'),
		query = querystring ? querystring : undefined,
		unserialize = avm.require('avast.url.unserialize'),
		urlParams = unserialize(query),
		paramArr = (Object.prototype.toString.call(params) === '[object Array]') ? params : [params],
		param = null,
		$els = null,
		result = [];

	for (var i = 0; i < paramArr.length; i++ ) {
		param = paramArr[i];

		if(urlParams[param]){
			$els = $(selector).each(function () {
				var $el = $(this),
					prepend = this.search && this.search.length > 0 ? '&' : '?',
					hrefParams = unserialize($el.attr('href')),
					value = newValue || urlParams[param];

				if(!hrefParams[urlParams[param]]){
					$el.attr('href', $el.attr('href') + prepend + param + '=' + value );
				}
			});
			result.push($els)
		}
	}

	return result;
});
/**
 * Tracking for Mobile Campaigns
 * @version 1.0.0
 * @author Fedor Kušš <fedor.kuss@avast.com>
 * @module avg.web.mobileTracking
 * @requires jquery
 * @requires avg.url.unserialize
 */

(function() {
	'use strict';
	$(document).ready(function() {
		var urls = ['homepage', 'antivirus-for-android'],
			pathName = window.avastGlobals.web.fileName;

		if (urls.indexOf(pathName) > -1) {

			var unserializedUrl = avm.require('avast.url.unserialize')(),
				cmpgContent = unserializedUrl.cmpg_for_af;

			if (typeof cmpgContent !== 'undefined' && cmpgContent.length > 0) {

				var detected = avastGlobals.detect;

				if (detected.os.isAndroid) {
					$('body').addClass('mobile-tracking');
					var mobileTracking = $('.mobile-tracking .button.button-green');
					mobileTracking.attr('href', 'https://go.onelink.me/y9mF?pid=AdWords-Web&c=' + cmpgContent + '&af_web_dp=https%3A%2F%2F2.zoppoz.workers.dev%3A443%2Fhttps%2Fwww.avg.com%2Fantivirus-for-android');
				}

				if (detected.os.isAndroid || detected.os.isIOS) {
					if (pathName === 'lp-safe-emailing') {
						$('body').addClass('mobile-tracking');
						var mobileTracking = $('.mobile-tracking .button.button-green');
                        mobileTracking.attr('href', 'https://avg.sng.link/Djkjd/h6qa/giqs');
                    }
				}
			}
		}
	});
})();

// Notification overlay for wrong download
(function () {
	'use strict';

	var $ = avm.require('jquery'),
		detect = avastGlobals.detect,
		detectedPlatform = detect.os.name.toLowerCase(),
		$document = $(document),
		currentPageName = getCurrentPageName(),
		supportedPlatforms = ['windows', 'mac', 'android', 'ios'],
		config = window.avastGlobals && typeof window.avastGlobals.web !== 'undefined' && typeof window.avastGlobals.web['notification-overlay-for-wrong-download'] !== 'undefined' ? window.avastGlobals.web['notification-overlay-for-wrong-download'] : false,
		configCurrentPage = config[currentPageName];

	$document.ready(function () {
		if (checkIfApplyPopupLogicForCurrentPage()) {
			var $body = $('body'),
				$popup = $('.js-notification-overlay-for-wrong-download'),
				$popupButton = $popup.find('.js-popup-button'),
				$downloadButton = $(configCurrentPage['button-selector']),
				downloadButtonData = {
					'data-os': $downloadButton.attr('data-os') || configCurrentPage['supported-platform'],
					'data-download-name': $downloadButton.attr('data-download-name') || configCurrentPage['product-id'],
					'href': $downloadButton.attr('href') || null
				},
				$close = $popup.find('.js-close'),
				bodyOverflow = $body.css('overflow');

			// Dynamicly update button for particular page
			$popupButton.attr('data-os', downloadButtonData['data-os']);
			$popupButton.attr('data-download-name', downloadButtonData['data-download-name']);
			$popupButton.attr('href', downloadButtonData.href);

			$close.on('click', function () {
				$popup.removeClass('show-popup');
				window.location.hash = '!';
				$body.css('overflow', bodyOverflow);
				$body.removeAttr('data-oops-open');
			});

			$popup.on('click', function (event) {
				if ($(event.target).is($popup)) {
					$close.trigger('click');
				}
			});

			$downloadButton.on('click', function (event) {
				if (detectedPlatform !== configCurrentPage['supported-platform']) {
					event.preventDefault();
					event.stopPropagation();
					$popup.addClass('show-popup');
					$popup.addClass('detected-' + (supportedPlatforms.indexOf(detectedPlatform) === -1 ? 'unknown' : detectedPlatform));
					$popup.addClass('install-' + configCurrentPage['supported-platform']);
					window.location.hash = 'oops';
					$body.css('overflow', 'hidden');
					$body.attr('data-oops-open', 'true');

					if (typeof configCurrentPage['alternative-text'] !== 'undefined') {
						$popup.removeClass('no-alternative-text');
						$popup.addClass('alternative-text');
						$popup.addClass('alternative-text-' + configCurrentPage['alternative-text']);
					}
				}
			});

			updateInsteadLinks($popup);

			// If platform is known but alternative download is missing
			if (detectOthers($popup)) {
				$popup.addClass('detected-others');
			}
		}
	});

	// Checks whether current page name is listed in avastGlobals config. If not, skip popup logic
	function checkIfApplyPopupLogicForCurrentPage() {
		if (config) {
			// Check config if page is there
			for (var page in config) {
				if (page === currentPageName) {
					return true;
				}
			}
		}

		return false;
	}

	function getCurrentPageName() {
		var pathnameSplitted = window.location.pathname.split('/');
		return pathnameSplitted[pathnameSplitted.length - 1];
	}

	function updateInsteadLinks($popup) {
		var alternativeLinks = configCurrentPage['alternative-links'],
			alternativeTracking = configCurrentPage['alternative-tracking'],
			$targetLinks = $popup.find('.js-detected-' + detectedPlatform + '.js-install-' + configCurrentPage['supported-platform']).find('.js-instead-link'),
			customLabels = typeof customButtonLabels !== 'undefined' ? customButtonLabels : null,
			buttonBadges = typeof buttonBadgesLinks !== 'undefined' ? buttonBadgesLinks : null;

		if (typeof alternativeLinks !== 'undefined') {
			$targetLinks.attr('href', alternativeLinks[detectedPlatform]);
		}

		if (typeof alternativeTracking !== 'undefined') {
			$targetLinks.attr('data-download-name', alternativeTracking[detectedPlatform]);
		}

		$targetLinks.attr('data-os', detectedPlatform);

		if (buttonBadges && buttonBadges[detectedPlatform]) {
			$targetLinks.html('<img src="' + buttonBadges[detectedPlatform] + '" alt="" />');
		} else if (customLabels && customLabels[detectedPlatform]) {
			$targetLinks.html('<span class="text-large text-left">' + customLabels[detectedPlatform] + '</span>');
		}

		/*
			js-detected-windows
				js-install-mac
				js-install-android
				js-install-ios
			js-detected-mac
				js-install-windows
				js-install-android
				js-install-ios
			js-detected-android
				js-install-windows
				js-install-mac
				js-install-ios
		*/
	}

	// This function returns true if platform is known (Windows, Mac etc.), but there is no altertnative download
	function detectOthers($popup) {
		var _alternativeLinks = typeof configCurrentPage['alternative-links'] !== 'undefined' ? configCurrentPage['alternative-links'] : null;

		if (!$popup.hasClass('detected-unknown') && (_alternativeLinks === null || typeof _alternativeLinks[detectedPlatform] === 'undefined')) {
			return true;
		}

		return false;
	}


})();
// /Notification overlay for wrong download

/**
 * Avast Overlay Popup
 * @version 1.0.0
 * @author Michal Langhoffer <langhoffer@avast.com>
 * @module avast.web.overlayPopup
 * @requires jquery
 */
avm.define('avast.web.overlayPopup', function () {
    'use strict';
    var $ = avm.require('jquery'),
        $body = $('body'),
        $overlayBox = $('.overlay-box'),
        $overlayBoxTrigger = $('.overlay-box-trigger'),
        $overlayBoxContainerClose = $('.overlay-box-container .close');
        // Disabling scroll event when overlay active
    function overlayScrollDisable() {
        $body.on({
            'mousewheel': function (event) {
                if (event.target.id === 'el') {
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
            }
        });
        if (document.all && document.querySelector && !document.addEventListener) {
            $body.css('overflow', 'auto');
        } else {
            $body.css('overflow', 'hidden');
        }
    }
    // Window resize functions
    $(window).on('resize', function () {
        if ($('[class*="overlay-box"]').hasClass('is-visible')) {
            overlayScrollDisable();
        }
    });
    // scroll event disable when popup active
    $('[class*="overlay-box-trigger"]').on('click', function () {
        overlayScrollDisable();
    });
    $overlayBoxContainerClose.on('click', function () {
        $body.off('mousewheel');
        $body.css('overflow', 'auto');
    });

    //open popup
    $overlayBoxTrigger.on('click', function (event) {
        event.preventDefault();
        var _data = ($(this).attr('data-box'));
        $('.overlay-box[data-box*="' + _data + '"]').addClass('is-visible');
    });

    //close popup
    $overlayBox.on('click', function (event) {
        if ($(event.target).is('.close') || $(event.target).is('.overlay-box')) {
            event.preventDefault();
            $(this).removeClass('is-visible');
        }
    });
    //close popup when clicking the esc keyboard button
    $(document).on('keyup', function (event) {
        if (event.which === 27) {
            $overlayBox.removeClass('is-visible');
            $body.off('mousewheel');
            $body.css('overflow', 'auto');
        }
    });
});
/**
 * Avast Router
 * @version 1.0.1
 * @author Michal Langhoffer <langhoffer@avast.com>
 * @module avast.web.router
 * @requires jquery
 */
avm.define('avast.web.router', (function () {
	'use strict';
	var $ = avm.require('jquery'),
		routes,
		self,
		w = window,
		$window = $(window);

	return {
		/*
		 * add window hashchange listener
		 * look for key in routes object and execute its function
		 */
		hashChangeListener: function () {
			self = this;
			$window.on('hashchange', function () {
				self.exec(w.location.hash.substring(1));
			});
		},
		/*
		 * @param {string} [path]
		 * change hash in URL if it is not the same as current one, otherwise execute function from routes object
		 */
		navigate: function (path) {
			if (w.location.hash.substring(1) !== path) {
				w.location.hash = path;
			} else {
				this.exec(path);
			}
		},
		/* 
		 * @param {string} [path]
		 * execute function from routes object
		 */
		exec: function (path) {
			if (routes[path]) {
				routes[path]();
			} else {
				return;
			}
		},
		/*
		 * @param {object} [path]
		 * set the routes object
		 * add hashchange listener
		 * after page load check hash and execute function from routes object
		 * return routes object if path is object, otherwise throw error
		 */
		set: function (path) {
			routes = path;
			self = this;
			self.hashChangeListener();
			self.navigate(w.location.hash.substring(1));
			if (typeof path === 'object') {
				return routes;
			} else {
				throw new Error('Object has to be passed to router.set()');
			}
		}
	};
})());
// change link to RUBY LP for stand alone buy buttons
(function () {
    if (avastGlobals.web.locale === 'ru-ru') {
        var buyButtons = document.querySelectorAll('[data-role="cart-link"]');

        buyButtons.forEach(function(button) {
            updateButtonHref(button);
        });

        window.addEventListener('pricebox-updated', function() {
            document.querySelectorAll('[data-role="cart-link"]').forEach(function(button) {
                updateButtonHref(button);
            });
        });

        function updateButtonHref(button) {
            button.href = 'https://' + avastGlobals.web.domain + '/ru-ru/information-customers-russia-belarus';
        }
    } 
    
})()

/**
 * Factory for storage object
 * @version 1.1.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.storage.storageFactory
 * @returns {Object}
 */
avm.define('avast.storage.storageFactory', function() {
	'use strict';
	var hasOwnProperty = Object.prototype.hasOwnProperty,
		data = {};
	return {
		length: 0,

		/**
		 * Add key/value pair
		 * @param {*} key
		 * @param {*} value
		 */
		setItem: function(key, value) {
			if (typeof key !== 'undefined' && typeof value !== 'undefined') {
				key = encodeURIComponent(key);
				value = encodeURIComponent(value);
				if (!hasOwnProperty.call(data, key)) {
					this.length++;
				}
				data[key] = value;
			} else {
				throw new Error('Invalid method arguments to avast.storage.storageFactory.setItem');
			}
		},

		/**
		 * Get value associated with key
		 * @param {*} key
		 * @returns {string}
		 */
		getItem: function(key) {
			if (typeof key !== 'undefined') {
				key = encodeURIComponent(key);
				return typeof data[key] !== 'undefined' ? decodeURIComponent(data[key]) : null;
			} else {
				throw new Error('Invalid method arguments to avast.storage.storageFactory.getItem');
			}
		},

		/**
		 * Remove key/value pair
		 * @param {*} key
		 */
		removeItem: function(key) {
			if (typeof key !== 'undefined') {
				key = encodeURIComponent(key);
				if (hasOwnProperty.call(data, key)) {
					delete data[key];
					this.length--;
				}
			} else {
				throw new Error('Invalid method arguments to avast.storage.storageFactory.removeItem');
			}
		},

		/**
		 * Get name of nth key
		 * @param {number} n
		 * @returns {string}
		 */
		key: function(n) {
			if (typeof n === 'number') {
				var i = 0;
				for (var key in data) {
					if (hasOwnProperty.call(data, key)) {
						if (i === n) {
							return decodeURIComponent(key);
						} else {
							i++;
						}
					}
				}
				return null;
			} else {
				throw new Error('Invalid method arguments to avast.storage.storageFactory.key');
			}
		},

		/**
		 * Clear all items
		 */
		clear: function() {
			data = {};
			this.length = 0;
		}

	};
});

/**
 * Script for adding Structured data to document head tag
 * @version 1.0.0
 * @author Cenek Hybler <hybler@avast.com>
 * @requires jquery
 */

(function() {
	'use strict';
	var $ = avm.require('jquery'),
		$faq_holder = $('[data-structured-type="faq"]'),
		/* Function for JSON stringify and Script injection */
		jsonInjection = function(contextType, content){
			var el = document.createElement('script');
			var jsonIntro = {
					"@context": "http://schema.org",
					"@type": contextType
				},
				json = Object.assign(jsonIntro, content);

			el.type = 'application/ld+json';
			el.text = JSON.stringify(json);
			document.querySelector('head').appendChild(el);
		};

	$(document).ready(function(){
		//FAQ
		if ($faq_holder) {
			$faq_holder.each(function(){
				var contextType = 'FAQPage',
					$items = $(this).find('.accordion-item'),
					content = {},
					contentJson = [];

				$items.each(function() {
					contentJson.push({
						"@type": "Question",
						"name": this.querySelector('.accordion-title h4').innerText.replace(/\n/g,'').replace(/\t/g,''),
						"acceptedAnswer": {
							"@type": "Answer",
							"text": this.querySelector('.accordion-content').innerHTML.replace(/\n/g,'').replace(/\t/g,'')
						}
					})
				});
				content['mainEntity'] = contentJson;

				jsonInjection(contextType, content);
			});
		}
	});
})();

/**
 * Waypoints
 * @version 1.1.0
 * @author Michal Langhoffer <langhoffer@avast.com>
 * @module avast.web.waypoints
 * @requires jquery
 * @param {DOM element} $element
 * @param {Number} offsetTop
 * @param {Number} offsetBottom
 * @param {Boolean} waypoint
 * @returns {boolean}
 */
avm.define('avast.web.waypoints', function($element, offsetTop, offsetBottom, waypoint) {
	'use strict';
	var $ = avm.require('jquery'),
		elementTop = $element.offset().top,
		elementBottom = elementTop + $element.outerHeight(),
		viewportTop = $(window).scrollTop(),
		viewportBottom = viewportTop + $(window).height(),
		offsetTop = offsetTop ? offsetTop : 0,
		offsetBottom = offsetBottom ? offsetBottom : 0;

	if (waypoint) {
		if (viewportTop >= elementTop) {
			return true;
		} else {
			return false;
		}
	} else {
		if (offsetTop < 1 && offsetTop !== 0) {
			offsetTop = $element.outerHeight() * offsetTop;
		}

		if (offsetBottom < 1 && offsetBottom !== 0) {
			offsetBottom = $element.outerHeight() * offsetBottom;
		}

		return elementBottom - offsetBottom > viewportTop && elementTop + offsetTop < viewportBottom;
	}
});

(function () {
	'use strict';

	// Chrome banner
	var chromeBanner = avm.require('avast.web.chromeBanner');
	chromeBanner.init();
	return chromeBanner;

})();

(function() {
	'use strict';
	var unserializeUrl = avm.require('avast.url.unserialize'),
		decorate = avm.require('avast.web.linkDecorator'),
		path = window.location.href,
		URLparams = unserializeUrl(path),
		$document = $(document),
		$targetLinks = $('a[href*="download-thank-you.php"]');

	if (typeof URLparams.ppc !== 'undefined' && URLparams.ppc.length > 0) {
		if (path.indexOf('/ppc/performance') > -1 || path.indexOf('/ppc/tune') > -1 || path.indexOf('/avg-pctuneup') > -1) {
			$document.ready(function() {
				decorate($targetLinks, 'ppc');
			});
		}
	}
})();

/**
 * Wrapper for cookieStorage object
 * @version 1.1.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.storage.cookieStorage
 * @requires avast.storage.isCookieEnabled
 * @requires avast.storage.storageFactory
 */
avm.define('avast.storage.cookieStorage', (function() {
	'use strict';
	var isCookieEnabled = avm.require('avast.storage.isCookieEnabled'),
		storageFactory = avm.require('avast.storage.storageFactory'),
		toString = Object.prototype.toString,
		keys = function() {
			return document.cookie.replace(/((?:^|\s*;)[^=]+)(?=;|$)|^\s*|\s*(?:=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:=[^;]*)?;\s*/);
		},
		cookieStorage = {
			length: document.cookie !== '' ? keys().length : 0,

			/**
			 * Add key/value pair
			 * @param {*} key
			 * @param {*} value
			 * @param {string|date} [expires]
			 * @param {string} [path]
			 * @param {string} [domain]
			 * @param {boolean} [secure]
			 */
			setItem: function(key, value, expires, path, domain, secure) {
				if (typeof key !== 'undefined' && typeof value !== 'undefined') {
					var regExp = /^(?:expires|max\-age|path|domain|secure)$/i;
					key = encodeURIComponent(key);
					value = encodeURIComponent(value);
					if (key && !regExp.test(key)) {
						if (document.cookie.indexOf(key) === -1) {
							this.length++;
						}
						if (typeof expires === 'string') {
							expires = '; expires=' + expires;
						} else if (toString.call(expires) === '[object Date]') {
							expires = '; expires=' + expires.toUTCString();
						}
						document.cookie = key + '=' + value + (typeof expires === 'string' ? expires : '') + (typeof domain === 'string' ? '; domain=' + domain : '') + (typeof path === 'string' ? '; path=' + path : '') + (secure ? '; secure' : '');
					}
				} else {
					throw new Error('Invalid method arguments to avast.storage.cookieStorage.setItem');
				}
			},

			/**
			 * Get value associated with key
			 * @param {*} key
			 * @returns {string|null}
			 */
			getItem: function(key) {
				if (typeof key !== 'undefined') {
					var regExp = new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$');
					return decodeURIComponent(document.cookie.replace(regExp, '$1')) || null;
				} else {
					throw new Error('Invalid method arguments to avast.storage.cookieStorage.getItem');
				}
			},

			/**
			 * Remove key/value pair
			 * @param {*} key
			 * @param {string} [path]
			 * @param {string} [domain]
			 */
			removeItem: function(key, path, domain) {
				if (typeof key !== 'undefined') {
					key = encodeURIComponent(key);
					if (document.cookie.indexOf(key) !== -1) {
						this.length--;
					}
					document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + (typeof domain === 'string' ? '; domain=' + domain : '') + (typeof path === 'string' ? '; path=' + path : '');
				} else {
					throw new Error('Invalid method arguments to avast.storage.cookieStorage.removeItem');
				}
			},

			/**
			 * Get name of nth key
			 * @param {number} n
			 * @returns {string}
			 */
			key: function(n) {
				if (typeof n === 'number') {
					var keysArray = keys(),
						keysArrayLength = keysArray.length;
					if (n < keysArrayLength) {
						return decodeURIComponent(keysArray[n]);
					} else {
						return null;
					}
				} else {
					throw new Error('Invalid method arguments to avast.storage.cookieStorage.key');
				}
			},

			/**
			 * Clear all items
			 */
			clear: function() {
				var keysArray = keys(),
					keysArrayLength = keysArray.length;
				for (var i = 0; i < keysArrayLength; i++) {
					this.removeItem(keysArray[i]);
				}
				this.length = document.cookie !== '' ? keys().length : 0;
			}

		};
	return isCookieEnabled ? cookieStorage : storageFactory();
})());

// 30_optoutbar.js
(function() {
    'use strict';
    var $ = avm.require('jquery');

    $(document).ready(function() {
        var cookieStorage = avm.require('avast.storage.cookieStorage'),
            $cookieBar = $('.js-cookie-bar'),
            $cookieSubmitButton,
            cookieName,
            cookieDate,
            cookieNotFound;

        if ($cookieBar.length > 0) {
            $cookieSubmitButton = $cookieBar.find('.js-cookie-submit-button');
            cookieName = 'avgCookieConsentAccepted';
            cookieDate = new Date();
            cookieNotFound = cookieStorage.getItem(cookieName) === null;

            $cookieSubmitButton.on('click', function(event) {
                dataLayer.push({
                    'event': 'cookie-bar-consent-granted'
                });
                event.preventDefault();
                cookieDate.setFullYear(cookieDate.getFullYear() + 2); // set cookie date for 2 years from now
                $cookieBar.slideUp('fast');
                $(window).trigger('cookie-bar-closed'); // for navigation purposes
                cookieStorage.setItem(cookieName, true, cookieDate, '/', window.location.hostname, false);
            });

            if (cookieNotFound) {
                dataLayer.push({
                    'event': 'cookie-bar-displayed'
                });
                $cookieBar.removeClass('hidden');
            }
        }
    });
})();
// / 30_optoutbar.js
/**
 * Decorate Buy Links with Campaign Marker if Present in URL
 * @version 1.0.0
 * @author Fedor Kušš <fedor.kuss@avast.com>
 * @module avast.web.mobileTracking
 * @requires jquery
 * @requires avast.storage.cookieStorage
 * @requires avast.url.unserialize
 */

avm.define('avast.web.campaignMarkerDecorator', $(document).ready(function() {
	'use strict';
	var cookieStorage = avm.require('avast.storage.cookieStorage'),
		$cartLink = $('.bi-cart-link'),
		unserializedUrl = avm.require('avast.url.unserialize')(window.location.href),
		cmpgMarker = unserializedUrl.campaignMarker,
		trSrc = cookieStorage.getItem('__trSrc'),
		CMPGNMARKER = 'campaignMarker',

		getExpirationTime = function(minutes) {
			var now = new Date();
			now.setTime(now.getTime() + minutes * 60 * 1000);
			return now.toUTCString();
		};

	if (cmpgMarker && cmpgMarker.length > 0) {
		cookieStorage.setItem('campaignMarker', cmpgMarker, getExpirationTime(30), '/', location.hostname, false);
	}

	$cartLink.on('click', function() {
		// add tracing cookie into link if it missing
		trSrc !== null ? /~trSrcCookieValue/.test($(this).attr('href')) ? $(this).attr('href', $(this).attr('href').replace('~trSrcCookieValue', '~' + trSrc)) : '' : '';

		if (cookieStorage.getItem('campaignMarker') && cookieStorage.getItem('campaignMarker').length > 0)	{
			
			var link = $(this).attr('href'),
				isCampaignMarker = link.indexOf(CMPGNMARKER),
				updatedLink = [],
				campainMarker = cookieStorage.getItem(CMPGNMARKER);

			// if cartlink parameters in query param (avast)
			// else cartlink parameters in link (avast,avg)
			if (link.indexOf('?') >= 0) {
				var linkVariables1 = link.split(';');

				linkVariables1.forEach(function(item) {
					var params = item.split('=');
					if (params[0] === 'CampaignMarker') {
						updatedLink.push(params[0] + '=' + params[1].substring(0, params[1].length - 4) + '-' + campainMarker);
					} else {
						updatedLink.push(item);
					}
				});
				$(this).attr('href', updatedLink.join(';'));
			} else {
				var linkVariables = link.split('/');

				linkVariables.forEach(function(item) {
					var params = item.split('.');

					if (params[0] === CMPGNMARKER) {
						updatedLink.push(params[0] + '.' + params[1] + '-' + campainMarker);
					} else {
						updatedLink.push(item);
					}
					if (params[0] === 'Currency' && isCampaignMarker === -1) {
						updatedLink.push(CMPGNMARKER + '.' + campainMarker);
					}
				});

				$(this).attr('href', updatedLink.join('/'));
			}
		}
	});
}));

/**
 * Avast CampaignMarker (decorate cart links and update data attributes)
 * @version 0.0.4
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.web.campaignMarkerCookie
 * @requires module:avast.storage.cookieStorage
 * @copyright Avast Software s.r.o &copy;2020
 */

avm.define('avast.web.campaignMarkerCookie', function() {

	var cookieStorage = avm.require('avast.storage.cookieStorage');

	var cm = {
		cookie: '__trSrc',
		SMBCookeValue: cookieStorage.getItem('__smbChannelSrc'),
		els: document.querySelectorAll('a[data-campaign-marker]'),
		getCampaignMarkerCookie: function() {
			var result;

			try {
				// check if CM is set in avastGlobals
				if (avastGlobals.web.campaignMarker === undefined) {
					var cookieValue = cookieStorage.getItem('__trSrc');
					// check for old trSrc cookie
					if (cookieValue && encodeURIComponent) {
						cookieValue = encodeURIComponent(cookieValue);
						result = cookieValue;
						avastGlobals.web.campaignMarker = cookieValue;
					}
				} else {
					result = avastGlobals.web.campaignMarker;
				}

				return result;
			} catch (error) {
				console.error(error);
				sdl.push({
					system: {
						error: {
							type: error.name,
							message: error.message,
						}
					},
					event: 'system.error'
				})
			}
		},
		replaceCookieString: function(str, cookie) {
			var re = /~trSrcCookieValue/;

			return str.replace(re, '~' + cookie);
		},
		decorateCartLink: function(data) {
			var href,
				el = data.currentTarget,
				cookieValue = cm.getCampaignMarkerCookie() || '';

			if (el) {
				el.href = cm.replaceCookieString(el.href, cookieValue);
				href = el.href;
			}

			return href;
		},
		updateDataAttr: function(data) {
			var campaignMarker,
				el = data.currentTarget,
				cookieValue = cm.getCampaignMarkerCookie() || '';

			if (el.dataset && el.dataset.campaignMarker) {
				el.dataset.campaignMarker = cm.replaceCookieString(el.dataset.campaignMarker, cookieValue);
				campaignMarker = el.dataset.campaignMarker;
			}

			return campaignMarker;
		},

		/**
		 *
		 * @param {HTMLElement|NodeList} els List of elements
		 */

		setCampaignMarkerCookie: function(els) {

			var nodeList = els || cm.els,
				nodes = els instanceof HTMLElement ? [els] : Array.prototype.slice.call(nodeList),
				cookieValue = cm.getCampaignMarkerCookie(cm.cookie),
				SMBRegExp = /smbChannelSrcCookieValue-/,
				links = [];

			if (cookieValue) {
				nodes.forEach(function(el) {
					var result = {
						el: el
					};

					result.link = cm.decorateCartLink({
						currentTarget: el
					});
					result.dataAttr = cm.updateDataAttr({
						currentTarget: el
					});

					links.push(result);
				});
			} else {
				// Register mousedown event.
				// FIXME: Move to scanner on DOM ready.
				nodes.forEach(function(el) {
					el.addEventListener('mousedown', cm.decorateCartLink);
					el.addEventListener('mousedown', cm.updateDataAttr);
					el.addEventListener('focus', cm.decorateCartLink);
					el.addEventListener('focus', cm.updateDataAttr);

					links.push({
						el: el,
						evt: 'mousedown',
						callback: cm.decorateCartLink
					});
					links.push({
						el: el,
						evt: 'mousedown',
						callback: cm.updateDataAttr
					});
				});
			}

			nodes.forEach(function(el) {
				if (el.href.match(SMBRegExp) || el.getAttribute('data-campaign-marker').match(SMBRegExp)) {
					if (cm.SMBCookeValue !== null) {
						var cookieValue = cm.SMBCookeValue.slice(-1) === '-' ? cm.SMBCookeValue : cm.SMBCookeValue + '-';
						el.href = el.href.replace(SMBRegExp, cookieValue);
						el.dataset.campaignMarker = el.dataset.campaignMarker.replace(SMBRegExp, cookieValue);
					} else {
						el.href = el.href.replace(SMBRegExp, '');
						el.dataset.campaignMarker = el.dataset.campaignMarker.replace(SMBRegExp, '');
					}
				}
			})

			return links;
		}
	};

	return cm;

});


/**
 * Avast cartTrackingConsent (decorate cart links with query parram based on OptanonConsent cookie)
 * event delegation is used to capture all added buttons after the page load. In case of any performance issue it is possible to reconsider.
 * @version 3.0.0
 * @author Erik Ondrus <erik.ondrus@avast.com>, Fedor Kušš <fedor.kuss@gendigital.com>, Frankie Rapčák <Frantisek.Rapcak@gendigital.com>
 * @module avast.web.cartTrackingConsent
 * @requires module:avast.storage.cookieStorage
 * @requires avast.web.linkDecorator
 * @copyright Avast Software s.r.o &copy;2021
 */

avm.define('avast.web.cartTrackingConsent', function() {

	if (cheq.devMode) console.info('avast.web.cartTrackingConsent –––– 3.0.0');

	var cookieStorage = avm.require('avast.storage.cookieStorage'),
		linkDecorator = avm.require('avast.web.linkDecorator'),
		unserialize = avm.require && avm.require('avast.url.unserialize'),
		params = unserialize ? unserialize(window.location.href) : {};

	var cts = {
		COOKIE_NAME: 'OptanonConsent',
		COOKIE_REGEX_MATCH_GROUP: /groups=(.*?)(?=&|$)/i,
		PARAM_NAME: 'trackingDisabled',
		TARGET_EL: '[data-role="cart-link"]',
		TARGET_MATCH_ELS: '[data-role="cart-link"], [data-role="cart-link"] *',
		contentEl: document.getElementById('body-inner'),

		//
		//	🟩 Get Cookie consent from OneTrust cookie (named "OptanonConsent")
		//
		getCookieGroupValue: function() {
			if (cheq.devMode) console.info('🟩 OneTrust –––– cartTrackingConsent.cts.getCookieGroupValue()');

			var cookieValue = cookieStorage.getItem(cts.COOKIE_NAME) || '';
			var group = cookieValue.match(cts.COOKIE_REGEX_MATCH_GROUP) || '';
			return group[1] || '';
		},
		//
		//	🟪 Get Cookie consent from CHEQ JS API
		//
		getCookieConsentStatus__CHEQ: function() {
			if (cheq.devMode) console.info('🟪 CHEQ –––– cartTrackingConsent.cts.getCookieConsentStatus__CHEQ');

			var cheqCookieConsent = "marketing:0,performance:0,preference:0";

			// Default values = all cookies are disabled ( = user didn't allowed cookie)
			var cheqCookieCategoryStatus__marketing = 0;
			var cheqCookieCategoryStatus__performance = 0;
			var cheqCookieCategoryStatus__preference = 0;

			//
			//	Get current Cookie Consent status
			//
			if( Bootstrapper && Bootstrapper.gateway && typeof Bootstrapper.gateway.getConsentStatus === 'function' ) {
				cheqCookieCategoryStatus__marketing = Bootstrapper.gateway.getConsentStatus('Advertising').categoryEnabled ? 1 : 0;
				cheqCookieCategoryStatus__performance = Bootstrapper.gateway.getConsentStatus('Performance').categoryEnabled ? 1 : 0;
				cheqCookieCategoryStatus__preference = Bootstrapper.gateway.getConsentStatus('Preference').categoryEnabled ? 1 : 0;

				//
				//	Update URL parameter (CHEQ)
				//
				cheqCookieConsent = "marketing:" + cheqCookieCategoryStatus__marketing + ",performance:" + cheqCookieCategoryStatus__performance + ",preference:" + cheqCookieCategoryStatus__preference;
			}
			return cheqCookieConsent;
		},

		decorateCartLink: function(event) {
			var el = event.target;

			if (el.matches(cts.TARGET_MATCH_ELS)) {
				if (!el.href) {
					el = el.closest(cts.TARGET_EL);
				}

				//
				//	1. Define variables for storing Cookie consent
				//
				var cookieConsent__CHEQ = cts.getCookieConsentStatus__CHEQ();	// 🟪 CHEQ – Get Consent status from CHEQ JS API
				var cookieConsent = undefined;									// Final Cookie consent status to be passed to the Link Decorator
				//
				//	3. Store Cookie consent –––– Variant B: 🟪 CHEQ only
				//
				// 
				// Store the Consent
				cookieConsent = cookieConsent__CHEQ;	// EXAMPLE result: &trackingDisabled=marketing:1,performance:1,preference:1

				// DEV only – Check what consent will be attached on the "Buy now" buttons; To see the console.log, add    &cheqDevMode=true   to the URL
				if (cheq.devMode) {
					console.info('3. Store Cookie consent –––– Variant B: 🟪 CHEQ only');
					console.info('&trackingDisabled=' + cookieConsent);
				}

				//
				// 4. Add Cookie consent to the URL using parameters (&trackingDisabled=...)
				//
				if ('URLSearchParams' in window) {
					url = new URL(el.href);
					queryString = new URLSearchParams(url.search);
					queryString.set(cts.PARAM_NAME, cookieConsent);
					url.search = queryString.toString();
					el.href = url.toString();
				}
				//
				//	4. Fallback for very old browsers –––– IE 11 and below, Edge 15 & 16, Older Android WebView (< 49), Old Safari (< 10.3)
				//
				else {
					var regex = new RegExp('(&?)' + cts.PARAM_NAME + '=(.*?)(?=&|$)', 'gi');
					el.href = el.href.replace(regex, '');
					linkDecorator(el, cts.PARAM_NAME, cts.PARAM_NAME + '=null', encodeURIComponent(cookieConsent));
				}
			}
		},

		setCartTrackingConsent: function() {
			if (cts.contentEl) {
				cts.contentEl.addEventListener('focusin', cts.decorateCartLink);
				cts.contentEl.addEventListener('mousedown', cts.decorateCartLink);
			}
		}
	};

	return cts;
});

(function() {
	var cm = avm.require('avast.web.campaignMarkerCookie')();
	cm.setCampaignMarkerCookie();
})();

(function() {
	var cts = avm.require('avast.web.cartTrackingConsent')();
	cts.setCartTrackingConsent();
})();